var kt = Object.defineProperty;
var yt = (n, e, t) => e in n ? kt(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var r = (n, e, t) => (yt(n, typeof e != "symbol" ? e + "" : e, t), t);
var Fe = function(n, e) {
  return Fe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, i) {
    t.__proto__ = i;
  } || function(t, i) {
    for (var s in i)
      Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
  }, Fe(n, e);
};
function $(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Fe(n, e);
  function t() {
    this.constructor = n;
  }
  n.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var k = function() {
  return k = Object.assign || function(e) {
    for (var t, i = 1, s = arguments.length; i < s; i++) {
      t = arguments[i];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, k.apply(this, arguments);
};
function Me(n, e) {
  var t = {};
  for (var i in n)
    Object.prototype.hasOwnProperty.call(n, i) && e.indexOf(i) < 0 && (t[i] = n[i]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, i = Object.getOwnPropertySymbols(n); s < i.length; s++)
      e.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(n, i[s]) && (t[i[s]] = n[i[s]]);
  return t;
}
function v(n, e, t, i) {
  function s(o) {
    return o instanceof t ? o : new t(function(a) {
      a(o);
    });
  }
  return new (t || (t = Promise))(function(o, a) {
    function d(l) {
      try {
        c(i.next(l));
      } catch (p) {
        a(p);
      }
    }
    function u(l) {
      try {
        c(i.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      l.done ? o(l.value) : s(l.value).then(d, u);
    }
    c((i = i.apply(n, e || [])).next());
  });
}
function g(n, e) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, i, s, o, a;
  return a = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function d(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (t = 0)), t; )
      try {
        if (i = 1, s && (o = c[0] & 2 ? s.return : c[0] ? s.throw || ((o = s.return) && o.call(s), 0) : s.next) && !(o = o.call(s, c[1])).done)
          return o;
        switch (s = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return t.label++, { value: c[1], done: !1 };
          case 5:
            t.label++, s = c[1], c = [0];
            continue;
          case 7:
            c = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              t = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              t.label = c[1];
              break;
            }
            if (c[0] === 6 && t.label < o[1]) {
              t.label = o[1], o = c;
              break;
            }
            if (o && t.label < o[2]) {
              t.label = o[2], t.ops.push(c);
              break;
            }
            o[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        c = e.call(n, t);
      } catch (l) {
        c = [6, l], s = 0;
      } finally {
        i = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function ee(n) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && n[e], i = 0;
  if (t)
    return t.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && i >= n.length && (n = void 0), { value: n && n[i++], done: !n };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function D(n, e) {
  var t = typeof Symbol == "function" && n[Symbol.iterator];
  if (!t)
    return n;
  var i = t.call(n), s, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(s = i.next()).done; )
      o.push(s.value);
  } catch (d) {
    a = { error: d };
  } finally {
    try {
      s && !s.done && (t = i.return) && t.call(i);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
function W(n, e, t) {
  if (t || arguments.length === 2)
    for (var i = 0, s = e.length, o; i < s; i++)
      (o || !(i in e)) && (o || (o = Array.prototype.slice.call(e, 0, i)), o[i] = e[i]);
  return n.concat(o || Array.prototype.slice.call(e));
}
var mt = "Event tracked successfully", _t = "Unexpected error occurred", wt = "Event rejected due to exceeded retry count", St = "Event skipped due to optOut config", bt = "Event rejected due to missing API key", It = "Invalid API key", At = "Client not initialized", R;
(function(n) {
  n.SET = "$set", n.SET_ONCE = "$setOnce", n.ADD = "$add", n.APPEND = "$append", n.PREPEND = "$prepend", n.REMOVE = "$remove", n.PREINSERT = "$preInsert", n.POSTINSERT = "$postInsert", n.UNSET = "$unset", n.CLEAR_ALL = "$clearAll";
})(R || (R = {}));
var j;
(function(n) {
  n.REVENUE_PRODUCT_ID = "$productId", n.REVENUE_QUANTITY = "$quantity", n.REVENUE_PRICE = "$price", n.REVENUE_TYPE = "$revenueType", n.REVENUE = "$revenue";
})(j || (j = {}));
var J;
(function(n) {
  n.IDENTIFY = "$identify", n.GROUP_IDENTIFY = "$groupidentify", n.REVENUE = "revenue_amount";
})(J || (J = {}));
var B;
(function(n) {
  n[n.None = 0] = "None", n[n.Error = 1] = "Error", n[n.Warn = 2] = "Warn", n[n.Verbose = 3] = "Verbose", n[n.Debug = 4] = "Debug";
})(B || (B = {}));
var F;
(function(n) {
  n.Unknown = "unknown", n.Skipped = "skipped", n.Success = "success", n.RateLimit = "rate_limit", n.PayloadTooLarge = "payload_too_large", n.Invalid = "invalid", n.Failed = "failed", n.Timeout = "Timeout", n.SystemError = "SystemError";
})(F || (F = {}));
var Ot = null, X = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = F.Unknown), { event: n, code: e, message: t };
}, ae = function(n) {
  return n ? (
    // a random number from 0 to 15
    (n ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    n / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      ae
    )
  );
}, Tt = (
  /** @class */
  function() {
    function n(e) {
      this.client = e, this.queue = [], this.applying = !1, this.plugins = [];
    }
    return n.prototype.register = function(e, t) {
      var i, s, o;
      return v(this, void 0, void 0, function() {
        return g(this, function(a) {
          switch (a.label) {
            case 0:
              return e.name = (i = e.name) !== null && i !== void 0 ? i : ae(), e.type = (s = e.type) !== null && s !== void 0 ? s : "enrichment", [4, (o = e.setup) === null || o === void 0 ? void 0 : o.call(e, t, this.client)];
            case 1:
              return a.sent(), this.plugins.push(e), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.deregister = function(e) {
      var t;
      return v(this, void 0, void 0, function() {
        var i, s;
        return g(this, function(o) {
          switch (o.label) {
            case 0:
              return i = this.plugins.findIndex(function(a) {
                return a.name === e;
              }), s = this.plugins[i], this.plugins.splice(i, 1), [4, (t = s.teardown) === null || t === void 0 ? void 0 : t.call(s)];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.reset = function(e) {
      this.applying = !1;
      var t = this.plugins;
      t.map(function(i) {
        var s;
        return (s = i.teardown) === null || s === void 0 ? void 0 : s.call(i);
      }), this.plugins = [], this.client = e;
    }, n.prototype.push = function(e) {
      var t = this;
      return new Promise(function(i) {
        t.queue.push([e, i]), t.scheduleApply(0);
      });
    }, n.prototype.scheduleApply = function(e) {
      var t = this;
      this.applying || (this.applying = !0, setTimeout(function() {
        t.apply(t.queue.shift()).then(function() {
          t.applying = !1, t.queue.length > 0 && t.scheduleApply(0);
        });
      }, e));
    }, n.prototype.apply = function(e) {
      return v(this, void 0, void 0, function() {
        var t, i, s, o, a, d, u, y, C, c, l, p, h, y, C, _, f, w, M, S, P, H;
        return g(this, function(b) {
          switch (b.label) {
            case 0:
              if (!e)
                return [
                  2
                  /*return*/
                ];
              t = D(e, 1), i = t[0], s = D(e, 2), o = s[1], a = this.plugins.filter(function(I) {
                return I.type === "before";
              }), b.label = 1;
            case 1:
              b.trys.push([1, 6, 7, 8]), d = ee(a), u = d.next(), b.label = 2;
            case 2:
              return u.done ? [3, 5] : (y = u.value, y.execute ? [4, y.execute(k({}, i))] : [3, 4]);
            case 3:
              if (C = b.sent(), C === null)
                return o({ event: i, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              i = C, b.label = 4;
            case 4:
              return u = d.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return c = b.sent(), M = { error: c }, [3, 8];
            case 7:
              try {
                u && !u.done && (S = d.return) && S.call(d);
              } finally {
                if (M)
                  throw M.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              l = this.plugins.filter(function(I) {
                return I.type === "enrichment" || I.type === void 0;
              }), b.label = 9;
            case 9:
              b.trys.push([9, 14, 15, 16]), p = ee(l), h = p.next(), b.label = 10;
            case 10:
              return h.done ? [3, 13] : (y = h.value, y.execute ? [4, y.execute(k({}, i))] : [3, 12]);
            case 11:
              if (C = b.sent(), C === null)
                return o({ event: i, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              i = C, b.label = 12;
            case 12:
              return h = p.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return _ = b.sent(), P = { error: _ }, [3, 16];
            case 15:
              try {
                h && !h.done && (H = p.return) && H.call(p);
              } finally {
                if (P)
                  throw P.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return f = this.plugins.filter(function(I) {
                return I.type === "destination";
              }), w = f.map(function(I) {
                var E = k({}, i);
                return I.execute(E).catch(function(U) {
                  return X(E, 0, String(U));
                });
              }), Promise.all(w).then(function(I) {
                var E = D(I, 1), U = E[0], V = U || X(i, 100, "Event not tracked, no destination plugins on the instance");
                o(V);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.flush = function() {
      return v(this, void 0, void 0, function() {
        var e, t, i, s = this;
        return g(this, function(o) {
          switch (o.label) {
            case 0:
              return e = this.queue, this.queue = [], [4, Promise.all(e.map(function(a) {
                return s.apply(a);
              }))];
            case 1:
              return o.sent(), t = this.plugins.filter(function(a) {
                return a.type === "destination";
              }), i = t.map(function(a) {
                return a.flush && a.flush();
              }), [4, Promise.all(i)];
            case 2:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n;
  }()
), Le = "-", ge = "AMP", Pt = "".concat(ge, "_unsent"), rt = "https://api2.amplitude.com/2/httpapi", Et = "https://api.eu.amplitude.com/2/httpapi", Ft = "https://api2.amplitude.com/batch", Mt = "https://api.eu.amplitude.com/batch", Rt = 1e3, Re = function(n) {
  if (Object.keys(n).length > Rt)
    return !1;
  for (var e in n) {
    var t = n[e];
    if (!it(e, t))
      return !1;
  }
  return !0;
}, it = function(n, e) {
  var t, i;
  if (typeof n != "string")
    return !1;
  if (Array.isArray(e)) {
    var s = !0;
    try {
      for (var o = ee(e), a = o.next(); !a.done; a = o.next()) {
        var d = a.value;
        if (Array.isArray(d))
          return !1;
        if (typeof d == "object")
          s = s && Re(d);
        else if (!["number", "string"].includes(typeof d))
          return !1;
        if (!s)
          return !1;
      }
    } catch (u) {
      t = { error: u };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (t)
          throw t.error;
      }
    }
  } else {
    if (e == null)
      return !1;
    if (typeof e == "object")
      return Re(e);
    if (!["number", "string", "boolean"].includes(typeof e))
      return !1;
  }
  return !0;
}, te = (
  /** @class */
  function() {
    function n() {
      this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
    }
    return n.prototype.getUserProperties = function() {
      return k({}, this._properties);
    }, n.prototype.set = function(e, t) {
      return this._safeSet(R.SET, e, t), this;
    }, n.prototype.setOnce = function(e, t) {
      return this._safeSet(R.SET_ONCE, e, t), this;
    }, n.prototype.append = function(e, t) {
      return this._safeSet(R.APPEND, e, t), this;
    }, n.prototype.prepend = function(e, t) {
      return this._safeSet(R.PREPEND, e, t), this;
    }, n.prototype.postInsert = function(e, t) {
      return this._safeSet(R.POSTINSERT, e, t), this;
    }, n.prototype.preInsert = function(e, t) {
      return this._safeSet(R.PREINSERT, e, t), this;
    }, n.prototype.remove = function(e, t) {
      return this._safeSet(R.REMOVE, e, t), this;
    }, n.prototype.add = function(e, t) {
      return this._safeSet(R.ADD, e, t), this;
    }, n.prototype.unset = function(e) {
      return this._safeSet(R.UNSET, e, Le), this;
    }, n.prototype.clearAll = function() {
      return this._properties = {}, this._properties[R.CLEAR_ALL] = Le, this;
    }, n.prototype._safeSet = function(e, t, i) {
      if (this._validate(e, t, i)) {
        var s = this._properties[e];
        return s === void 0 && (s = {}, this._properties[e] = s), s[t] = i, this._propertySet.add(t), !0;
      }
      return !1;
    }, n.prototype._validate = function(e, t, i) {
      return this._properties[R.CLEAR_ALL] !== void 0 || this._propertySet.has(t) ? !1 : e === R.ADD ? typeof i == "number" : e !== R.UNSET && e !== R.REMOVE ? it(t, i) : !0;
    }, n;
  }()
), Dt = function(n, e, t) {
  var i = typeof n == "string" ? { event_type: n } : n;
  return k(k(k({}, i), t), e && { event_properties: e });
}, st = function(n, e) {
  var t = k(k({}, e), { event_type: J.IDENTIFY, user_properties: n.getUserProperties() });
  return t;
}, Ut = function(n, e, t, i) {
  var s, o = k(k({}, i), { event_type: J.GROUP_IDENTIFY, group_properties: t.getUserProperties(), groups: (s = {}, s[n] = e, s) });
  return o;
}, Ht = function(n, e, t) {
  var i, s = new te();
  s.set(n, e);
  var o = k(k({}, t), { event_type: J.IDENTIFY, user_properties: s.getUserProperties(), groups: (i = {}, i[n] = e, i) });
  return o;
}, Bt = function(n, e) {
  return k(k({}, e), { event_type: J.REVENUE, event_properties: n.getEventProperties() });
}, L = function(n) {
  return {
    promise: n || Promise.resolve()
  };
}, Lt = (
  /** @class */
  function() {
    function n(e) {
      e === void 0 && (e = "$default"), this.initializing = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new Tt(this), this.name = e;
    }
    return n.prototype._init = function(e) {
      return v(this, void 0, void 0, function() {
        return g(this, function(t) {
          switch (t.label) {
            case 0:
              return this.config = e, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.runQueuedFunctions = function(e) {
      return v(this, void 0, void 0, function() {
        var t, i, s, o, a, d, u;
        return g(this, function(c) {
          switch (c.label) {
            case 0:
              t = this[e], this[e] = [], c.label = 1;
            case 1:
              c.trys.push([1, 6, 7, 8]), i = ee(t), s = i.next(), c.label = 2;
            case 2:
              return s.done ? [3, 5] : (o = s.value, [4, o()]);
            case 3:
              c.sent(), c.label = 4;
            case 4:
              return s = i.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return a = c.sent(), d = { error: a }, [3, 8];
            case 7:
              try {
                s && !s.done && (u = i.return) && u.call(i);
              } finally {
                if (d)
                  throw d.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.track = function(e, t, i) {
      var s = Dt(e, t, i);
      return L(this.dispatch(s));
    }, n.prototype.identify = function(e, t) {
      var i = st(e, t);
      return L(this.dispatch(i));
    }, n.prototype.groupIdentify = function(e, t, i, s) {
      var o = Ut(e, t, i, s);
      return L(this.dispatch(o));
    }, n.prototype.setGroup = function(e, t, i) {
      var s = Ht(e, t, i);
      return L(this.dispatch(s));
    }, n.prototype.revenue = function(e, t) {
      var i = Bt(e, t);
      return L(this.dispatch(i));
    }, n.prototype.add = function(e) {
      return this.config ? L(this.timeline.register(e, this.config)) : (this.q.push(this.add.bind(this, e)), L());
    }, n.prototype.remove = function(e) {
      return this.config ? L(this.timeline.deregister(e)) : (this.q.push(this.remove.bind(this, e)), L());
    }, n.prototype.dispatchWithCallback = function(e, t) {
      if (!this.config)
        return t(X(e, 0, At));
      this.process(e).then(t);
    }, n.prototype.dispatch = function(e) {
      return v(this, void 0, void 0, function() {
        var t = this;
        return g(this, function(i) {
          return this.config ? [2, this.process(e)] : [2, new Promise(function(s) {
            t.dispatchQ.push(t.dispatchWithCallback.bind(t, e, s));
          })];
        });
      });
    }, n.prototype.process = function(e) {
      return v(this, void 0, void 0, function() {
        var s, t, i, s;
        return g(this, function(o) {
          switch (o.label) {
            case 0:
              return o.trys.push([0, 2, , 3]), this.config.optOut ? [2, X(e, 0, St)] : [4, this.timeline.push(e)];
            case 1:
              return s = o.sent(), s.code === 200 ? this.config.loggerProvider.log(s.message) : s.code === 100 ? this.config.loggerProvider.warn(s.message) : this.config.loggerProvider.error(s.message), [2, s];
            case 2:
              return t = o.sent(), i = String(t), this.config.loggerProvider.error(i), s = X(e, 0, i), [2, s];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.setOptOut = function(e) {
      if (!this.config) {
        this.q.push(this.setOptOut.bind(this, !!e));
        return;
      }
      this.config.optOut = !!e;
    }, n.prototype.flush = function() {
      return L(this.timeline.flush());
    }, n;
  }()
), Nt = (
  /** @class */
  function() {
    function n() {
      this.productId = "", this.quantity = 1, this.price = 0;
    }
    return n.prototype.setProductId = function(e) {
      return this.productId = e, this;
    }, n.prototype.setQuantity = function(e) {
      return e > 0 && (this.quantity = e), this;
    }, n.prototype.setPrice = function(e) {
      return this.price = e, this;
    }, n.prototype.setRevenueType = function(e) {
      return this.revenueType = e, this;
    }, n.prototype.setRevenue = function(e) {
      return this.revenue = e, this;
    }, n.prototype.setEventProperties = function(e) {
      return Re(e) && (this.properties = e), this;
    }, n.prototype.getEventProperties = function() {
      var e = this.properties ? k({}, this.properties) : {};
      return e[j.REVENUE_PRODUCT_ID] = this.productId, e[j.REVENUE_QUANTITY] = this.quantity, e[j.REVENUE_PRICE] = this.price, e[j.REVENUE_TYPE] = this.revenueType, e[j.REVENUE] = this.revenue, e;
    }, n;
  }()
), Wt = function(n, e) {
  var t = Math.max(e, 1);
  return n.reduce(function(i, s, o) {
    var a = Math.floor(o / t);
    return i[a] || (i[a] = []), i[a].push(s), i;
  }, []);
}, ue = "Amplitude Logger ", ot = (
  /** @class */
  function() {
    function n() {
      this.logLevel = B.None;
    }
    return n.prototype.disable = function() {
      this.logLevel = B.None;
    }, n.prototype.enable = function(e) {
      e === void 0 && (e = B.Warn), this.logLevel = e;
    }, n.prototype.log = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.logLevel < B.Verbose || console.log("".concat(ue, "[Log]: ").concat(e.join(" ")));
    }, n.prototype.warn = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.logLevel < B.Warn || console.warn("".concat(ue, "[Warn]: ").concat(e.join(" ")));
    }, n.prototype.error = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.logLevel < B.Error || console.error("".concat(ue, "[Error]: ").concat(e.join(" ")));
    }, n.prototype.debug = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.logLevel < B.Debug || console.log("".concat(ue, "[Debug]: ").concat(e.join(" ")));
    }, n;
  }()
), pe = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: B.Warn,
    loggerProvider: new ot(),
    offline: !1,
    optOut: !1,
    serverUrl: rt,
    serverZone: "US",
    useBatch: !1
  };
}, Vt = (
  /** @class */
  function() {
    function n(e) {
      var t, i, s, o;
      this._optOut = !1;
      var a = pe();
      this.apiKey = e.apiKey, this.flushIntervalMillis = (t = e.flushIntervalMillis) !== null && t !== void 0 ? t : a.flushIntervalMillis, this.flushMaxRetries = e.flushMaxRetries || a.flushMaxRetries, this.flushQueueSize = e.flushQueueSize || a.flushQueueSize, this.instanceName = e.instanceName || a.instanceName, this.loggerProvider = e.loggerProvider || a.loggerProvider, this.logLevel = (i = e.logLevel) !== null && i !== void 0 ? i : a.logLevel, this.minIdLength = e.minIdLength, this.plan = e.plan, this.ingestionMetadata = e.ingestionMetadata, this.offline = e.offline !== void 0 ? e.offline : a.offline, this.optOut = (s = e.optOut) !== null && s !== void 0 ? s : a.optOut, this.serverUrl = e.serverUrl, this.serverZone = e.serverZone || a.serverZone, this.storageProvider = e.storageProvider, this.transportProvider = e.transportProvider, this.useBatch = (o = e.useBatch) !== null && o !== void 0 ? o : a.useBatch, this.loggerProvider.enable(this.logLevel);
      var d = at(e.serverUrl, e.serverZone, e.useBatch);
      this.serverZone = d.serverZone, this.serverUrl = d.serverUrl;
    }
    return Object.defineProperty(n.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(e) {
        this._optOut = e;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }()
), xt = function(n, e) {
  return n === "EU" ? e ? Mt : Et : e ? Ft : rt;
}, at = function(n, e, t) {
  if (n === void 0 && (n = ""), e === void 0 && (e = pe().serverZone), t === void 0 && (t = pe().useBatch), n)
    return { serverUrl: n, serverZone: void 0 };
  var i = ["US", "EU"].includes(e) ? e : pe().serverZone;
  return {
    serverZone: i,
    serverUrl: xt(i, t)
  };
};
function Qt(n) {
  return n instanceof Error ? n.message : String(n);
}
function de(n) {
  var e = "";
  try {
    "body" in n && (e = JSON.stringify(n.body, null, 2));
  } catch {
  }
  return e;
}
var Kt = (
  /** @class */
  function() {
    function n() {
      this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduled = null, this.queue = [];
    }
    return n.prototype.setup = function(e) {
      var t;
      return v(this, void 0, void 0, function() {
        var i, s = this;
        return g(this, function(o) {
          switch (o.label) {
            case 0:
              return this.config = e, this.storageKey = "".concat(Pt, "_").concat(this.config.apiKey.substring(0, 10)), [4, (t = this.config.storageProvider) === null || t === void 0 ? void 0 : t.get(this.storageKey)];
            case 1:
              return i = o.sent(), i && i.length > 0 && Promise.all(i.map(function(a) {
                return s.execute(a);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, n.prototype.execute = function(e) {
      var t = this;
      return new Promise(function(i) {
        var s = {
          event: e,
          attempts: 0,
          callback: function(o) {
            return i(o);
          },
          timeout: 0
        };
        t.addToQueue(s);
      });
    }, n.prototype.addToQueue = function() {
      for (var e = this, t = [], i = 0; i < arguments.length; i++)
        t[i] = arguments[i];
      var s = t.filter(function(o) {
        return o.attempts < e.config.flushMaxRetries ? (o.attempts += 1, !0) : (e.fulfillRequest([o], 500, wt), !1);
      });
      s.forEach(function(o) {
        if (e.queue = e.queue.concat(o), o.timeout === 0) {
          e.schedule(e.config.flushIntervalMillis);
          return;
        }
        setTimeout(function() {
          o.timeout = 0, e.schedule(0);
        }, o.timeout);
      }), this.updateEventStorage([], this.queue);
    }, n.prototype.schedule = function(e) {
      var t = this;
      this.scheduled || this.config.offline || (this.scheduled = setTimeout(function() {
        t.flush(!0).then(function() {
          t.queue.length > 0 && t.schedule(e);
        });
      }, e));
    }, n.prototype.flush = function(e) {
      return e === void 0 && (e = !1), v(this, void 0, void 0, function() {
        var t, i, s, o = this;
        return g(this, function(a) {
          switch (a.label) {
            case 0:
              return this.config.offline ? (this.config.loggerProvider.debug("Skipping flush while offline."), [
                2
                /*return*/
              ]) : (t = [], i = [], this.queue.forEach(function(d) {
                return d.timeout === 0 ? t.push(d) : i.push(d);
              }), this.queue = i, this.scheduled && (clearTimeout(this.scheduled), this.scheduled = null), s = Wt(t, this.config.flushQueueSize), [4, Promise.all(s.map(function(d) {
                return o.send(d, e);
              }))]);
            case 1:
              return a.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.send = function(e, t) {
      return t === void 0 && (t = !0), v(this, void 0, void 0, function() {
        var i, s, o, a, d;
        return g(this, function(u) {
          switch (u.label) {
            case 0:
              if (!this.config.apiKey)
                return [2, this.fulfillRequest(e, 400, bt)];
              i = {
                api_key: this.config.apiKey,
                events: e.map(function(c) {
                  var l = c.event;
                  l.extra;
                  var p = Me(l, ["extra"]);
                  return p;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString()
              }, u.label = 1;
            case 1:
              return u.trys.push([1, 3, , 4]), s = at(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(s, i)];
            case 2:
              return o = u.sent(), o === null ? (this.fulfillRequest(e, 0, _t), [
                2
                /*return*/
              ]) : t ? (this.handleResponse(o, e), [3, 4]) : ("body" in o ? this.fulfillRequest(e, o.statusCode, "".concat(o.status, ": ").concat(de(o))) : this.fulfillRequest(e, o.statusCode, o.status), [
                2
                /*return*/
              ]);
            case 3:
              return a = u.sent(), d = Qt(a), this.config.loggerProvider.error(d), this.fulfillRequest(e, 0, d), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.handleResponse = function(e, t) {
      var i = e.status;
      switch (i) {
        case F.Success: {
          this.handleSuccessResponse(e, t);
          break;
        }
        case F.Invalid: {
          this.handleInvalidResponse(e, t);
          break;
        }
        case F.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(e, t);
          break;
        }
        case F.RateLimit: {
          this.handleRateLimitResponse(e, t);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(i, "' provided for ").concat(t.length, ' events"}')), this.handleOtherResponse(t);
          break;
        }
      }
    }, n.prototype.handleSuccessResponse = function(e, t) {
      this.fulfillRequest(t, e.statusCode, mt);
    }, n.prototype.handleInvalidResponse = function(e, t) {
      var i = this;
      if (e.body.missingField || e.body.error.startsWith(It)) {
        this.fulfillRequest(t, e.statusCode, e.body.error);
        return;
      }
      var s = W(W(W(W([], D(Object.values(e.body.eventsWithInvalidFields)), !1), D(Object.values(e.body.eventsWithMissingFields)), !1), D(Object.values(e.body.eventsWithInvalidIdLengths)), !1), D(e.body.silencedEvents), !1).flat(), o = new Set(s), a = t.filter(function(d, u) {
        if (o.has(u)) {
          i.fulfillRequest([d], e.statusCode, e.body.error);
          return;
        }
        return !0;
      });
      a.length > 0 && this.config.loggerProvider.warn(de(e)), this.addToQueue.apply(this, W([], D(a), !1));
    }, n.prototype.handlePayloadTooLargeResponse = function(e, t) {
      if (t.length === 1) {
        this.fulfillRequest(t, e.statusCode, e.body.error);
        return;
      }
      this.config.loggerProvider.warn(de(e)), this.config.flushQueueSize /= 2, this.addToQueue.apply(this, W([], D(t), !1));
    }, n.prototype.handleRateLimitResponse = function(e, t) {
      var i = this, s = Object.keys(e.body.exceededDailyQuotaUsers), o = Object.keys(e.body.exceededDailyQuotaDevices), a = e.body.throttledEvents, d = new Set(s), u = new Set(o), c = new Set(a), l = t.filter(function(p, h) {
        if (p.event.user_id && d.has(p.event.user_id) || p.event.device_id && u.has(p.event.device_id)) {
          i.fulfillRequest([p], e.statusCode, e.body.error);
          return;
        }
        return c.has(h) && (p.timeout = i.throttleTimeout), !0;
      });
      l.length > 0 && this.config.loggerProvider.warn(de(e)), this.addToQueue.apply(this, W([], D(l), !1));
    }, n.prototype.handleOtherResponse = function(e) {
      var t = this;
      this.addToQueue.apply(this, W([], D(e.map(function(i) {
        return i.timeout = i.attempts * t.retryTimeout, i;
      })), !1));
    }, n.prototype.fulfillRequest = function(e, t, i) {
      e.forEach(function(s) {
        return s.callback(X(s.event, t, i));
      }), this.updateEventStorage(e);
    }, n.prototype.updateEventStorage = function(e, t) {
      return v(this, void 0, void 0, function() {
        var i, s, o;
        return g(this, function(a) {
          switch (a.label) {
            case 0:
              return this.config.storageProvider ? (i = e.reduce(function(d, u) {
                return u.event.insert_id && d.add(u.event.insert_id), d;
              }, /* @__PURE__ */ new Set()), [4, this.config.storageProvider.get(this.storageKey)]) : [
                2
                /*return*/
              ];
            case 1:
              return s = a.sent(), o = (t == null ? void 0 : t.map(function(d) {
                return d.event;
              })) || [], s == null || s.forEach(function(d) {
                d.insert_id && !i.has(d.insert_id) && o.push(d);
              }), [4, this.config.storageProvider.set(this.storageKey, o)];
            case 2:
              return a.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n;
  }()
), qt = function(n) {
  n === void 0 && (n = 0);
  var e = new Error().stack || "";
  return e.split(`
`).slice(2 + n).map(function(t) {
    return t.trim();
  });
}, A = function(n) {
  return function() {
    var e = k({}, n.config), t = e.loggerProvider, i = e.logLevel;
    return {
      logger: t,
      logLevel: i
    };
  };
}, zt = function(n, e) {
  var t, i;
  e = e.replace(/\[(\w+)\]/g, ".$1"), e = e.replace(/^\./, "");
  try {
    for (var s = ee(e.split(".")), o = s.next(); !o.done; o = s.next()) {
      var a = o.value;
      if (a in n)
        n = n[a];
      else
        return;
    }
  } catch (d) {
    t = { error: d };
  } finally {
    try {
      o && !o.done && (i = s.return) && i.call(s);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return n;
}, O = function(n, e) {
  return function() {
    var t, i, s = {};
    try {
      for (var o = ee(e), a = o.next(); !a.done; a = o.next()) {
        var d = a.value;
        s[d] = zt(n, d);
      }
    } catch (u) {
      t = { error: u };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (t)
          throw t.error;
      }
    }
    return s;
  };
}, T = function(n, e, t, i, s) {
  return s === void 0 && (s = null), function() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    var d = t(), u = d.logger, c = d.logLevel;
    if (c && c < B.Debug || !c || !u)
      return n.apply(s, o);
    var l = {
      type: "invoke public method",
      name: e,
      args: o,
      stacktrace: qt(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    i && l.states && (l.states.before = i());
    var p = n.apply(s, o);
    return p && p.promise ? p.promise.then(function() {
      i && l.states && (l.states.after = i()), l.time && (l.time.end = (/* @__PURE__ */ new Date()).toISOString()), u.debug(JSON.stringify(l, null, 2));
    }) : (i && l.states && (l.states.after = i()), l.time && (l.time.end = (/* @__PURE__ */ new Date()).toISOString()), u.debug(JSON.stringify(l, null, 2))), p;
  };
}, ct = (
  /** @class */
  function() {
    function n() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    return n.prototype.isEnabled = function() {
      return v(this, void 0, void 0, function() {
        return g(this, function(e) {
          return [2, !0];
        });
      });
    }, n.prototype.get = function(e) {
      return v(this, void 0, void 0, function() {
        return g(this, function(t) {
          return [2, this.memoryStorage.get(e)];
        });
      });
    }, n.prototype.getRaw = function(e) {
      return v(this, void 0, void 0, function() {
        var t;
        return g(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.get(e)];
            case 1:
              return t = i.sent(), [2, t ? JSON.stringify(t) : void 0];
          }
        });
      });
    }, n.prototype.set = function(e, t) {
      return v(this, void 0, void 0, function() {
        return g(this, function(i) {
          return this.memoryStorage.set(e, t), [
            2
            /*return*/
          ];
        });
      });
    }, n.prototype.remove = function(e) {
      return v(this, void 0, void 0, function() {
        return g(this, function(t) {
          return this.memoryStorage.delete(e), [
            2
            /*return*/
          ];
        });
      });
    }, n.prototype.reset = function() {
      return v(this, void 0, void 0, function() {
        return g(this, function(e) {
          return this.memoryStorage.clear(), [
            2
            /*return*/
          ];
        });
      });
    }, n;
  }()
), He = (
  /** @class */
  function() {
    function n() {
    }
    return n.prototype.send = function(e, t) {
      return Promise.resolve(null);
    }, n.prototype.buildResponse = function(e) {
      var t, i, s, o, a, d, u, c, l, p, h, y, C, _, f, w, M, S, P, H, b, I;
      if (typeof e != "object")
        return null;
      var E = e.code || 0, U = this.buildStatus(E);
      switch (U) {
        case F.Success:
          return {
            status: U,
            statusCode: E,
            body: {
              eventsIngested: (t = e.events_ingested) !== null && t !== void 0 ? t : 0,
              payloadSizeBytes: (i = e.payload_size_bytes) !== null && i !== void 0 ? i : 0,
              serverUploadTime: (s = e.server_upload_time) !== null && s !== void 0 ? s : 0
            }
          };
        case F.Invalid:
          return {
            status: U,
            statusCode: E,
            body: {
              error: (o = e.error) !== null && o !== void 0 ? o : "",
              missingField: (a = e.missing_field) !== null && a !== void 0 ? a : "",
              eventsWithInvalidFields: (d = e.events_with_invalid_fields) !== null && d !== void 0 ? d : {},
              eventsWithMissingFields: (u = e.events_with_missing_fields) !== null && u !== void 0 ? u : {},
              eventsWithInvalidIdLengths: (c = e.events_with_invalid_id_lengths) !== null && c !== void 0 ? c : {},
              epsThreshold: (l = e.eps_threshold) !== null && l !== void 0 ? l : 0,
              exceededDailyQuotaDevices: (p = e.exceeded_daily_quota_devices) !== null && p !== void 0 ? p : {},
              silencedDevices: (h = e.silenced_devices) !== null && h !== void 0 ? h : [],
              silencedEvents: (y = e.silenced_events) !== null && y !== void 0 ? y : [],
              throttledDevices: (C = e.throttled_devices) !== null && C !== void 0 ? C : {},
              throttledEvents: (_ = e.throttled_events) !== null && _ !== void 0 ? _ : []
            }
          };
        case F.PayloadTooLarge:
          return {
            status: U,
            statusCode: E,
            body: {
              error: (f = e.error) !== null && f !== void 0 ? f : ""
            }
          };
        case F.RateLimit:
          return {
            status: U,
            statusCode: E,
            body: {
              error: (w = e.error) !== null && w !== void 0 ? w : "",
              epsThreshold: (M = e.eps_threshold) !== null && M !== void 0 ? M : 0,
              throttledDevices: (S = e.throttled_devices) !== null && S !== void 0 ? S : {},
              throttledUsers: (P = e.throttled_users) !== null && P !== void 0 ? P : {},
              exceededDailyQuotaDevices: (H = e.exceeded_daily_quota_devices) !== null && H !== void 0 ? H : {},
              exceededDailyQuotaUsers: (b = e.exceeded_daily_quota_users) !== null && b !== void 0 ? b : {},
              throttledEvents: (I = e.throttled_events) !== null && I !== void 0 ? I : []
            }
          };
        case F.Timeout:
        default:
          return {
            status: U,
            statusCode: E
          };
      }
    }, n.prototype.buildStatus = function(e) {
      return e >= 200 && e < 300 ? F.Success : e === 429 ? F.RateLimit : e === 413 ? F.PayloadTooLarge : e === 408 ? F.Timeout : e >= 400 && e < 500 ? F.Invalid : e >= 500 ? F.Failed : F.Unknown;
    }, n;
  }()
), x = function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global < "u")
    return global;
}, De = function() {
  var n, e = x();
  if (!(!((n = e == null ? void 0 : e.location) === null || n === void 0) && n.search))
    return {};
  var t = e.location.search.substring(1).split("&").filter(Boolean), i = t.reduce(function(s, o) {
    var a = o.split("=", 2), d = Ne(a[0]), u = Ne(a[1]);
    return u && (s[d] = u), s;
  }, {});
  return i;
}, Ne = function(n) {
  n === void 0 && (n = "");
  try {
    return decodeURIComponent(n);
  } catch {
    return "";
  }
}, Gt = "utm_campaign", jt = "utm_content", Jt = "utm_id", $t = "utm_medium", Yt = "utm_source", Zt = "utm_term", We = "dclid", Ve = "fbclid", xe = "gbraid", Qe = "gclid", Ke = "ko_click_id", qe = "li_fat_id", ze = "msclkid", Ge = "rtd_cid", je = "ttclid", Je = "twclid", $e = "wbraid", Be = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, ut = (
  /** @class */
  function() {
    function n() {
    }
    return n.prototype.parse = function() {
      return v(this, void 0, void 0, function() {
        return g(this, function(e) {
          return [2, k(k(k(k({}, Be), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, n.prototype.getUtmParam = function() {
      var e = De(), t = e[Gt], i = e[jt], s = e[Jt], o = e[$t], a = e[Yt], d = e[Zt];
      return {
        utm_campaign: t,
        utm_content: i,
        utm_id: s,
        utm_medium: o,
        utm_source: a,
        utm_term: d
      };
    }, n.prototype.getReferrer = function() {
      var e, t, i = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        i.referrer = document.referrer || void 0, i.referring_domain = (t = (e = i.referrer) === null || e === void 0 ? void 0 : e.split("/")[2]) !== null && t !== void 0 ? t : void 0;
      } catch {
      }
      return i;
    }, n.prototype.getClickIds = function() {
      var e, t = De();
      return e = {}, e[We] = t[We], e[Ve] = t[Ve], e[xe] = t[xe], e[Qe] = t[Qe], e[Ke] = t[Ke], e[qe] = t[qe], e[ze] = t[ze], e[Ge] = t[Ge], e[je] = t[je], e[Je] = t[Je], e[$e] = t[$e], e;
    }, n;
  }()
), dt = function(n, e, t) {
  return e === void 0 && (e = ""), t === void 0 && (t = 10), [ge, e, n.substring(0, t)].filter(Boolean).join("_");
}, Xt = function(n) {
  return "".concat(ge.toLowerCase(), "_").concat(n.substring(0, 6));
}, lt = function(n, e) {
  e === void 0 && (e = Date.now());
  var t = Date.now(), i = t - e;
  return i > n;
}, Ue = (
  /** @class */
  function() {
    function n(e) {
      this.options = k({}, e);
    }
    return n.prototype.isEnabled = function() {
      return v(this, void 0, void 0, function() {
        var e, t, i;
        return g(this, function(s) {
          switch (s.label) {
            case 0:
              if (!x())
                return [2, !1];
              n.testValue = String(Date.now()), e = new n(this.options), t = "AMP_TEST", s.label = 1;
            case 1:
              return s.trys.push([1, 4, 5, 7]), [4, e.set(t, n.testValue)];
            case 2:
              return s.sent(), [4, e.get(t)];
            case 3:
              return i = s.sent(), [2, i === n.testValue];
            case 4:
              return s.sent(), [2, !1];
            case 5:
              return [4, e.remove(t)];
            case 6:
              return s.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.get = function(e) {
      return v(this, void 0, void 0, function() {
        var t;
        return g(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.getRaw(e)];
            case 1:
              if (t = i.sent(), !t)
                return [2, void 0];
              try {
                try {
                  t = decodeURIComponent(atob(t));
                } catch {
                }
                return [2, JSON.parse(t)];
              } catch {
                return [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.getRaw = function(e) {
      var t, i;
      return v(this, void 0, void 0, function() {
        var s, o, a;
        return g(this, function(d) {
          return s = x(), o = (i = (t = s == null ? void 0 : s.document) === null || t === void 0 ? void 0 : t.cookie.split("; ")) !== null && i !== void 0 ? i : [], a = o.find(function(u) {
            return u.indexOf(e + "=") === 0;
          }), a ? [2, a.substring(e.length + 1)] : [2, void 0];
        });
      });
    }, n.prototype.set = function(e, t) {
      var i;
      return v(this, void 0, void 0, function() {
        var s, o, a, d, u, c;
        return g(this, function(l) {
          try {
            s = (i = this.options.expirationDays) !== null && i !== void 0 ? i : 0, o = t !== null ? s : -1, a = void 0, o && (d = /* @__PURE__ */ new Date(), d.setTime(d.getTime() + o * 24 * 60 * 60 * 1e3), a = d), u = "".concat(e, "=").concat(btoa(encodeURIComponent(JSON.stringify(t)))), a && (u += "; expires=".concat(a.toUTCString())), u += "; path=/", this.options.domain && (u += "; domain=".concat(this.options.domain)), this.options.secure && (u += "; Secure"), this.options.sameSite && (u += "; SameSite=".concat(this.options.sameSite)), c = x(), c && (c.document.cookie = u);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, n.prototype.remove = function(e) {
      return v(this, void 0, void 0, function() {
        return g(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.set(e, null)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.reset = function() {
      return v(this, void 0, void 0, function() {
        return g(this, function(e) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, n;
  }()
), en = (
  /** @class */
  function(n) {
    $(e, n);
    function e() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return e.prototype.send = function(t, i) {
      return v(this, void 0, void 0, function() {
        var s, o, a;
        return g(this, function(d) {
          switch (d.label) {
            case 0:
              if (typeof fetch > "u")
                throw new Error("FetchTransport is not supported");
              return s = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify(i),
                method: "POST"
              }, [4, fetch(t, s)];
            case 1:
              return o = d.sent(), [4, o.json()];
            case 2:
              return a = d.sent(), [2, this.buildResponse(a)];
          }
        });
      });
    }, e;
  }(He)
), tn = (
  /** @class */
  function() {
    function n() {
    }
    return n.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: nn(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, n;
  }()
), nn = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, rn = (
  /** @class */
  function() {
    function n() {
      this.queue = [];
    }
    return n.prototype.logEvent = function(e) {
      this.receiver ? this.receiver(e) : this.queue.length < 512 && this.queue.push(e);
    }, n.prototype.setEventReceiver = function(e) {
      this.receiver = e, this.queue.length > 0 && (this.queue.forEach(function(t) {
        e(t);
      }), this.queue = []);
    }, n;
  }()
), q = function() {
  return q = Object.assign || function(e) {
    for (var t, i = 1, s = arguments.length; i < s; i++) {
      t = arguments[i];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, q.apply(this, arguments);
}, he = function(n, e) {
  var t = ["string", "number", "boolean", "undefined"], i = typeof n, s = typeof e;
  if (i !== s)
    return !1;
  for (var o = 0, a = t; o < a.length; o++) {
    var d = a[o];
    if (d === i)
      return n === e;
  }
  if (n == null && e == null)
    return !0;
  if (n == null || e == null || n.length !== e.length)
    return !1;
  var u = Array.isArray(n), c = Array.isArray(e);
  if (u !== c)
    return !1;
  if (u && c) {
    for (var l = 0; l < n.length; l++)
      if (!he(n[l], e[l]))
        return !1;
  } else {
    var p = Object.keys(n).sort(), h = Object.keys(e).sort();
    if (!he(p, h))
      return !1;
    var y = !0;
    return Object.keys(n).forEach(function(C) {
      he(n[C], e[C]) || (y = !1);
    }), y;
  }
  return !0;
}, sn = "$set", on = "$unset", an = "$clearAll";
Object.entries || (Object.entries = function(n) {
  for (var e = Object.keys(n), t = e.length, i = new Array(t); t--; )
    i[t] = [e[t], n[e[t]]];
  return i;
});
var cn = (
  /** @class */
  function() {
    function n() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return n.prototype.editIdentity = function() {
      var e = this, t = q({}, this.identity.userProperties), i = q(q({}, this.identity), { userProperties: t });
      return {
        setUserId: function(s) {
          return i.userId = s, this;
        },
        setDeviceId: function(s) {
          return i.deviceId = s, this;
        },
        setUserProperties: function(s) {
          return i.userProperties = s, this;
        },
        setOptOut: function(s) {
          return i.optOut = s, this;
        },
        updateUserProperties: function(s) {
          for (var o = i.userProperties || {}, a = 0, d = Object.entries(s); a < d.length; a++) {
            var u = d[a], c = u[0], l = u[1];
            switch (c) {
              case sn:
                for (var p = 0, h = Object.entries(l); p < h.length; p++) {
                  var y = h[p], C = y[0], _ = y[1];
                  o[C] = _;
                }
                break;
              case on:
                for (var f = 0, w = Object.keys(l); f < w.length; f++) {
                  var C = w[f];
                  delete o[C];
                }
                break;
              case an:
                o = {};
                break;
            }
          }
          return i.userProperties = o, this;
        },
        commit: function() {
          return e.setIdentity(i), this;
        }
      };
    }, n.prototype.getIdentity = function() {
      return q({}, this.identity);
    }, n.prototype.setIdentity = function(e) {
      var t = q({}, this.identity);
      this.identity = q({}, e), he(t, this.identity) || this.listeners.forEach(function(i) {
        i(e);
      });
    }, n.prototype.addIdentityListener = function(e) {
      this.listeners.add(e);
    }, n.prototype.removeIdentityListener = function(e) {
      this.listeners.delete(e);
    }, n;
  }()
), ie = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : self, un = (
  /** @class */
  function() {
    function n() {
      this.identityStore = new cn(), this.eventBridge = new rn(), this.applicationContextProvider = new tn();
    }
    return n.getInstance = function(e) {
      return ie.analyticsConnectorInstances || (ie.analyticsConnectorInstances = {}), ie.analyticsConnectorInstances[e] || (ie.analyticsConnectorInstances[e] = new n()), ie.analyticsConnectorInstances[e];
    }, n;
  }()
), oe = function(n) {
  return n === void 0 && (n = "$default_instance"), un.getInstance(n);
}, dn = function(n, e) {
  oe(e).identityStore.editIdentity().setUserId(n).commit();
}, ln = function(n, e) {
  oe(e).identityStore.editIdentity().setDeviceId(n).commit();
}, pn = (
  /** @class */
  function() {
    function n() {
      this.name = "identity", this.type = "before", this.identityStore = oe().identityStore;
    }
    return n.prototype.execute = function(e) {
      return v(this, void 0, void 0, function() {
        var t;
        return g(this, function(i) {
          return t = e.user_properties, t && this.identityStore.editIdentity().updateUserProperties(t).commit(), [2, e];
        });
      });
    }, n.prototype.setup = function(e) {
      return v(this, void 0, void 0, function() {
        return g(this, function(t) {
          return e.instanceName && (this.identityStore = oe(e.instanceName).identityStore), [
            2
            /*return*/
          ];
        });
      });
    }, n;
  }()
), hn = function() {
  var n, e, t, i;
  if (typeof navigator > "u")
    return "";
  var s = navigator.userLanguage;
  return (i = (t = (e = (n = navigator.languages) === null || n === void 0 ? void 0 : n[0]) !== null && e !== void 0 ? e : navigator.language) !== null && t !== void 0 ? t : s) !== null && i !== void 0 ? i : "";
}, ce = function(n, e) {
  return typeof n == "boolean" ? n : (n == null ? void 0 : n[e]) !== !1;
}, pt = function(n) {
  return ce(n, "attribution");
}, vn = function(n) {
  return ce(n, "fileDownloads");
}, gn = function(n) {
  return ce(n, "formInteractions");
}, ht = function(n) {
  return ce(n, "pageViews");
}, Cn = function(n) {
  return ce(n, "sessions");
}, fn = function(n) {
  var e = function() {
    return !1;
  }, t = void 0, i, s = n.pageCounter, o = ht(n.defaultTracking);
  return o && (e = void 0, i = void 0, n.defaultTracking && typeof n.defaultTracking == "object" && n.defaultTracking.pageViews && typeof n.defaultTracking.pageViews == "object" && ("trackOn" in n.defaultTracking.pageViews && (e = n.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in n.defaultTracking.pageViews && (t = n.defaultTracking.pageViews.trackHistoryChanges), "eventType" in n.defaultTracking.pageViews && n.defaultTracking.pageViews.eventType && (i = n.defaultTracking.pageViews.eventType))), {
    trackOn: e,
    trackHistoryChanges: t,
    eventType: i,
    pageCounter: s
  };
}, kn = function(n) {
  return pt(n.defaultTracking) && n.defaultTracking && typeof n.defaultTracking == "object" && n.defaultTracking.attribution && typeof n.defaultTracking.attribution == "object" ? k({}, n.defaultTracking.attribution) : {};
}, Ie = function(n, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t], s = i.name, o = i.args, a = i.resolve, d = n && n[s];
    if (typeof d == "function") {
      var u = d.apply(n, o);
      typeof a == "function" && a(u == null ? void 0 : u.promise);
    }
  }
  return n;
}, Ae = function(n) {
  var e = n;
  return e && e._q !== void 0;
}, yn = "2.5.3", mn = "Web", _n = "$remote", wn = (
  /** @class */
  function() {
    function n() {
      this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = "amplitude-ts/".concat(yn), typeof navigator < "u" && (this.userAgent = navigator.userAgent);
    }
    return n.prototype.setup = function(e) {
      return this.config = e, Promise.resolve(void 0);
    }, n.prototype.execute = function(e) {
      var t, i;
      return v(this, void 0, void 0, function() {
        var s, o, a, d;
        return g(this, function(u) {
          return s = (/* @__PURE__ */ new Date()).getTime(), o = (t = this.config.lastEventId) !== null && t !== void 0 ? t : -1, a = (i = e.event_id) !== null && i !== void 0 ? i : o + 1, this.config.lastEventId = a, e.time || (this.config.lastEventTime = s), d = k(k(k(k(k(k(k(k({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: s }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: mn }), this.config.trackingOptions.language && { language: hn() }), this.config.trackingOptions.ipAddress && { ip: _n }), { insert_id: ae(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), e), { event_id: a, library: this.library, user_agent: this.userAgent }), [2, d];
        });
      });
    }, n;
  }()
), vt = (
  /** @class */
  function() {
    function n(e) {
      this.storage = e;
    }
    return n.prototype.isEnabled = function() {
      return v(this, void 0, void 0, function() {
        var e, t, i, s;
        return g(this, function(o) {
          switch (o.label) {
            case 0:
              if (!this.storage)
                return [2, !1];
              e = String(Date.now()), t = new n(this.storage), i = "AMP_TEST", o.label = 1;
            case 1:
              return o.trys.push([1, 4, 5, 7]), [4, t.set(i, e)];
            case 2:
              return o.sent(), [4, t.get(i)];
            case 3:
              return s = o.sent(), [2, s === e];
            case 4:
              return o.sent(), [2, !1];
            case 5:
              return [4, t.remove(i)];
            case 6:
              return o.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.get = function(e) {
      return v(this, void 0, void 0, function() {
        var t;
        return g(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), [4, this.getRaw(e)];
            case 1:
              return t = i.sent(), t ? [2, JSON.parse(t)] : [2, void 0];
            case 2:
              return i.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, n.prototype.getRaw = function(e) {
      var t;
      return v(this, void 0, void 0, function() {
        return g(this, function(i) {
          return [2, ((t = this.storage) === null || t === void 0 ? void 0 : t.getItem(e)) || void 0];
        });
      });
    }, n.prototype.set = function(e, t) {
      var i;
      return v(this, void 0, void 0, function() {
        return g(this, function(s) {
          try {
            (i = this.storage) === null || i === void 0 || i.setItem(e, JSON.stringify(t));
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, n.prototype.remove = function(e) {
      var t;
      return v(this, void 0, void 0, function() {
        return g(this, function(i) {
          try {
            (t = this.storage) === null || t === void 0 || t.removeItem(e);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, n.prototype.reset = function() {
      var e;
      return v(this, void 0, void 0, function() {
        return g(this, function(t) {
          try {
            (e = this.storage) === null || e === void 0 || e.clear();
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, n;
  }()
), le = 1e3, gt = (
  /** @class */
  function(n) {
    $(e, n);
    function e(t) {
      var i = this, s;
      return i = n.call(this, (s = x()) === null || s === void 0 ? void 0 : s.localStorage) || this, i.loggerProvider = t == null ? void 0 : t.loggerProvider, i;
    }
    return e.prototype.set = function(t, i) {
      var s;
      return v(this, void 0, void 0, function() {
        var o;
        return g(this, function(a) {
          switch (a.label) {
            case 0:
              return Array.isArray(i) && i.length > le ? (o = i.length - le, [4, n.prototype.set.call(this, t, i.slice(0, le))]) : [3, 2];
            case 1:
              return a.sent(), (s = this.loggerProvider) === null || s === void 0 || s.error("Failed to save ".concat(o, " events because the queue length exceeded ").concat(le, ".")), [3, 4];
            case 2:
              return [4, n.prototype.set.call(this, t, i)];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }(vt)
), Sn = (
  /** @class */
  function(n) {
    $(e, n);
    function e() {
      var t;
      return n.call(this, (t = x()) === null || t === void 0 ? void 0 : t.sessionStorage) || this;
    }
    return e;
  }(vt)
), bn = (
  /** @class */
  function(n) {
    $(e, n);
    function e() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        done: 4
      }, t;
    }
    return e.prototype.send = function(t, i) {
      return v(this, void 0, void 0, function() {
        var s = this;
        return g(this, function(o) {
          return [2, new Promise(function(a, d) {
            typeof XMLHttpRequest > "u" && d(new Error("XHRTransport is not supported."));
            var u = new XMLHttpRequest();
            u.open("POST", t, !0), u.onreadystatechange = function() {
              if (u.readyState === s.state.done)
                try {
                  var c = u.responseText, l = JSON.parse(c), p = s.buildResponse(l);
                  a(p);
                } catch (h) {
                  d(h);
                }
            }, u.setRequestHeader("Content-Type", "application/json"), u.setRequestHeader("Accept", "*/*"), u.send(JSON.stringify(i));
          })];
        });
      });
    }, e;
  }(He)
), In = (
  /** @class */
  function(n) {
    $(e, n);
    function e() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return e.prototype.send = function(t, i) {
      return v(this, void 0, void 0, function() {
        var s = this;
        return g(this, function(o) {
          return [2, new Promise(function(a, d) {
            var u = x();
            if (!(u != null && u.navigator.sendBeacon))
              throw new Error("SendBeaconTransport is not supported");
            try {
              var c = JSON.stringify(i), l = u.navigator.sendBeacon(t, JSON.stringify(i));
              return a(l ? s.buildResponse({
                code: 200,
                events_ingested: i.events.length,
                payload_size_bytes: c.length,
                server_upload_time: Date.now()
              }) : s.buildResponse({ code: 500 }));
            } catch (p) {
              d(p);
            }
          })];
        });
      });
    }, e;
  }(He)
), An = function(n, e, t) {
  return t === void 0 && (t = !0), v(void 0, void 0, void 0, function() {
    var i, s, o, a, d, u, c, l, p;
    return g(this, function(h) {
      switch (h.label) {
        case 0:
          return i = Xt(n), [4, e.getRaw(i)];
        case 1:
          return s = h.sent(), s ? t ? [4, e.remove(i)] : [3, 3] : [2, {
            optOut: !1
          }];
        case 2:
          h.sent(), h.label = 3;
        case 3:
          return o = D(s.split("."), 6), a = o[0], d = o[1], u = o[2], c = o[3], l = o[4], p = o[5], [2, {
            deviceId: a,
            userId: On(d),
            sessionId: Oe(c),
            lastEventId: Oe(p),
            lastEventTime: Oe(l),
            optOut: !!u
          }];
      }
    });
  });
}, Oe = function(n) {
  var e = parseInt(n, 32);
  if (!isNaN(e))
    return e;
}, On = function(n) {
  if (!(!atob || !escape || !n))
    try {
      return decodeURIComponent(escape(atob(n)));
    } catch {
      return;
    }
}, N = "[Amplitude]", Ye = "".concat(N, " Form Started"), Tn = "".concat(N, " Form Submitted"), Pn = "".concat(N, " File Downloaded"), Ze = "session_start", Xe = "session_end", En = "".concat(N, " File Extension"), Fn = "".concat(N, " File Name"), Mn = "".concat(N, " Link ID"), Rn = "".concat(N, " Link Text"), Dn = "".concat(N, " Link URL"), Te = "".concat(N, " Form ID"), Pe = "".concat(N, " Form Name"), Ee = "".concat(N, " Form Destination"), ve = "cookie", Un = "US", Hn = (
  /** @class */
  function(n) {
    $(e, n);
    function e(t, i, s, o, a, d, u, c, l, p, h, y, C, _, f, w, M, S, P, H, b, I, E, U, V, Q, z, K, G, ne, re) {
      s === void 0 && (s = new ct()), o === void 0 && (o = {
        domain: "",
        expiration: 365,
        sameSite: "Lax",
        secure: !1,
        upgrade: !0
      }), u === void 0 && (u = 1e3), c === void 0 && (c = 5), l === void 0 && (l = 30), p === void 0 && (p = ve), f === void 0 && (f = new ot()), w === void 0 && (w = B.Warn), S === void 0 && (S = !1), P === void 0 && (P = !1), I === void 0 && (I = ""), E === void 0 && (E = Un), V === void 0 && (V = 30 * 60 * 1e3), Q === void 0 && (Q = new gt({ loggerProvider: f })), z === void 0 && (z = {
        ipAddress: !0,
        language: !0,
        platform: !0
      }), K === void 0 && (K = "fetch"), G === void 0 && (G = !1);
      var m = n.call(this, { apiKey: t, storageProvider: Q, transportProvider: Ct(K) }) || this;
      return m.apiKey = t, m.appVersion = i, m.cookieOptions = o, m.defaultTracking = a, m.flushIntervalMillis = u, m.flushMaxRetries = c, m.flushQueueSize = l, m.identityStorage = p, m.ingestionMetadata = h, m.instanceName = y, m.loggerProvider = f, m.logLevel = w, m.minIdLength = M, m.offline = S, m.partnerId = H, m.plan = b, m.serverUrl = I, m.serverZone = E, m.sessionTimeout = V, m.storageProvider = Q, m.trackingOptions = z, m.transport = K, m.useBatch = G, m._optOut = !1, m._cookieStorage = s, m.deviceId = d, m.lastEventId = C, m.lastEventTime = _, m.optOut = P, m.sessionId = U, m.pageCounter = re, m.userId = ne, m.loggerProvider.enable(m.logLevel), m;
    }
    return Object.defineProperty(e.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(t) {
        this._cookieStorage !== t && (this._cookieStorage = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(t) {
        this._deviceId !== t && (this._deviceId = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(t) {
        this._userId !== t && (this._userId = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(t) {
        this._sessionId !== t && (this._sessionId = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(t) {
        this._optOut !== t && (this._optOut = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(t) {
        this._lastEventTime !== t && (this._lastEventTime = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(t) {
        this._lastEventId !== t && (this._lastEventId = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "pageCounter", {
      get: function() {
        return this._pageCounter;
      },
      set: function(t) {
        this._pageCounter !== t && (this._pageCounter = t, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateStorage = function() {
      var t = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId,
        pageCounter: this._pageCounter
      };
      this.cookieStorage.set(dt(this.apiKey), t);
    }, e;
  }(Vt)
), Bn = function(n, e, t) {
  return e === void 0 && (e = {}), v(void 0, void 0, void 0, function() {
    var i, s, o, a, d, u, c, l, p, h, y, C, _, f, w, M, S, P, H, b, I, E, U, V, Q, z, K, G, ne, re, m, Ce, fe, ke, ye, me, _e, we, Se, be;
    return g(this, function(Y) {
      switch (Y.label) {
        case 0:
          return i = e.identityStorage || ve, S = {}, i === ve ? [3, 1] : (o = "", [3, 5]);
        case 1:
          return (H = (P = e.cookieOptions) === null || P === void 0 ? void 0 : P.domain) !== null && H !== void 0 ? (a = H, [3, 4]) : [3, 2];
        case 2:
          return [4, Nn()];
        case 3:
          a = Y.sent(), Y.label = 4;
        case 4:
          o = a, Y.label = 5;
        case 5:
          return s = k.apply(void 0, [(S.domain = o, S.expiration = 365, S.sameSite = "Lax", S.secure = !1, S.upgrade = !0, S), e.cookieOptions]), d = Ln(e.identityStorage, s), [4, An(n, d, (I = (b = e.cookieOptions) === null || b === void 0 ? void 0 : b.upgrade) !== null && I !== void 0 ? I : !0)];
        case 6:
          return u = Y.sent(), [4, d.get(dt(n))];
        case 7:
          return c = Y.sent(), l = De(), p = (Q = (V = (U = (E = e.deviceId) !== null && E !== void 0 ? E : l.deviceId) !== null && U !== void 0 ? U : c == null ? void 0 : c.deviceId) !== null && V !== void 0 ? V : u.deviceId) !== null && Q !== void 0 ? Q : ae(), h = (z = c == null ? void 0 : c.lastEventId) !== null && z !== void 0 ? z : u.lastEventId, y = (K = c == null ? void 0 : c.lastEventTime) !== null && K !== void 0 ? K : u.lastEventTime, C = (ne = (G = e.optOut) !== null && G !== void 0 ? G : c == null ? void 0 : c.optOut) !== null && ne !== void 0 ? ne : u.optOut, _ = (re = c == null ? void 0 : c.sessionId) !== null && re !== void 0 ? re : u.sessionId, f = (Ce = (m = e.userId) !== null && m !== void 0 ? m : c == null ? void 0 : c.userId) !== null && Ce !== void 0 ? Ce : u.userId, t.previousSessionDeviceId = (fe = c == null ? void 0 : c.deviceId) !== null && fe !== void 0 ? fe : u.deviceId, t.previousSessionUserId = (ke = c == null ? void 0 : c.userId) !== null && ke !== void 0 ? ke : u.userId, w = {
            ipAddress: (me = (ye = e.trackingOptions) === null || ye === void 0 ? void 0 : ye.ipAddress) !== null && me !== void 0 ? me : !0,
            language: (we = (_e = e.trackingOptions) === null || _e === void 0 ? void 0 : _e.language) !== null && we !== void 0 ? we : !0,
            platform: (be = (Se = e.trackingOptions) === null || Se === void 0 ? void 0 : Se.platform) !== null && be !== void 0 ? be : !0
          }, M = c == null ? void 0 : c.pageCounter, [2, new Hn(n, e.appVersion, d, s, e.defaultTracking, p, e.flushIntervalMillis, e.flushMaxRetries, e.flushQueueSize, i, e.ingestionMetadata, e.instanceName, h, y, e.loggerProvider, e.logLevel, e.minIdLength, e.offline, C, e.partnerId, e.plan, e.serverUrl, e.serverZone, _, e.sessionTimeout, e.storageProvider, w, e.transport, e.useBatch, f, M)];
      }
    });
  });
}, Ln = function(n, e) {
  switch (n === void 0 && (n = ve), e === void 0 && (e = {}), n) {
    case "localStorage":
      return new gt();
    case "sessionStorage":
      return new Sn();
    case "none":
      return new ct();
    case "cookie":
    default:
      return new Ue(k(k({}, e), { expirationDays: e.expiration }));
  }
}, Ct = function(n) {
  return n === "xhr" ? new bn() : n === "beacon" ? new In() : new en();
}, Nn = function(n) {
  return v(void 0, void 0, void 0, function() {
    var e, t, i, s, o, o, a, d, u, c;
    return g(this, function(l) {
      switch (l.label) {
        case 0:
          return [4, new Ue().isEnabled()];
        case 1:
          if (!l.sent() || !n && typeof location > "u")
            return [2, ""];
          for (e = n ?? location.hostname, t = e.split("."), i = [], s = "AMP_TLDTEST", o = t.length - 2; o >= 0; --o)
            i.push(t.slice(o).join("."));
          o = 0, l.label = 2;
        case 2:
          return o < i.length ? (a = i[o], d = { domain: "." + a }, u = new Ue(d), [4, u.set(s, 1)]) : [3, 7];
        case 3:
          return l.sent(), [4, u.get(s)];
        case 4:
          return c = l.sent(), c ? [4, u.remove(s)] : [3, 6];
        case 5:
          return l.sent(), [2, "." + a];
        case 6:
          return o++, [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
}, Wn = function(n, e, t) {
  return e === void 0 && (e = ""), t === void 0 && (t = 10), [ge, e, n.substring(0, t)].filter(Boolean).join("_");
}, et = function(n) {
  var e = n.split(".");
  return e.length <= 2 ? n : e.slice(e.length - 2, e.length).join(".");
}, Vn = function(n) {
  return Object.values(n).every(function(e) {
    return !e;
  });
}, xn = function(n, e, t, i) {
  i === void 0 && (i = !0), n.referrer;
  var s = n.referring_domain, o = Me(n, ["referrer", "referring_domain"]), a = e || {};
  a.referrer;
  var d = a.referring_domain, u = Me(a, ["referrer", "referring_domain"]);
  if (Qn(t.excludeReferrers, n.referring_domain) || !i && Vn(n) && e)
    return !1;
  var c = JSON.stringify(o) !== JSON.stringify(u), l = et(s || "") !== et(d || "");
  return !e || c || l;
}, Qn = function(n, e) {
  return n === void 0 && (n = []), e === void 0 && (e = ""), n.some(function(t) {
    return t instanceof RegExp ? t.test(e) : t === e;
  });
}, Kn = function(n, e) {
  var t = k(k({}, Be), n), i = Object.entries(t).reduce(function(s, o) {
    var a, d = D(o, 2), u = d[0], c = d[1];
    return s.setOnce("initial_".concat(u), (a = c ?? e.initialEmptyValue) !== null && a !== void 0 ? a : "EMPTY"), c ? s.set(u, c) : s.unset(u);
  }, new te());
  return st(i);
}, qn = function(n) {
  var e = n;
  return e ? (e.startsWith(".") && (e = e.substring(1)), [new RegExp("".concat(e.replace(".", "\\."), "$"))]) : [];
}, zn = function(n) {
  var e = this;
  n === void 0 && (n = {});
  var t = {
    name: "@amplitude/plugin-web-attribution-browser",
    type: "before",
    setup: function(i, s) {
      var o;
      return v(this, void 0, void 0, function() {
        var a, d, u, c, l, p, h, y;
        return g(this, function(C) {
          switch (C.label) {
            case 0:
              return a = k({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: !1, excludeReferrers: qn((o = i.cookieOptions) === null || o === void 0 ? void 0 : o.domain) }, n), i.loggerProvider.log("Installing @amplitude/plugin-web-attribution-browser."), d = i.cookieStorage, u = Wn(i.apiKey, "MKTG"), [4, Promise.all([
                new ut().parse(),
                d.get(u)
              ])];
            case 1:
              return c = D.apply(void 0, [C.sent(), 2]), l = c[0], p = c[1], h = lt(i.sessionTimeout, i.lastEventTime), xn(l, p, a, h) && (a.resetSessionOnNewCampaign && (s.setSessionId(Date.now()), i.loggerProvider.log("Created a new session for new campaign.")), i.loggerProvider.log("Tracking attribution."), y = Kn(l, a), s.track(y), d.set(u, l)), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(i) {
      return v(e, void 0, void 0, function() {
        return g(this, function(s) {
          return [2, i];
        });
      });
    }
  };
  return t;
}, Gn = function(n) {
  var e = {};
  for (var t in n) {
    var i = n[t];
    i && (e[t] = i);
  }
  return e;
}, jn = function(n) {
  n === void 0 && (n = {});
  var e, t = x(), i = void 0, s, o, a = function() {
    return v(void 0, void 0, void 0, function() {
      var h, y, C;
      return g(this, function(_) {
        switch (_.label) {
          case 0:
            return o.pageCounter = o.pageCounter ? o.pageCounter + 1 : 1, y = {
              event_type: (C = n.eventType) !== null && C !== void 0 ? C : "[Amplitude] Page Viewed"
            }, h = [{}], [4, Jn()];
          case 1:
            return [2, (y.event_properties = k.apply(void 0, [k.apply(void 0, h.concat([_.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location < "u" && location.hostname || ""
            ), "[Amplitude] Page Location": (
              /* istanbul ignore next */
              typeof location < "u" && location.href || ""
            ), "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location < "u" && location.pathname || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document < "u" && document.title || ""
            ), "[Amplitude] Page URL": (
              /* istanbul ignore next */
              typeof location < "u" && location.href.split("?")[0] || ""
            ), "[Amplitude] Page Counter": o.pageCounter }]), y)];
        }
      });
    });
  }, d = function() {
    return typeof n.trackOn > "u" || typeof n.trackOn == "function" && n.trackOn();
  }, u = typeof location < "u" ? location.href : null, c = function() {
    return v(void 0, void 0, void 0, function() {
      var h, y, C, _;
      return g(this, function(f) {
        switch (f.label) {
          case 0:
            return h = location.href, y = Yn(n.trackHistoryChanges, h, u || "") && d(), u = h, y ? (i == null || i.log("Tracking page view event"), e != null ? [3, 1] : [3, 3]) : [3, 4];
          case 1:
            return _ = (C = e).track, [4, a()];
          case 2:
            _.apply(C, [f.sent()]), f.label = 3;
          case 3:
            f.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, l = function() {
    c();
  }, p = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(h, y) {
      return v(void 0, void 0, void 0, function() {
        var C, _;
        return g(this, function(f) {
          switch (f.label) {
            case 0:
              return e = y, o = h, i = h.loggerProvider, i.log("Installing @amplitude/plugin-page-view-tracking-browser"), t && (t.addEventListener("popstate", l), s = t.history.pushState, t.history.pushState = new Proxy(t.history.pushState, {
                apply: function(w, M, S) {
                  var P = D(S, 3), H = P[0], b = P[1], I = P[2];
                  w.apply(M, [H, b, I]), c();
                }
              })), d() ? (i.log("Tracking page view event"), _ = (C = e).track, [4, a()]) : [3, 2];
            case 1:
              _.apply(C, [f.sent()]), f.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(h) {
      return v(void 0, void 0, void 0, function() {
        var y;
        return g(this, function(C) {
          switch (C.label) {
            case 0:
              return n.trackOn === "attribution" && $n(h) ? (i == null || i.log("Enriching campaign event to page view event with campaign parameters"), [4, a()]) : [3, 2];
            case 1:
              y = C.sent(), h.event_type = y.event_type, h.event_properties = k(k({}, h.event_properties), y.event_properties), C.label = 2;
            case 2:
              return [2, h];
          }
        });
      });
    },
    teardown: function() {
      return v(void 0, void 0, void 0, function() {
        return g(this, function(h) {
          return t && (t.removeEventListener("popstate", l), s && (t.history.pushState = s)), [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return p;
}, Jn = function() {
  return v(void 0, void 0, void 0, function() {
    var n;
    return g(this, function(e) {
      switch (e.label) {
        case 0:
          return n = Gn, [4, new ut().parse()];
        case 1:
          return [2, n.apply(void 0, [e.sent()])];
      }
    });
  });
}, $n = function(n) {
  if (n.event_type === "$identify" && n.user_properties) {
    var e = n.user_properties, t = e[R.SET] || {}, i = e[R.UNSET] || {}, s = W(W([], D(Object.keys(t)), !1), D(Object.keys(i)), !1);
    return Object.keys(Be).every(function(o) {
      return s.includes(o);
    });
  }
  return !1;
}, Yn = function(n, e, t) {
  switch (n) {
    case "pathOnly":
      return e.split("?")[0] !== t.split("?")[0];
    default:
      return e !== t;
  }
}, Zn = function() {
  var n, e = [], t = function(c, l, p) {
    c.addEventListener(l, p), e.push({
      element: c,
      type: l,
      handler: p
    });
  }, i = function() {
    e.forEach(function(c) {
      var l = c.element, p = c.type, h = c.handler;
      l == null || l.removeEventListener(p, h);
    }), e = [];
  }, s = "@amplitude/plugin-form-interaction-tracking-browser", o = "enrichment", a = function(c, l) {
    return v(void 0, void 0, void 0, function() {
      var p, h;
      return g(this, function(y) {
        return l ? typeof document > "u" ? [
          2
          /*return*/
        ] : (p = function(C) {
          var _ = !1;
          t(C, "change", function() {
            var f;
            _ || l.track(Ye, (f = {}, f[Te] = Z(C.id), f[Pe] = Z(C.name), f[Ee] = C.action, f)), _ = !0;
          }), t(C, "submit", function() {
            var f, w;
            _ || l.track(Ye, (f = {}, f[Te] = Z(C.id), f[Pe] = Z(C.name), f[Ee] = C.action, f)), l.track(Tn, (w = {}, w[Te] = Z(C.id), w[Pe] = Z(C.name), w[Ee] = C.action, w)), _ = !1;
          });
        }, h = Array.from(document.getElementsByTagName("form")), h.forEach(p), typeof MutationObserver < "u" && (n = new MutationObserver(function(C) {
          C.forEach(function(_) {
            _.addedNodes.forEach(function(f) {
              f.nodeName === "FORM" && p(f), "querySelectorAll" in f && typeof f.querySelectorAll == "function" && Array.from(f.querySelectorAll("form")).map(p);
            });
          });
        }), n.observe(document.body, {
          subtree: !0,
          childList: !0
        })), [
          2
          /*return*/
        ]) : (c.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked."), [
          2
          /*return*/
        ]);
      });
    });
  }, d = function(c) {
    return v(void 0, void 0, void 0, function() {
      return g(this, function(l) {
        return [2, c];
      });
    });
  }, u = function() {
    return v(void 0, void 0, void 0, function() {
      return g(this, function(c) {
        return n == null || n.disconnect(), i(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: s,
    type: o,
    setup: a,
    execute: d,
    teardown: u
  };
}, Z = function(n) {
  if (typeof n == "string")
    return n;
}, Xn = function() {
  var n, e = [], t = function(c, l, p) {
    c.addEventListener(l, p), e.push({
      element: c,
      type: l,
      handler: p
    });
  }, i = function() {
    e.forEach(function(c) {
      var l = c.element, p = c.type, h = c.handler;
      l == null || l.removeEventListener(p, h);
    }), e = [];
  }, s = "@amplitude/plugin-file-download-tracking-browser", o = "enrichment", a = function(c, l) {
    return v(void 0, void 0, void 0, function() {
      var p, h, y;
      return g(this, function(C) {
        return l ? typeof document > "u" ? [
          2
          /*return*/
        ] : (p = function(_) {
          var f;
          try {
            f = new URL(_.href, window.location.href);
          } catch {
            return;
          }
          var w = h.exec(f.href), M = w == null ? void 0 : w[1];
          M && t(_, "click", function() {
            var S;
            M && l.track(Pn, (S = {}, S[En] = M, S[Fn] = f.pathname, S[Mn] = _.id, S[Rn] = _.text, S[Dn] = _.href, S));
          });
        }, h = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)$/, y = Array.from(document.getElementsByTagName("a")), y.forEach(p), typeof MutationObserver < "u" && (n = new MutationObserver(function(_) {
          _.forEach(function(f) {
            f.addedNodes.forEach(function(w) {
              w.nodeName === "A" && p(w), "querySelectorAll" in w && typeof w.querySelectorAll == "function" && Array.from(w.querySelectorAll("a")).map(p);
            });
          });
        }), n.observe(document.body, {
          subtree: !0,
          childList: !0
        })), [
          2
          /*return*/
        ]) : (c.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked."), [
          2
          /*return*/
        ]);
      });
    });
  }, d = function(c) {
    return v(void 0, void 0, void 0, function() {
      return g(this, function(l) {
        return [2, c];
      });
    });
  }, u = function() {
    return v(void 0, void 0, void 0, function() {
      return g(this, function(c) {
        return n == null || n.disconnect(), i(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: s,
    type: o,
    setup: a,
    execute: d,
    teardown: u
  };
}, tt = !1, er = function(n) {
  if (!(tt || n.defaultTracking !== void 0)) {
    var e = `\`options.defaultTracking\` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to \`options.defaultTracking\`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:

amplitude.init(<YOUR_API_KEY>, {
  defaultTracking: true,
});

Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.`;
    n.loggerProvider.warn(e), tt = !0;
  }
}, tr = function() {
  var n = "@amplitude/plugin-network-checker-browser", e = "before", t = x(), i = [], s = function(u, c) {
    t && (t.addEventListener(u, c), i.push({
      type: u,
      handler: c
    }));
  }, o = function() {
    i.forEach(function(u) {
      var c = u.type, l = u.handler;
      t && t.removeEventListener(c, l);
    }), i = [];
  }, a = function(u, c) {
    return v(void 0, void 0, void 0, function() {
      return g(this, function(l) {
        return u.offline = !navigator.onLine, s("online", function() {
          u.loggerProvider.debug("Network connectivity changed to online."), u.offline = !1, setTimeout(function() {
            c.flush();
          }, u.flushIntervalMillis);
        }), s("offline", function() {
          u.loggerProvider.debug("Network connectivity changed to offline."), u.offline = !0;
        }), [
          2
          /*return*/
        ];
      });
    });
  }, d = function() {
    return v(void 0, void 0, void 0, function() {
      return g(this, function(u) {
        return o(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: n,
    type: e,
    setup: a,
    teardown: d
  };
}, nr = (
  /** @class */
  function(n) {
    $(e, n);
    function e() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return e.prototype.init = function(t, i, s) {
      t === void 0 && (t = "");
      var o, a;
      return arguments.length > 2 ? (o = i, a = s) : typeof i == "string" ? (o = i, a = void 0) : (o = i == null ? void 0 : i.userId, a = i), L(this._init(k(k({}, a), { userId: o, apiKey: t })));
    }, e.prototype._init = function(t) {
      var i, s;
      return v(this, void 0, void 0, function() {
        var o, a, d, u, c = this;
        return g(this, function(l) {
          switch (l.label) {
            case 0:
              return this.initializing ? [
                2
                /*return*/
              ] : (this.initializing = !0, [4, Bn(t.apiKey, t, this)]);
            case 1:
              return o = l.sent(), [4, n.prototype._init.call(this, o)];
            case 2:
              return l.sent(), this.setSessionId((s = (i = t.sessionId) !== null && i !== void 0 ? i : this.config.sessionId) !== null && s !== void 0 ? s : Date.now()), a = oe(t.instanceName), a.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), this.config.offline === Ot ? [3, 4] : [4, this.add(tr()).promise];
            case 3:
              l.sent(), l.label = 4;
            case 4:
              return [4, this.add(new Kt()).promise];
            case 5:
              return l.sent(), [4, this.add(new wn()).promise];
            case 6:
              return l.sent(), [4, this.add(new pn()).promise];
            case 7:
              return l.sent(), er(this.config), vn(this.config.defaultTracking) ? [4, this.add(Xn()).promise] : [3, 9];
            case 8:
              l.sent(), l.label = 9;
            case 9:
              return gn(this.config.defaultTracking) ? [4, this.add(Zn()).promise] : [3, 11];
            case 10:
              l.sent(), l.label = 11;
            case 11:
              return pt(this.config.defaultTracking) ? (d = kn(this.config), u = zn(d), [4, this.add(u).promise]) : [3, 13];
            case 12:
              l.sent(), l.label = 13;
            case 13:
              return ht(this.config.defaultTracking) ? [4, this.add(jn(fn(this.config))).promise] : [3, 15];
            case 14:
              l.sent(), l.label = 15;
            case 15:
              return this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
            case 16:
              return l.sent(), a.eventBridge.setEventReceiver(function(p) {
                c.track(p.eventType, p.eventProperties);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getUserId = function() {
      var t;
      return (t = this.config) === null || t === void 0 ? void 0 : t.userId;
    }, e.prototype.setUserId = function(t) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, t));
        return;
      }
      (t !== this.config.userId || t === void 0) && (this.config.userId = t, dn(t, this.config.instanceName));
    }, e.prototype.getDeviceId = function() {
      var t;
      return (t = this.config) === null || t === void 0 ? void 0 : t.deviceId;
    }, e.prototype.setDeviceId = function(t) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, t));
        return;
      }
      this.config.deviceId = t, ln(t, this.config.instanceName);
    }, e.prototype.reset = function() {
      this.setDeviceId(ae()), this.setUserId(void 0);
    }, e.prototype.getSessionId = function() {
      var t;
      return (t = this.config) === null || t === void 0 ? void 0 : t.sessionId;
    }, e.prototype.setSessionId = function(t) {
      var i;
      if (!this.config) {
        this.q.push(this.setSessionId.bind(this, t));
        return;
      }
      if (t !== this.config.sessionId) {
        var s = this.getSessionId(), o = this.config.lastEventTime, a = (i = this.config.lastEventId) !== null && i !== void 0 ? i : -1;
        this.config.sessionId = t, this.config.lastEventTime = void 0, this.config.pageCounter = 0, Cn(this.config.defaultTracking) && (s && o && this.track(Xe, void 0, {
          device_id: this.previousSessionDeviceId,
          event_id: ++a,
          session_id: s,
          time: o + 1,
          user_id: this.previousSessionUserId
        }), this.config.lastEventTime = this.config.sessionId, this.track(Ze, void 0, {
          event_id: ++a,
          session_id: this.config.sessionId,
          time: this.config.lastEventTime
        })), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId;
      }
    }, e.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    }, e.prototype.setTransport = function(t) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, t));
        return;
      }
      this.config.transportProvider = Ct(t);
    }, e.prototype.identify = function(t, i) {
      if (Ae(t)) {
        var s = t._q;
        t._q = [], t = Ie(new te(), s);
      }
      return i != null && i.user_id && this.setUserId(i.user_id), i != null && i.device_id && this.setDeviceId(i.device_id), n.prototype.identify.call(this, t, i);
    }, e.prototype.groupIdentify = function(t, i, s, o) {
      if (Ae(s)) {
        var a = s._q;
        s._q = [], s = Ie(new te(), a);
      }
      return n.prototype.groupIdentify.call(this, t, i, s, o);
    }, e.prototype.revenue = function(t, i) {
      if (Ae(t)) {
        var s = t._q;
        t._q = [], t = Ie(new Nt(), s);
      }
      return n.prototype.revenue.call(this, t, i);
    }, e.prototype.process = function(t) {
      return v(this, void 0, void 0, function() {
        var i, s;
        return g(this, function(o) {
          return i = Date.now(), s = lt(this.config.sessionTimeout, this.config.lastEventTime), t.event_type !== Ze && t.event_type !== Xe && (!t.session_id || t.session_id === this.getSessionId()) && s && this.setSessionId(i), [2, n.prototype.process.call(this, t)];
        });
      });
    }, e;
  }(Lt)
), ft = function() {
  var n = new nr();
  return {
    init: T(n.init.bind(n), "init", A(n), O(n, ["config"])),
    add: T(n.add.bind(n), "add", A(n), O(n, ["config.apiKey", "timeline.plugins"])),
    remove: T(n.remove.bind(n), "remove", A(n), O(n, ["config.apiKey", "timeline.plugins"])),
    track: T(n.track.bind(n), "track", A(n), O(n, ["config.apiKey", "timeline.queue.length"])),
    logEvent: T(n.logEvent.bind(n), "logEvent", A(n), O(n, ["config.apiKey", "timeline.queue.length"])),
    identify: T(n.identify.bind(n), "identify", A(n), O(n, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: T(n.groupIdentify.bind(n), "groupIdentify", A(n), O(n, ["config.apiKey", "timeline.queue.length"])),
    setGroup: T(n.setGroup.bind(n), "setGroup", A(n), O(n, ["config.apiKey", "timeline.queue.length"])),
    revenue: T(n.revenue.bind(n), "revenue", A(n), O(n, ["config.apiKey", "timeline.queue.length"])),
    flush: T(n.flush.bind(n), "flush", A(n), O(n, ["config.apiKey", "timeline.queue.length"])),
    getUserId: T(n.getUserId.bind(n), "getUserId", A(n), O(n, ["config", "config.userId"])),
    setUserId: T(n.setUserId.bind(n), "setUserId", A(n), O(n, ["config", "config.userId"])),
    getDeviceId: T(n.getDeviceId.bind(n), "getDeviceId", A(n), O(n, ["config", "config.deviceId"])),
    setDeviceId: T(n.setDeviceId.bind(n), "setDeviceId", A(n), O(n, ["config", "config.deviceId"])),
    reset: T(n.reset.bind(n), "reset", A(n), O(n, ["config", "config.userId", "config.deviceId"])),
    getSessionId: T(n.getSessionId.bind(n), "getSessionId", A(n), O(n, ["config"])),
    setSessionId: T(n.setSessionId.bind(n), "setSessionId", A(n), O(n, ["config"])),
    extendSession: T(n.extendSession.bind(n), "extendSession", A(n), O(n, ["config"])),
    setOptOut: T(n.setOptOut.bind(n), "setOptOut", A(n), O(n, ["config"])),
    setTransport: T(n.setTransport.bind(n), "setTransport", A(n), O(n, ["config"]))
  };
};
ft();
const rr = {
  prod: "9697cc8538da787c61338c2f38936f4e",
  stag: "44832403362971771e3b4df598b6c3f2"
}, ir = {
  plan: {
    version: "24",
    branch: "main",
    source: "agent-interface",
    versionId: "7eee25ca-48fe-4d48-a0a3-d3a43e0f6975"
  },
  ingestionMetadata: {
    sourceName: "browser-typescript-ampli",
    sourceVersion: "2.0.0"
  }
};
class vg {
  constructor(e) {
    r(this, "event_type", J.IDENTIFY);
    this.event_properties = e, this.event_properties = e;
  }
}
class sr {
  constructor(e) {
    r(this, "event_type", "Add Agents Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class or {
  constructor() {
    r(this, "event_type", "Agent Copilot Back Button Clicked");
  }
}
class ar {
  constructor(e) {
    r(this, "event_type", "Agent Copilot Dropdown Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class cr {
  constructor(e) {
    r(this, "event_type", "Agent Copilot Improve Writing Improvement Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ur {
  constructor(e) {
    r(this, "event_type", "Agent Copilot Text Insert Below Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class dr {
  constructor(e) {
    r(this, "event_type", "Agent Copilot Text Replace Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class lr {
  constructor(e) {
    r(this, "event_type", "Agent Copilot Translate Message Language Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class pr {
  constructor() {
    r(this, "event_type", "Agent Copilot Undo Clicked");
  }
}
class hr {
  constructor(e) {
    r(this, "event_type", "Analytics Business Hours Schedule Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class vr {
  constructor(e) {
    r(this, "event_type", "Analytics Business Hours Schedule Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class gr {
  constructor(e) {
    r(this, "event_type", "Analytics Chart Granularity Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cr {
  constructor(e) {
    r(this, "event_type", "Analytics Chart Visualization Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class fr {
  constructor(e) {
    r(this, "event_type", "Analytics Compare Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class kr {
  constructor(e) {
    r(this, "event_type", "Analytics Compare Context Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class yr {
  constructor(e) {
    r(this, "event_type", "Analytics Compare Period Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class mr {
  constructor(e) {
    r(this, "event_type", "Analytics Context Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class _r {
  constructor(e) {
    r(this, "event_type", "Analytics Conversation Link Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wr {
  constructor(e) {
    r(this, "event_type", "Analytics Conversation Preview Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sr {
  constructor(e) {
    r(this, "event_type", "Analytics Dashboard Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class br {
  constructor(e) {
    r(this, "event_type", "Analytics Export Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ir {
  constructor(e) {
    r(this, "event_type", "Analytics Export Download Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ar {
  constructor(e) {
    r(this, "event_type", "Analytics Export My Data Button Pressed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Or {
  constructor(e) {
    r(this, "event_type", "Analytics Filter Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tr {
  constructor(e) {
    r(this, "event_type", "Analytics Filter Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pr {
  constructor(e) {
    r(this, "event_type", "Analytics Filter Operator Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Er {
  constructor(e) {
    r(this, "event_type", "Analytics Filter Value Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fr {
  constructor(e) {
    r(this, "event_type", "Analytics Filters Applied");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mr {
  constructor(e) {
    r(this, "event_type", "Analytics Filters Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rr {
  constructor(e) {
    r(this, "event_type", "Analytics Helper Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dr {
  constructor(e) {
    r(this, "event_type", "Analytics In Depth Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ur {
  constructor(e) {
    r(this, "event_type", "Analytics Insights Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hr {
  constructor(e) {
    r(this, "event_type", "Analytics Insights Copy Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Br {
  constructor(e) {
    r(this, "event_type", "Analytics Insights Feedback Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lr {
  constructor(e) {
    r(this, "event_type", "Analytics Insights Prompt Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nr {
  constructor(e) {
    r(this, "event_type", "Analytics Insights Regenerate Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wr {
  constructor(e) {
    r(this, "event_type", "Analytics Period Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vr {
  constructor(e) {
    r(this, "event_type", "Analytics Quick View Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class xr {
  constructor(e) {
    r(this, "event_type", "Analytics Quick View Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qr {
  constructor(e) {
    r(this, "event_type", "Analytics Quick View Duplicated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kr {
  constructor(e) {
    r(this, "event_type", "Analytics Quick View Favorite Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class qr {
  constructor(e) {
    r(this, "event_type", "Analytics Quick View Sharing Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class zr {
  constructor(e) {
    r(this, "event_type", "Analytics Quick View Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gr {
  constructor(e) {
    r(this, "event_type", "Analytics Quick View Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class jr {
  constructor(e) {
    r(this, "event_type", "Analytics Refresh Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jr {
  constructor(e) {
    r(this, "event_type", "Analytics Table Load All Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class $r {
  constructor(e) {
    r(this, "event_type", "Analytics Table Sort Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yr {
  constructor(e) {
    r(this, "event_type", "Analytics Timezone Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zr {
  constructor(e) {
    r(this, "event_type", "Analytics View Conversations Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xr {
  constructor(e) {
    r(this, "event_type", "Auth Failed Init");
    this.event_properties = e, this.event_properties = e;
  }
}
class ei {
  constructor() {
    r(this, "event_type", "Automations Flow Options Menu Option Audit Log Clicked");
  }
}
class ti {
  constructor(e) {
    r(this, "event_type", "Automations Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class ni {
  constructor(e) {
    r(this, "event_type", "Automations Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class ri {
  constructor(e) {
    r(this, "event_type", "Automations Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ii {
  constructor() {
    r(this, "event_type", "Automations Options Menu Opened");
  }
}
class si {
  constructor() {
    r(this, "event_type", "Automations Options Menu Option Delete Clicked");
  }
}
class oi {
  constructor() {
    r(this, "event_type", "Automations Options Menu Option Duplicate Clicked");
  }
}
class ai {
  constructor() {
    r(this, "event_type", "Automations Options Menu Option Flow Clicked");
  }
}
class ci {
  constructor() {
    r(this, "event_type", "Automations Options Menu Option Settings Clicked");
  }
}
class ui {
  constructor() {
    r(this, "event_type", "Automations Pagination Next Clicked");
  }
}
class di {
  constructor() {
    r(this, "event_type", "Automations Pagination Previous Clicked");
  }
}
class li {
  constructor() {
    r(this, "event_type", "Automations Search Applied");
  }
}
class pi {
  constructor() {
    r(this, "event_type", "Automations Search Closed");
  }
}
class hi {
  constructor() {
    r(this, "event_type", "Automations Search Opened");
  }
}
class vi {
  constructor() {
    r(this, "event_type", "Automations Toggled Off");
  }
}
class gi {
  constructor() {
    r(this, "event_type", "Automations Toggled On");
  }
}
class Ci {
  constructor(e) {
    r(this, "event_type", "Bans Ban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class fi {
  constructor() {
    r(this, "event_type", "Bans Unban Ip Clicked");
  }
}
class ki {
  constructor(e) {
    r(this, "event_type", "Bans Unban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class yi {
  constructor(e) {
    r(this, "event_type", "Bulk Actions Update Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class mi {
  constructor(e) {
    r(this, "event_type", "Business Hours Add Schedule Audio Message Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class _i {
  constructor() {
    r(this, "event_type", "Business Hours Add Schedule Button Clicked");
  }
}
class wi {
  constructor(e) {
    r(this, "event_type", "Business Hours Add Schedule Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Si {
  constructor(e) {
    r(this, "event_type", "Business Hours Add Schedule Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class bi {
  constructor() {
    r(this, "event_type", "Business Hours Conflict Notification Button Clicked");
  }
}
class Ii {
  constructor() {
    r(this, "event_type", "Business Hours Conflict Notification Closed");
  }
}
class Ai {
  constructor() {
    r(this, "event_type", "Business Hours Delete Schedule Form Cancelled");
  }
}
class Oi {
  constructor() {
    r(this, "event_type", "Business Hours Delete Schedule Form Submitted");
  }
}
class Ti {
  constructor() {
    r(this, "event_type", "Business Hours Duplicate Schedule Form Cancelled");
  }
}
class Pi {
  constructor() {
    r(this, "event_type", "Business Hours Duplicate Schedule Form Submitted");
  }
}
class Ei {
  constructor(e) {
    r(this, "event_type", "Business Hours First Schedule Modal Question Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fi {
  constructor() {
    r(this, "event_type", "Business Hours First Schedule Support Article Clicked");
  }
}
class Mi {
  constructor() {
    r(this, "event_type", "Business Hours Go To Flow Clicked");
  }
}
class Ri {
  constructor(e) {
    r(this, "event_type", "Business Hours Migration Wizard Audio Message Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class Di {
  constructor() {
    r(this, "event_type", "Business Hours Migration Wizard Create New Schedule Button Clicked");
  }
}
class Ui {
  constructor() {
    r(this, "event_type", "Business Hours Migration Wizard Edit Hours Button Clicked");
  }
}
class Hi {
  constructor(e) {
    r(this, "event_type", "Business Hours Migration Wizard Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bi {
  constructor(e) {
    r(this, "event_type", "Business Hours Migration Wizard Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Li {
  constructor() {
    r(this, "event_type", "Business Hours Migration Wizard Opening Hours Form Cancelled");
  }
}
class Ni {
  constructor() {
    r(this, "event_type", "Business Hours Migration Wizard Opening Hours Form Submitted");
  }
}
class Wi {
  constructor() {
    r(this, "event_type", "Business Hours Migration Wizard Start Update Button Clicked");
  }
}
class Vi {
  constructor() {
    r(this, "event_type", "Business Hours Options Menu Opened");
  }
}
class xi {
  constructor() {
    r(this, "event_type", "Business Hours Options Menu Option Delete Clicked");
  }
}
class Qi {
  constructor() {
    r(this, "event_type", "Business Hours Options Menu Option Duplicate Clicked");
  }
}
class Ki {
  constructor() {
    r(this, "event_type", "Business Hours Options Menu Option Edit Clicked");
  }
}
class qi {
  constructor() {
    r(this, "event_type", "Business Hours Options Menu Option Rename Clicked");
  }
}
class zi {
  constructor() {
    r(this, "event_type", "Business Hours Rename Schedule Form Cancelled");
  }
}
class Gi {
  constructor(e) {
    r(this, "event_type", "Business Hours Rename Schedule Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ji {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Add Exception Button Clicked");
  }
}
class Ji {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Add Exception Form Cancelled");
  }
}
class $i {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Add Exception Form Submitted");
  }
}
class Yi {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Audio Message Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zi {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Audio Message Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xi {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Audio Message Options Menu Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class es {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Audio Message Options Menu Option Clear Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ts {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Audio Message Options Menu Option Record Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ns {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Audio Message Options Menu Option Upload Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class rs {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Auto Reply Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class is {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Auto Reply Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ss {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Auto Reply Options Menu Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class os {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Auto Reply Options Menu Option Add Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class as {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Auto Reply Options Menu Option Clear Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class cs {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Conflict Change Button Clicked");
  }
}
class us {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Conflict Review Button Clicked");
  }
}
class ds {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Delete Exception Form Cancelled");
  }
}
class ls {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Delete Exception Form Submitted");
  }
}
class ps {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Exception Options Menu Option Delete Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class hs {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Import Holiday Form Cancelled");
  }
}
class vs {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Import Holiday Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class gs {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Options Menu Import Holidays Clicked");
  }
}
class Cs {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Options Menu Opened");
  }
}
class fs {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Options Menu Recover Holidays Clicked");
  }
}
class ks {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Options Menu Rename Clicked");
  }
}
class ys {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Options Menu Timezone Clicked");
  }
}
class ms {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Preview Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class _s {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Recover Holidays Form Cancelled");
  }
}
class ws {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Recover Holidays Form Submitted");
  }
}
class Ss {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Review Form Cancelled");
  }
}
class bs {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Review Form Submitted");
  }
}
class Is {
  constructor() {
    r(this, "event_type", "Business Hours Schedule Save Schedule Button Clicked");
  }
}
class As {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule Tab Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Os {
  constructor(e) {
    r(this, "event_type", "Business Hours Schedule View Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ts {
  constructor() {
    r(this, "event_type", "Chat Flow Options Menu Option Audit Log Clicked");
  }
}
class Ps {
  constructor(e) {
    r(this, "event_type", "Chat Form Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Es {
  constructor(e) {
    r(this, "event_type", "Chat Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fs {
  constructor(e) {
    r(this, "event_type", "Chat Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ms {
  constructor() {
    r(this, "event_type", "Chat Options Menu Opened");
  }
}
class Rs {
  constructor() {
    r(this, "event_type", "Chat Options Menu Option Delete Clicked");
  }
}
class Ds {
  constructor() {
    r(this, "event_type", "Chat Options Menu Option Duplicate Clicked");
  }
}
class Us {
  constructor() {
    r(this, "event_type", "Chat Options Menu Option Flow Clicked");
  }
}
class Hs {
  constructor() {
    r(this, "event_type", "Chat Options Menu Option Rename Clicked");
  }
}
class Bs {
  constructor() {
    r(this, "event_type", "Chat Options Menu Option Setup Clicked");
  }
}
class Ls {
  constructor() {
    r(this, "event_type", "Chat Pagination Next Clicked");
  }
}
class Ns {
  constructor() {
    r(this, "event_type", "Chat Pagination Previous Clicked");
  }
}
class Ws {
  constructor() {
    r(this, "event_type", "Chat Search Applied");
  }
}
class Vs {
  constructor() {
    r(this, "event_type", "Chat Search Closed");
  }
}
class xs {
  constructor() {
    r(this, "event_type", "Chat Search Opened");
  }
}
class Qs {
  constructor() {
    r(this, "event_type", "Chatbot Create Modal Opened");
  }
}
class Ks {
  constructor(e) {
    r(this, "event_type", "Chatbot Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class qs {
  constructor() {
    r(this, "event_type", "Chatbot Delete Modal Opened");
  }
}
class zs {
  constructor(e) {
    r(this, "event_type", "Chatbot Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gs {
  constructor() {
    r(this, "event_type", "Chatbot Edit Identity Modal Opened");
  }
}
class js {
  constructor() {
    r(this, "event_type", "Chatbot Identity Edited");
  }
}
class Js {
  constructor(e) {
    r(this, "event_type", "Command Executed");
    this.event_properties = e, this.event_properties = e;
  }
}
class $s {
  constructor(e) {
    r(this, "event_type", "Company Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ys {
  constructor() {
    r(this, "event_type", "Contacts Add New Company Clicked");
  }
}
class Zs {
  constructor() {
    r(this, "event_type", "Contacts Add New Contact Clicked");
  }
}
class Xs {
  constructor(e) {
    r(this, "event_type", "Contacts Ban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class eo {
  constructor() {
    r(this, "event_type", "Contacts Card Actions Menu Opened");
  }
}
class to {
  constructor() {
    r(this, "event_type", "Contacts Card Compose New Email Clicked");
  }
}
class no {
  constructor() {
    r(this, "event_type", "Contacts Card Edit Company Clicked");
  }
}
class ro {
  constructor() {
    r(this, "event_type", "Contacts Card Edit Contact Clicked");
  }
}
class io {
  constructor() {
    r(this, "event_type", "Contacts Card Make Call Clicked");
  }
}
class so {
  constructor() {
    r(this, "event_type", "Contacts Card See All Assigned Conversations Clicked");
  }
}
class oo {
  constructor() {
    r(this, "event_type", "Contacts Card See All Conversations Clicked");
  }
}
class ao {
  constructor() {
    r(this, "event_type", "Contacts Card View Company Clicked");
  }
}
class co {
  constructor() {
    r(this, "event_type", "Contacts Card View User Clicked");
  }
}
class uo {
  constructor() {
    r(this, "event_type", "Contacts Search Blurred");
  }
}
class lo {
  constructor() {
    r(this, "event_type", "Contacts Search Focused");
  }
}
class po {
  constructor(e) {
    r(this, "event_type", "Contacts Unban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ho {
  constructor() {
    r(this, "event_type", "Contacts View Companies");
  }
}
class vo {
  constructor() {
    r(this, "event_type", "Contacts View End Users");
  }
}
class go {
  constructor() {
    r(this, "event_type", "Conversation Actions Menu Opened");
  }
}
class Co {
  constructor(e) {
    r(this, "event_type", "Conversation Actions Menu Option Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class fo {
  constructor() {
    r(this, "event_type", "Conversation Activity Log Closed");
  }
}
class ko {
  constructor() {
    r(this, "event_type", "Conversation Activity Log Flooter Expanded");
  }
}
class yo {
  constructor(e) {
    r(this, "event_type", "Conversation Activity Log Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class mo {
  constructor() {
    r(this, "event_type", "Conversation Attached Image Is Downloaded");
  }
}
class _o {
  constructor() {
    r(this, "event_type", "Conversation Attached Image Is Viewed");
  }
}
class wo {
  constructor(e) {
    r(this, "event_type", "Conversation Claimed");
    this.event_properties = e, this.event_properties = e;
  }
}
class So {
  constructor(e) {
    r(this, "event_type", "Conversation Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class bo {
  constructor() {
    r(this, "event_type", "Conversation Csat Cancelled");
  }
}
class Io {
  constructor() {
    r(this, "event_type", "Conversation Csat Menu Cancel Option Clicked");
  }
}
class Ao {
  constructor(e) {
    r(this, "event_type", "Conversation Csat Menu Language Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Oo {
  constructor() {
    r(this, "event_type", "Conversation Csat Menu Opened");
  }
}
class To {
  constructor(e) {
    r(this, "event_type", "Conversation Follow Up");
    this.event_properties = e, this.event_properties = e;
  }
}
class Po {
  constructor() {
    r(this, "event_type", "Conversation Follow Up Menu Opened");
  }
}
class Eo {
  constructor(e) {
    r(this, "event_type", "Conversation Follow Up Menu Option Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fo {
  constructor() {
    r(this, "event_type", "Conversation Header Conversation Details Menu Opened");
  }
}
class Mo {
  constructor() {
    r(this, "event_type", "Conversation Header More Menu Opened");
  }
}
class Ro {
  constructor(e) {
    r(this, "event_type", "Conversation Header Tag Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class Do {
  constructor(e) {
    r(this, "event_type", "Conversation Header Tag Include Deactivated Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Uo {
  constructor() {
    r(this, "event_type", "Conversation Header Tag Menu Opened");
  }
}
class Ho {
  constructor(e) {
    r(this, "event_type", "Conversation Header Tag Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bo {
  constructor() {
    r(this, "event_type", "Conversation Header Transfer To Agent Item Selected");
  }
}
class Lo {
  constructor() {
    r(this, "event_type", "Conversation Header Transfer To Agent Menu Opened");
  }
}
class No {
  constructor() {
    r(this, "event_type", "Conversation Header Transfer To Number Button Clicked");
  }
}
class Wo {
  constructor(e) {
    r(this, "event_type", "Conversation Header Transfer To Queue Item Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vo {
  constructor() {
    r(this, "event_type", "Conversation Header Transfer To Queue Menu Opened");
  }
}
class xo {
  constructor() {
    r(this, "event_type", "Conversation Internal Note Editor Opened");
  }
}
class Qo {
  constructor(e) {
    r(this, "event_type", "Conversation Offered");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ko {
  constructor(e) {
    r(this, "event_type", "Conversation Replied");
    this.event_properties = e, this.event_properties = e;
  }
}
class qo {
  constructor(e) {
    r(this, "event_type", "Conversation Resolved As A Knowledge Article Draft");
    this.event_properties = e, this.event_properties = e;
  }
}
class zo {
  constructor(e) {
    r(this, "event_type", "Conversation Resolved As A Knowledge Gap");
    this.event_properties = e, this.event_properties = e;
  }
}
class Go {
  constructor(e) {
    r(this, "event_type", "Conversation Resolved By Knowledge");
    this.event_properties = e, this.event_properties = e;
  }
}
class jo {
  constructor(e) {
    r(this, "event_type", "Conversation Resolved With No Knowledge Article");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jo {
  constructor() {
    r(this, "event_type", "Conversation Sidebar Closed");
  }
}
class $o {
  constructor() {
    r(this, "event_type", "Conversation Sidebar Conversation History Closed");
  }
}
class Yo {
  constructor() {
    r(this, "event_type", "Conversation Sidebar Conversation History Navigated To Conversation");
  }
}
class Zo {
  constructor() {
    r(this, "event_type", "Conversation Sidebar Conversation History Opened");
  }
}
class Xo {
  constructor() {
    r(this, "event_type", "Conversation Sidebar Customer Info Email Clicked");
  }
}
class ea {
  constructor() {
    r(this, "event_type", "Conversation Sidebar Customer Info Phone Number Clicked");
  }
}
class ta {
  constructor() {
    r(this, "event_type", "Conversation Sidebar Opened");
  }
}
class na {
  constructor() {
    r(this, "event_type", "Conversation Timeline Item Opened");
  }
}
class ra {
  constructor() {
    r(this, "event_type", "Conversation Timeline Navigated To Conversation");
  }
}
class ia {
  constructor(e) {
    r(this, "event_type", "Conversation Transferred");
    this.event_properties = e, this.event_properties = e;
  }
}
class sa {
  constructor(e) {
    r(this, "event_type", "Conversations Bulk Actions Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class oa {
  constructor() {
    r(this, "event_type", "Conversations Clear All Clicked");
  }
}
class aa {
  constructor(e) {
    r(this, "event_type", "Conversations Filter Agent Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ca {
  constructor() {
    r(this, "event_type", "Conversations Filter Clear All Clicked");
  }
}
class ua {
  constructor(e) {
    r(this, "event_type", "Conversations Filter Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class da {
  constructor(e) {
    r(this, "event_type", "Conversations Filter Contact Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class la {
  constructor(e) {
    r(this, "event_type", "Conversations Filter Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class pa {
  constructor(e) {
    r(this, "event_type", "Conversations Go To Conversation Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ha {
  constructor() {
    r(this, "event_type", "Conversations Item Preview Clicked");
  }
}
class va {
  constructor() {
    r(this, "event_type", "Conversations Next Page Clicked");
  }
}
class ga {
  constructor() {
    r(this, "event_type", "Conversations Previous Page Clicked");
  }
}
class Ca {
  constructor() {
    r(this, "event_type", "Conversations Select All Clicked");
  }
}
class fa {
  constructor(e) {
    r(this, "event_type", "Conversations Select Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ka {
  constructor(e) {
    r(this, "event_type", "Conversations Timestamp Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ya {
  constructor() {
    r(this, "event_type", "Conversations Transfer To Queue Clicked");
  }
}
class ma {
  constructor() {
    r(this, "event_type", "Conversations View Agent Clicked");
  }
}
class _a {
  constructor() {
    r(this, "event_type", "Conversations View Contact Clicked");
  }
}
class wa {
  constructor(e) {
    r(this, "event_type", "ConversationSummaryFeedbackNotUseful");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sa {
  constructor(e) {
    r(this, "event_type", "ConversationSummaryFeedbackUseful");
    this.event_properties = e, this.event_properties = e;
  }
}
class ba {
  constructor(e) {
    r(this, "event_type", "ConversationSummaryRegenerateSummary");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ia {
  constructor() {
    r(this, "event_type", "Copy Script");
  }
}
class Aa {
  constructor() {
    r(this, "event_type", "Country Code Selected");
  }
}
class Oa {
  constructor(e) {
    r(this, "event_type", "Custom Attribute Value Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ta {
  constructor() {
    r(this, "event_type", "Dashboard Back To Old Clicked");
  }
}
class Pa {
  constructor() {
    r(this, "event_type", "Dashboard Global Tv Dashboard Clicked");
  }
}
class Ea {
  constructor(e) {
    r(this, "event_type", "Dashboard Layout Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fa {
  constructor(e) {
    r(this, "event_type", "Dashboard Longest Queued Time Metric Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ma {
  constructor(e) {
    r(this, "event_type", "Dashboard Metric Helper Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ra {
  constructor() {
    r(this, "event_type", "Dashboard Next Page Clicked");
  }
}
class Da {
  constructor() {
    r(this, "event_type", "Dashboard Organization Timezone Settings Clicked");
  }
}
class Ua {
  constructor() {
    r(this, "event_type", "Dashboard Previous Page Clicked");
  }
}
class Ha {
  constructor() {
    r(this, "event_type", "Dashboard Queue All Conversations Clicked");
  }
}
class Ba {
  constructor() {
    r(this, "event_type", "Dashboard Queue Go To Analytics Clicked");
  }
}
class La {
  constructor() {
    r(this, "event_type", "Dashboard Queue Item Clicked");
  }
}
class Na {
  constructor(e) {
    r(this, "event_type", "Dashboard Queue Item Favorite Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wa {
  constructor() {
    r(this, "event_type", "Dashboard Queue Name Clicked");
  }
}
class Va {
  constructor(e) {
    r(this, "event_type", "Dashboard Queue Pending Conversations Metric Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class xa {
  constructor() {
    r(this, "event_type", "Dashboard Queue Settings Clicked");
  }
}
class Qa {
  constructor() {
    r(this, "event_type", "Dashboard Queue Tv Dashboard Clicked");
  }
}
class Ka {
  constructor(e) {
    r(this, "event_type", "Dashboard Queues Manually Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class qa {
  constructor(e) {
    r(this, "event_type", "Dashboard Queues Search Field Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class za {
  constructor(e) {
    r(this, "event_type", "Dashboard Queues Search Field Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ga {
  constructor(e) {
    r(this, "event_type", "Dashboard Queues Sorting Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class ja {
  constructor(e) {
    r(this, "event_type", "Dashboard Queues Type Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ja {
  constructor() {
    r(this, "event_type", "Dashboard Refresh Data Clicked");
  }
}
class $a {
  constructor() {
    r(this, "event_type", "Dashboard Switch To New Clicked");
  }
}
class Ya {
  constructor() {
    r(this, "event_type", "Dashboard Tv Reloaded");
  }
}
class Za {
  constructor(e) {
    r(this, "event_type", "Dashboard Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xa {
  constructor() {
    r(this, "event_type", "Editor QuickResponse Added");
  }
}
class ec {
  constructor() {
    r(this, "event_type", "Email Flow Options Menu Option Audit Log Clicked");
  }
}
class tc {
  constructor(e) {
    r(this, "event_type", "Email Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class nc {
  constructor() {
    r(this, "event_type", "Email Options Menu Opened");
  }
}
class rc {
  constructor() {
    r(this, "event_type", "Email Options Menu Option Delete Clicked");
  }
}
class ic {
  constructor() {
    r(this, "event_type", "Email Options Menu Option Duplicate Clicked");
  }
}
class sc {
  constructor() {
    r(this, "event_type", "Email Options Menu Option Email Clicked");
  }
}
class oc {
  constructor() {
    r(this, "event_type", "Email Options Menu Option Flow Clicked");
  }
}
class ac {
  constructor() {
    r(this, "event_type", "Email Options Menu Option Rename Clicked");
  }
}
class cc {
  constructor() {
    r(this, "event_type", "Email Search Applied");
  }
}
class uc {
  constructor() {
    r(this, "event_type", "Email Search Closed");
  }
}
class dc {
  constructor() {
    r(this, "event_type", "Email Search Opened");
  }
}
class lc {
  constructor(e) {
    r(this, "event_type", "Flow Action Add Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class pc {
  constructor(e) {
    r(this, "event_type", "Flow Action Condition Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class hc {
  constructor(e) {
    r(this, "event_type", "Flow Action Condition Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class vc {
  constructor(e) {
    r(this, "event_type", "Flow Action Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class gc {
  constructor(e) {
    r(this, "event_type", "Flow Action Edit Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cc {
  constructor(e) {
    r(this, "event_type", "Flow Action Edit Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class fc {
  constructor(e) {
    r(this, "event_type", "Flow Activate Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class kc {
  constructor(e) {
    r(this, "event_type", "Flow Add Action Action Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class yc {
  constructor(e) {
    r(this, "event_type", "Flow Add Action Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class mc {
  constructor(e) {
    r(this, "event_type", "Flow Add Action Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class _c {
  constructor(e) {
    r(this, "event_type", "Flow Back To Settings Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wc {
  constructor(e) {
    r(this, "event_type", "Flow Context Align Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sc {
  constructor(e) {
    r(this, "event_type", "Flow Context Delete Cancel Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class bc {
  constructor(e) {
    r(this, "event_type", "Flow Context Delete Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ic {
  constructor(e) {
    r(this, "event_type", "Flow Context Delete Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ac {
  constructor(e) {
    r(this, "event_type", "Flow Context Node Arrange Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Oc {
  constructor() {
    r(this, "event_type", "Flow Phone Number Changed");
  }
}
class Tc {
  constructor(e) {
    r(this, "event_type", "Flow Save Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pc {
  constructor(e) {
    r(this, "event_type", "Flow Title Edit Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ec {
  constructor(e) {
    r(this, "event_type", "Flow Zoom In Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fc {
  constructor(e) {
    r(this, "event_type", "Flow Zoom Out Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mc {
  constructor(e) {
    r(this, "event_type", "Flow Zoom Reset Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rc {
  constructor() {
    r(this, "event_type", "Follow Up Conversation Modal Internal Note Added");
  }
}
class Dc {
  constructor() {
    r(this, "event_type", "Follow Up Conversation Modal Offer In Queue Added");
  }
}
class Uc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Archived");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Changes Discarded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Destroyed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Feedback Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Marked As Helpful");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Moved");
    this.event_properties = e, this.event_properties = e;
  }
}
class xc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Published");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Reordered");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Tag Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class qc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Tag Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class zc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Unpublished");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class jc {
  constructor(e) {
    r(this, "event_type", "Knowledge Article Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jc {
  constructor(e) {
    r(this, "event_type", "Knowledge Articles Search By Term Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class $c {
  constructor(e) {
    r(this, "event_type", "Knowledge Category Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yc {
  constructor(e) {
    r(this, "event_type", "Knowledge Category Destroyed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zc {
  constructor(e) {
    r(this, "event_type", "Knowledge Category Reordered");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xc {
  constructor(e) {
    r(this, "event_type", "Knowledge Category Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class eu {
  constructor(e) {
    r(this, "event_type", "Knowledge Collection Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class tu {
  constructor(e) {
    r(this, "event_type", "Knowledge Collection Destroyed");
    this.event_properties = e, this.event_properties = e;
  }
}
class nu {
  constructor(e) {
    r(this, "event_type", "Knowledge Collection Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class ru {
  constructor(e) {
    r(this, "event_type", "Knowledge Collection Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class iu {
  constructor(e) {
    r(this, "event_type", "Knowledge Help Center Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class su {
  constructor(e) {
    r(this, "event_type", "Knowledge Help Center Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ou {
  constructor(e) {
    r(this, "event_type", "Knowledge Help Center Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class au {
  constructor() {
    r(this, "event_type", "Knowledge Internal Kb Dashboard Viewed");
  }
}
class cu {
  constructor(e) {
    r(this, "event_type", "Knowledge Internal Kb Search Result Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class uu {
  constructor(e) {
    r(this, "event_type", "Knowledge Resolution Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class du {
  constructor(e) {
    r(this, "event_type", "Knowledge Resolution Initialised");
    this.event_properties = e, this.event_properties = e;
  }
}
class lu {
  constructor() {
    r(this, "event_type", "Merge Contacts Merge Cancelled");
  }
}
class pu {
  constructor() {
    r(this, "event_type", "Merge Contacts Merge Failed");
  }
}
class hu {
  constructor(e) {
    r(this, "event_type", "Merge Contacts Merge Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class vu {
  constructor() {
    r(this, "event_type", "Merge Contacts Modal Closed");
  }
}
class gu {
  constructor() {
    r(this, "event_type", "Merge Contacts Modal Opened");
  }
}
class Cu {
  constructor() {
    r(this, "event_type", "Merge Contacts Source Contact Selected");
  }
}
class fu {
  constructor() {
    r(this, "event_type", "Messenger Flow Options Menu Option Audit Log Clicked");
  }
}
class ku {
  constructor(e) {
    r(this, "event_type", "Messenger Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class yu {
  constructor(e) {
    r(this, "event_type", "Messenger Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class mu {
  constructor(e) {
    r(this, "event_type", "Messenger Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class _u {
  constructor() {
    r(this, "event_type", "Messenger Options Menu Opened");
  }
}
class wu {
  constructor(e) {
    r(this, "event_type", "Messenger Options Menu Option Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Su {
  constructor() {
    r(this, "event_type", "Modal Conversation Close Cancel Clicked");
  }
}
class bu {
  constructor(e) {
    r(this, "event_type", "Modal Conversation Close Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Iu {
  constructor() {
    r(this, "event_type", "Modal Transfer To Queue Cancel Clicked");
  }
}
class Au {
  constructor(e) {
    r(this, "event_type", "Modal Transfer To Queue Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ou {
  constructor(e) {
    r(this, "event_type", "Network Connection Status Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tu {
  constructor(e) {
    r(this, "event_type", "Notification Offer Accepted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pu {
  constructor(e) {
    r(this, "event_type", "Notification Offer Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Eu {
  constructor(e) {
    r(this, "event_type", "Notification Offer Rejected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fu {
  constructor() {
    r(this, "event_type", "Notification Offer Timeout");
  }
}
class Mu {
  constructor(e) {
    r(this, "event_type", "Notification Transfer Offer Accepted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ru {
  constructor(e) {
    r(this, "event_type", "Notification Transfer Offer Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Du {
  constructor(e) {
    r(this, "event_type", "Notification Transfer Offer Rejected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Uu {
  constructor() {
    r(this, "event_type", "Notification Transfer Offer Timeout");
  }
}
class Hu {
  constructor(e) {
    r(this, "event_type", "Organizations Navigation Organization Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Create New Issue Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Create New Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Create New Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Link Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Unlink All Issues Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class xu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Unlink All Issues Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Unlink All Issues Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ku {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Unlink Issue Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class qu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Unlink Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class zu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github Unlink Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Github View Link Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ju {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Comments Collapsed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ju {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Comments Expanded");
    this.event_properties = e, this.event_properties = e;
  }
}
class $u {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Link Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Open Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Open Jira Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xu {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Remove All Dangling Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ed {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Remove Dangling Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class td {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Unlink All Issues Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class nd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Unlink All Issues Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class rd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Unlink All Issues Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class id {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Unlink Issue Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class sd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Unlink Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class od {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Jira Unlink Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class ad {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Messages Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class cd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class ud {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class dd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Subscription To Channel Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ld {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Subscription To Channel Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class pd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Subscription To Channel Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class hd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Unsubscribe Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class vd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Unsubscribe Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class gd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Klaviyo Profile Unsubscribe Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Linear Create New Issue Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class fd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Linear Create New Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class kd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Linear Create New Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class yd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Linear Link Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class md {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Linear Open Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class _d {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Linear Open Linear Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Linear Unlink Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings Create Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class bd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings Overview Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Id {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings Overview Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ad {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings View Delete Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Od {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings View Delete Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Td {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings View Delete Requested");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings View OAuth Started");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ed {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings View OAuth Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Settings View Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Md {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Collapse Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Collapse Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ud {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Edit Shipping Address Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Refund Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ld {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Refund Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order Refund Requested");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Order View Order In Shopify Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class xd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget Refreshed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Shopify Widget View Customer In Shopify Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Channel Subscription Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class qd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Channel Subscription Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class zd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Channel Subscription Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Channel Unsubscription Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class jd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Channel Unsubscription Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Channel Unsubscription Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class $d {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Message External Link Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Messages Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Profile Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xd {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Voyado Widget Transactions Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class el {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Widget Collapse Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class tl {
  constructor(e) {
    r(this, "event_type", "Partner Integrations Widget Collapse Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class nl {
  constructor() {
    r(this, "event_type", "Partner Integrations Widget LoyaltyLion Add Points Failed");
  }
}
class rl {
  constructor() {
    r(this, "event_type", "Partner Integrations Widget LoyaltyLion Add Points Succeeded");
  }
}
class il {
  constructor() {
    r(this, "event_type", "Partner Integrations Widget LoyaltyLion Customer Received");
  }
}
class sl {
  constructor() {
    r(this, "event_type", "Partner Integrations Widget LoyaltyLion Remove Points Failed");
  }
}
class ol {
  constructor() {
    r(this, "event_type", "Partner Integrations Widget LoyaltyLion Remove Points Succeeded");
  }
}
class al {
  constructor() {
    r(this, "event_type", "Phone Actions Menu Action Add Outbound Caller ID Clicked");
  }
}
class cl {
  constructor() {
    r(this, "event_type", "Phone Actions Menu Action Change Hold Music Clicked");
  }
}
class ul {
  constructor() {
    r(this, "event_type", "Phone Actions Menu Opened");
  }
}
class dl {
  constructor() {
    r(this, "event_type", "Phone Add Outbound Caller ID Form Cancelled");
  }
}
class ll {
  constructor() {
    r(this, "event_type", "Phone Add Outbound Caller ID Form Submitted");
  }
}
class pl {
  constructor() {
    r(this, "event_type", "Phone Change Hold Music Form Cancelled");
  }
}
class hl {
  constructor() {
    r(this, "event_type", "Phone Change Hold Music Form Submitted");
  }
}
class vl {
  constructor() {
    r(this, "event_type", "Phone Create Flow Form Cancelled");
  }
}
class gl {
  constructor() {
    r(this, "event_type", "Phone Create Flow Form Submitted");
  }
}
class Cl {
  constructor() {
    r(this, "event_type", "Phone Flow Options Menu Option Audit Log Clicked");
  }
}
class fl {
  constructor() {
    r(this, "event_type", "Phone Flow Options Menu Option Delete Clicked");
  }
}
class kl {
  constructor() {
    r(this, "event_type", "Phone Flow Options Menu Option Duplicate Clicked");
  }
}
class yl {
  constructor() {
    r(this, "event_type", "Phone Flow Options Menu Option Edit Clicked");
  }
}
class ml {
  constructor() {
    r(this, "event_type", "Phone Flow Options Menu Option Move To Another Number Clicked");
  }
}
class _l {
  constructor() {
    r(this, "event_type", "Phone Flow Options Menu Option Opened");
  }
}
class wl {
  constructor() {
    r(this, "event_type", "Phone Flow Options Menu Option Rename Clicked");
  }
}
class Sl {
  constructor() {
    r(this, "event_type", "Phone Form Cancelled");
  }
}
class bl {
  constructor() {
    r(this, "event_type", "Phone Form Opened");
  }
}
class Il {
  constructor() {
    r(this, "event_type", "Phone Form Submitted");
  }
}
class Al {
  constructor() {
    r(this, "event_type", "Phone Options Menu Opened");
  }
}
class Ol {
  constructor() {
    r(this, "event_type", "Phone Options Menu Option Create Flow Clicked");
  }
}
class Tl {
  constructor() {
    r(this, "event_type", "Phone Options Menu Option Edit Clicked");
  }
}
class Pl {
  constructor() {
    r(this, "event_type", "Phone Options Menu Option Remove Number Clicked");
  }
}
class El {
  constructor() {
    r(this, "event_type", "Phone Options Menu Option Set Default Caller ID Clicked");
  }
}
class Fl {
  constructor() {
    r(this, "event_type", "Phone Options Menu Option Setup Clicked");
  }
}
class Ml {
  constructor(e) {
    r(this, "event_type", "Phone Recording Downloaded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rl {
  constructor(e) {
    r(this, "event_type", "Phone Recording Pause Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dl {
  constructor(e) {
    r(this, "event_type", "Phone Recording Play Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ul {
  constructor(e) {
    r(this, "event_type", "Phone Recording Playback Abandoned");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hl {
  constructor(e) {
    r(this, "event_type", "Phone Recording Playback Ended");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bl {
  constructor() {
    r(this, "event_type", "Phone Search Applied");
  }
}
class Ll {
  constructor(e) {
    r(this, "event_type", "Presence Media Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nl {
  constructor(e) {
    r(this, "event_type", "Presence Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wl {
  constructor(e) {
    r(this, "event_type", "Push Notification Platform Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vl {
  constructor(e) {
    r(this, "event_type", "Push Notification Platform Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class xl {
  constructor(e) {
    r(this, "event_type", "Push Notification Platform Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ql {
  constructor() {
    r(this, "event_type", "Saved Search Applied");
  }
}
class Kl {
  constructor() {
    r(this, "event_type", "Saved Search Closed");
  }
}
class ql {
  constructor(e) {
    r(this, "event_type", "Saved Search Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class zl {
  constructor() {
    r(this, "event_type", "Saved Search Deleted");
  }
}
class Gl {
  constructor() {
    r(this, "event_type", "Saved Search Updated");
  }
}
class jl {
  constructor() {
    r(this, "event_type", "Scheduled Conversations Csv Import Clicked");
  }
}
class Jl {
  constructor() {
    r(this, "event_type", "Scheduled Conversations Csv Imported");
  }
}
class $l {
  constructor(e) {
    r(this, "event_type", "Search Contact Preview Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yl {
  constructor(e) {
    r(this, "event_type", "Search Contact Preview Go To Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zl {
  constructor(e) {
    r(this, "event_type", "Search Contact Preview Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xl {
  constructor(e) {
    r(this, "event_type", "Search Contact Type Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class ep {
  constructor() {
    r(this, "event_type", "Search Conversation Preview Closed");
  }
}
class tp {
  constructor(e) {
    r(this, "event_type", "Search Conversation Preview Go To Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class np {
  constructor(e) {
    r(this, "event_type", "Search Conversation Preview Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class rp {
  constructor(e) {
    r(this, "event_type", "Search Field Blurred");
    this.event_properties = e, this.event_properties = e;
  }
}
class ip {
  constructor(e) {
    r(this, "event_type", "Search Field Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class sp {
  constructor(e) {
    r(this, "event_type", "Search Field Focused");
    this.event_properties = e, this.event_properties = e;
  }
}
class op {
  constructor(e) {
    r(this, "event_type", "Search Field Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ap {
  constructor(e) {
    r(this, "event_type", "Search Filter Condition Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class cp {
  constructor(e) {
    r(this, "event_type", "Search Filter Condition Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class up {
  constructor(e) {
    r(this, "event_type", "Search Filter Operator Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class dp {
  constructor(e) {
    r(this, "event_type", "Search Filter Strategy Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class lp {
  constructor(e) {
    r(this, "event_type", "Search Filter Value Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class pp {
  constructor(e) {
    r(this, "event_type", "Search Filter Value Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class hp {
  constructor(e) {
    r(this, "event_type", "Search Filters Applied");
    this.event_properties = e, this.event_properties = e;
  }
}
class vp {
  constructor(e) {
    r(this, "event_type", "Search Filters Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class gp {
  constructor(e) {
    r(this, "event_type", "Search Filters Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cp {
  constructor(e) {
    r(this, "event_type", "Search Filters Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class fp {
  constructor(e) {
    r(this, "event_type", "Search Filters Validation Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class kp {
  constructor() {
    r(this, "event_type", "Search Note Preview Closed");
  }
}
class yp {
  constructor() {
    r(this, "event_type", "Search Note Preview Go To Clicked");
  }
}
class mp {
  constructor() {
    r(this, "event_type", "Search Note Preview Opened");
  }
}
class _p {
  constructor(e) {
    r(this, "event_type", "Search Sorting Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class wp {
  constructor(e) {
    r(this, "event_type", "Search Strict Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sp {
  constructor(e) {
    r(this, "event_type", "Search Tab Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class bp {
  constructor() {
    r(this, "event_type", "Settings Agents Add Agent Button Clicked");
  }
}
class Ip {
  constructor() {
    r(this, "event_type", "Settings Agents Edit Button Clicked");
  }
}
class Ap {
  constructor(e) {
    r(this, "event_type", "Settings Agents Tab Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Op {
  constructor(e) {
    r(this, "event_type", "Settings Agents Workloads Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tp {
  constructor(e) {
    r(this, "event_type", "Settings Audio Delete Cancel Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pp {
  constructor(e) {
    r(this, "event_type", "Settings Audio Delete Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ep {
  constructor(e) {
    r(this, "event_type", "Settings Audio Delete Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fp {
  constructor(e) {
    r(this, "event_type", "Settings Audio Upload Wait Music");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mp {
  constructor(e) {
    r(this, "event_type", "Settings Audio Usage Flow Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rp {
  constructor(e) {
    r(this, "event_type", "Settings Audio Usage Link Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dp {
  constructor(e) {
    r(this, "event_type", "Settings Commands Assign Keybindings");
    this.event_properties = e, this.event_properties = e;
  }
}
class Up {
  constructor() {
    r(this, "event_type", "Settings Commands Reset All Keybindings");
  }
}
class Hp {
  constructor(e) {
    r(this, "event_type", "Settings Commands Reset Keybindings");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bp {
  constructor() {
    r(this, "event_type", "Settings Commands Unassign All Keybindings");
  }
}
class Lp {
  constructor(e) {
    r(this, "event_type", "Settings Commands Unassign Keybindings");
    this.event_properties = e, this.event_properties = e;
  }
}
class Np {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Activated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wp {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Add New Attribute Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vp {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Archived");
    this.event_properties = e, this.event_properties = e;
  }
}
class xp {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qp {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Deactivated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kp {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Reordered");
    this.event_properties = e, this.event_properties = e;
  }
}
class qp {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Unarchived");
    this.event_properties = e, this.event_properties = e;
  }
}
class zp {
  constructor(e) {
    r(this, "event_type", "Settings Custom Attribute Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gp {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Api Tokens Add Confirm");
    this.event_properties = e, this.event_properties = e;
  }
}
class jp {
  constructor() {
    r(this, "event_type", "Settings Integrations Api Tokens Copy");
  }
}
class Jp {
  constructor() {
    r(this, "event_type", "Settings Integrations Api Tokens Documentation Link Integrations Api");
  }
}
class $p {
  constructor() {
    r(this, "event_type", "Settings Integrations Api Tokens Remove");
  }
}
class Yp {
  constructor() {
    r(this, "event_type", "Settings Integrations Api Tokens Remove Cancel");
  }
}
class Zp {
  constructor() {
    r(this, "event_type", "Settings Integrations Api Tokens Remove Confirm");
  }
}
class Xp {
  constructor() {
    r(this, "event_type", "Settings Integrations Api Tokens View");
  }
}
class eh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Edit Save");
    this.event_properties = e, this.event_properties = e;
  }
}
class th {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Edit Test");
    this.event_properties = e, this.event_properties = e;
  }
}
class nh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Listing Add Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class rh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Listing Edit Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class ih {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Listing Remove Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class sh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Listing Remove Card Cancel");
    this.event_properties = e, this.event_properties = e;
  }
}
class oh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Listing Remove Card Confirm");
    this.event_properties = e, this.event_properties = e;
  }
}
class ah {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Listing Test Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class ch {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Read Documentation");
    this.event_properties = e, this.event_properties = e;
  }
}
class uh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Test");
    this.event_properties = e, this.event_properties = e;
  }
}
class dh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Test Add Parameter");
    this.event_properties = e, this.event_properties = e;
  }
}
class lh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Card Test Remove Parameter");
    this.event_properties = e, this.event_properties = e;
  }
}
class ph {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Custom Card Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class hh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Custom Card Edited");
    this.event_properties = e, this.event_properties = e;
  }
}
class vh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Custom Card Oauth Provider Authentication Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class gh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Custom Card Oauth Provider Authentication Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ch {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Custom Card Oauth Provider Authentication Timed Out");
    this.event_properties = e, this.event_properties = e;
  }
}
class fh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Custom Card Oauth Provider Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class kh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Custom Card Oauth Provider Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class yh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class mh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Webform Endpoints Add Save");
    this.event_properties = e, this.event_properties = e;
  }
}
class _h {
  constructor() {
    r(this, "event_type", "Settings Integrations Webform Endpoints Copy");
  }
}
class wh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webform Endpoints Read Documentation Link");
  }
}
class Sh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Webform Endpoints Remove");
    this.event_properties = e, this.event_properties = e;
  }
}
class bh {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Webform Endpoints Remove Cancel");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ih {
  constructor(e) {
    r(this, "event_type", "Settings Integrations Webform Endpoints Remove Confirm");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ah {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Add");
  }
}
class Oh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Add Confirm");
  }
}
class Th {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Documentation Link Clicked");
  }
}
class Ph {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Edit");
  }
}
class Eh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Edit Save");
  }
}
class Fh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Enabled Off");
  }
}
class Mh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Enabled On");
  }
}
class Rh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Remove");
  }
}
class Dh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Remove Cancel");
  }
}
class Uh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks Remove Confirm");
  }
}
class Hh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks View");
  }
}
class Bh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks View Copy Secret");
  }
}
class Lh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks View Copy Url");
  }
}
class Nh {
  constructor() {
    r(this, "event_type", "Settings Integrations Webhooks View Edit");
  }
}
class Wh {
  constructor(e) {
    r(this, "event_type", "Settings Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vh {
  constructor() {
    r(this, "event_type", "Settings Organization Form Submitted");
  }
}
class xh {
  constructor() {
    r(this, "event_type", "Settings Organization Logo Changed");
  }
}
class Qh {
  constructor(e) {
    r(this, "event_type", "Settings Profile Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kh {
  constructor(e) {
    r(this, "event_type", "Settings Queue Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class qh {
  constructor() {
    r(this, "event_type", "Settings Queue Agent Deleted");
  }
}
class zh {
  constructor() {
    r(this, "event_type", "Settings Queue Agent Search Submitted");
  }
}
class Gh {
  constructor(e) {
    r(this, "event_type", "Settings Queue Agent Sorted");
    this.event_properties = e, this.event_properties = e;
  }
}
class jh {
  constructor(e) {
    r(this, "event_type", "Settings Queue Alerts Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jh {
  constructor(e) {
    r(this, "event_type", "Settings Queue Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class $h {
  constructor() {
    r(this, "event_type", "Settings Queue Teams Add Team Button Clicked");
  }
}
class Yh {
  constructor() {
    r(this, "event_type", "Settings Queue Teams Add Team Form Submitted");
  }
}
class Zh {
  constructor() {
    r(this, "event_type", "Settings Queue Teams Delete Team Button Clicked");
  }
}
class Xh {
  constructor() {
    r(this, "event_type", "Settings Queues Add Queue Clicked");
  }
}
class ev {
  constructor(e) {
    r(this, "event_type", "Settings Queues Archive Queue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class tv {
  constructor() {
    r(this, "event_type", "Settings Queues Edit Queue Clicked");
  }
}
class nv {
  constructor() {
    r(this, "event_type", "Settings Queues Unarchive Queue Clicked");
  }
}
class rv {
  constructor(e) {
    r(this, "event_type", "Settings Roles Custom Role Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class iv {
  constructor() {
    r(this, "event_type", "Settings Roles Custom Role Deleted");
  }
}
class sv {
  constructor(e) {
    r(this, "event_type", "Settings Roles Custom Role Edited");
    this.event_properties = e, this.event_properties = e;
  }
}
class ov {
  constructor(e) {
    r(this, "event_type", "Settings Roles User Unassigned");
    this.event_properties = e, this.event_properties = e;
  }
}
class av {
  constructor(e) {
    r(this, "event_type", "Settings Roles Users Assigned");
    this.event_properties = e, this.event_properties = e;
  }
}
class cv {
  constructor() {
    r(this, "event_type", "Settings Summarization Save Changes Clicked");
  }
}
class uv {
  constructor(e) {
    r(this, "event_type", "Settings Summarization Show Automatically Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class dv {
  constructor(e) {
    r(this, "event_type", "Settings Summarization Show On Demand Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class lv {
  constructor() {
    r(this, "event_type", "Settings Tags Add Tag Button Clicked");
  }
}
class pv {
  constructor(e) {
    r(this, "event_type", "Settings Tags Tag Activated");
    this.event_properties = e, this.event_properties = e;
  }
}
class hv {
  constructor(e) {
    r(this, "event_type", "Settings Tags Tag Deactivated");
    this.event_properties = e, this.event_properties = e;
  }
}
class vv {
  constructor() {
    r(this, "event_type", "Settings Team Add Team Button Clicked");
  }
}
class gv {
  constructor() {
    r(this, "event_type", "Settings Team Details Add Agents Button Clicked");
  }
}
class Cv {
  constructor() {
    r(this, "event_type", "Settings Team Edit Team Button Clicked");
  }
}
class fv {
  constructor(e) {
    r(this, "event_type", "Settings Team Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class kv {
  constructor() {
    r(this, "event_type", "Settings Team Remove Team Button Clicked");
  }
}
class yv {
  constructor() {
    r(this, "event_type", "Settings Team Remove Team Confirmed");
  }
}
class mv {
  constructor(e) {
    r(this, "event_type", "Settings Templates Add Template Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class _v {
  constructor(e) {
    r(this, "event_type", "Settings Templates Edit Template Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wv {
  constructor(e) {
    r(this, "event_type", "Settings Templates Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sv {
  constructor(e) {
    r(this, "event_type", "Settings Templates Remove Template Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class bv {
  constructor(e) {
    r(this, "event_type", "Settings Templates Remove Template Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Iv {
  constructor(e) {
    r(this, "event_type", "Settings Templates Tab Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Av {
  constructor() {
    r(this, "event_type", "Shared Worker Tab Or Window Changed");
  }
}
class Ov {
  constructor(e) {
    r(this, "event_type", "Shared Worker Tab Or Window Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tv {
  constructor(e) {
    r(this, "event_type", "Shared Worker Tab Or Window Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pv {
  constructor() {
    r(this, "event_type", "Sidebar Add Agent Button Clicked");
  }
}
class Ev {
  constructor() {
    r(this, "event_type", "Sidebar Collapsed");
  }
}
class Fv {
  constructor() {
    r(this, "event_type", "Sidebar Expanded");
  }
}
class Mv {
  constructor(e) {
    r(this, "event_type", "Sidebar Nav Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rv {
  constructor() {
    r(this, "event_type", "Sign Out Aborted");
  }
}
class Dv {
  constructor() {
    r(this, "event_type", "Sign Out Confirmed");
  }
}
class Uv {
  constructor(e) {
    r(this, "event_type", "Simultaneous Ring Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hv {
  constructor(e) {
    r(this, "event_type", "Smart Conversation Reply Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bv {
  constructor(e) {
    r(this, "event_type", "Tag Select Create New Tag Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lv {
  constructor(e) {
    r(this, "event_type", "Tags Create Modal Color Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nv {
  constructor(e) {
    r(this, "event_type", "Tags Create Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wv {
  constructor(e) {
    r(this, "event_type", "Tags Create Modal Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vv {
  constructor(e) {
    r(this, "event_type", "Team Agent Actions Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class xv {
  constructor() {
    r(this, "event_type", "Team Agent Actions Menu Opened");
  }
}
class Qv {
  constructor() {
    r(this, "event_type", "Team Agent Collapsed");
  }
}
class Kv {
  constructor() {
    r(this, "event_type", "Team Agent Expanded");
  }
}
class qv {
  constructor() {
    r(this, "event_type", "Team Assigned Agents Only Clicked");
  }
}
class zv {
  constructor(e) {
    r(this, "event_type", "Team Conversation Actions Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gv {
  constructor() {
    r(this, "event_type", "Team Conversation Actions Menu Opened");
  }
}
class jv {
  constructor() {
    r(this, "event_type", "Team Conversation Status Link Clicked");
  }
}
class Jv {
  constructor() {
    r(this, "event_type", "Team Conversation Title Link Clicked");
  }
}
class $v {
  constructor(e) {
    r(this, "event_type", "Team Favorite Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yv {
  constructor(e) {
    r(this, "event_type", "Team Filter Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zv {
  constructor() {
    r(this, "event_type", "Team Filter Menu Opened");
  }
}
class Xv {
  constructor() {
    r(this, "event_type", "Team Next Page Clicked");
  }
}
class eg {
  constructor() {
    r(this, "event_type", "Team Previous Page Clicked");
  }
}
class tg {
  constructor() {
    r(this, "event_type", "Topbar Beamer Opened");
  }
}
class ng {
  constructor() {
    r(this, "event_type", "Topbar Email Opened");
  }
}
class rg {
  constructor() {
    r(this, "event_type", "Topbar Notifications Opened");
  }
}
class ig {
  constructor() {
    r(this, "event_type", "Topbar Phones Opened");
  }
}
class sg {
  constructor() {
    r(this, "event_type", "Topbar Support Opened");
  }
}
class og {
  constructor(e) {
    r(this, "event_type", "User Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ag {
  constructor(e) {
    r(this, "event_type", "Websocket Active Connection Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class cg {
  constructor(e) {
    r(this, "event_type", "Websocket Close Event Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class ug {
  constructor(e) {
    r(this, "event_type", "Websocket Connection Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class dg {
  constructor(e) {
    r(this, "event_type", "Websocket Connection Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class lg {
  constructor(e) {
    r(this, "event_type", "Websocket Reconnect Attempt Started");
    this.event_properties = e, this.event_properties = e;
  }
}
const se = () => ({ promise: Promise.resolve() });
class pg {
  constructor() {
    r(this, "disabled", !1);
    r(this, "amplitude");
  }
  get client() {
    return this.isInitializedAndEnabled(), this.amplitude;
  }
  get isLoaded() {
    return this.amplitude != null;
  }
  isInitializedAndEnabled() {
    return this.amplitude ? !this.disabled : (console.error("ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?"), !1);
  }
  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(e) {
    if (this.disabled = e.disabled ?? !1, this.amplitude)
      return console.warn("WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup."), se();
    let t = null;
    if (e.client && "apiKey" in e.client ? t = e.client.apiKey : "environment" in e && (t = rr[e.environment]), e.client && "instance" in e.client)
      this.amplitude = e.client.instance;
    else if (t) {
      this.amplitude = ft();
      const i = e.client && "configuration" in e.client ? e.client.configuration : {};
      return this.amplitude.init(t, void 0, { ...ir, ...i });
    } else
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    return se();
  }
  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(e, t, i) {
    if (!this.isInitializedAndEnabled())
      return se();
    e && (i = { ...i, user_id: e });
    const s = new te(), o = t;
    if (o != null)
      for (const [a, d] of Object.entries(o))
        s.set(a, d);
    return this.amplitude.identify(
      s,
      i
    );
  }
  /**
   * Flush the event.
   */
  flush() {
    return this.isInitializedAndEnabled() ? this.amplitude.flush() : se();
  }
  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(e, t) {
    return this.isInitializedAndEnabled() ? this.amplitude.track(e, void 0, t) : se();
  }
  /**
   * Add Agents Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Add%20Agents%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on Add agents modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. addTo)
   * @param options Amplitude event options.
   */
  addAgentsModalFormSubmitted(e, t) {
    return this.track(new sr(e), t);
  }
  /**
   * Agent Copilot Back Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Back%20Button%20Clicked)
   *
   * When the user clicks the back button in Agent Copilot
   *
   * @param options Amplitude event options.
   */
  agentCopilotBackButtonClicked(e) {
    return this.track(new or(), e);
  }
  /**
   * Agent Copilot Dropdown Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Dropdown%20Item%20Clicked)
   *
   * When the user clicks an items from the Agent Copilot dropdown in the reply area.
   *
   * @param properties The event's properties (e.g. key)
   * @param options Amplitude event options.
   */
  agentCopilotDropdownItemClicked(e, t) {
    return this.track(new ar(e), t);
  }
  /**
   * Agent Copilot Improve Writing Improvement Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Improve%20Writing%20Improvement%20Clicked)
   *
   * When the user selects a writing improvement option
   *
   * @param properties The event's properties (e.g. improvement)
   * @param options Amplitude event options.
   */
  agentCopilotImproveWritingImprovementClicked(e, t) {
    return this.track(new cr(e), t);
  }
  /**
   * Agent Copilot Text Insert Below Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Text%20Insert%20Below%20Clicked)
   *
   * When the user clicks the Replace Text action in a copilot action.
   *
   * @param properties The event's properties (e.g. key)
   * @param options Amplitude event options.
   */
  agentCopilotTextInsertBelowClicked(e, t) {
    return this.track(new ur(e), t);
  }
  /**
   * Agent Copilot Text Replace Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Text%20Replace%20Clicked)
   *
   * When the user clicks the Insert Below action in a copilot action.
   *
   * @param properties The event's properties (e.g. key)
   * @param options Amplitude event options.
   */
  agentCopilotTextReplaceClicked(e, t) {
    return this.track(new dr(e), t);
  }
  /**
   * Agent Copilot Translate Message Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Translate%20Message%20Language%20Selected)
   *
   * When the user selects a language to translate a message to.
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  agentCopilotTranslateMessageLanguageSelected(e, t) {
    return this.track(new lr(e), t);
  }
  /**
   * Agent Copilot Undo Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Undo%20Clicked)
   *
   * When the user clicks the undo button in Agent Copilot
   *
   * @param options Amplitude event options.
   */
  agentCopilotUndoClicked(e) {
    return this.track(new pr(), e);
  }
  /**
   * Analytics Business Hours Schedule Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Business%20Hours%20Schedule%20Removed)
   *
   * When the user selects a business hours schedule filter on a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsBusinessHoursScheduleRemoved(e, t) {
    return this.track(new hr(e), t);
  }
  /**
   * Analytics Business Hours Schedule Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Business%20Hours%20Schedule%20Updated)
   *
   * When the user removes a business hours schedule filter on a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsBusinessHoursScheduleUpdated(e, t) {
    return this.track(new vr(e), t);
  }
  /**
   * Analytics Chart Granularity Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Chart%20Granularity%20Changed)
   *
   * When the user changes the granularity of a chart
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsChartGranularityChanged(e, t) {
    return this.track(new gr(e), t);
  }
  /**
   * Analytics Chart Visualization Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Chart%20Visualization%20Changed)
   *
   * When the user changes the visualization of a chart
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsChartVisualizationChanged(e, t) {
    return this.track(new Cr(e), t);
  }
  /**
   * Analytics Compare Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Clicked)
   *
   * When the user clicks the compare button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsCompareClicked(e, t) {
    return this.track(new fr(e), t);
  }
  /**
   * Analytics Compare Context Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Context%20Updated)
   *
   * When the user updates the context in a comparison
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsCompareContextUpdated(e, t) {
    return this.track(new kr(e), t);
  }
  /**
   * Analytics Compare Period Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Period%20Updated)
   *
   * When the user updates the context in a comparison
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsComparePeriodUpdated(e, t) {
    return this.track(new yr(e), t);
  }
  /**
   * Analytics Context Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Context%20Updated)
   *
   * When the user updates the context on a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsContextUpdated(e, t) {
    return this.track(new mr(e), t);
  }
  /**
   * Analytics Conversation Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Conversation%20Link%20Clicked)
   *
   * When the user clicks on a conversation link in supported instruments
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  analyticsConversationLinkClicked(e, t) {
    return this.track(new _r(e), t);
  }
  /**
   * Analytics Conversation Preview Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Conversation%20Preview%20Clicked)
   *
   * When the user clicks on the button to preview a conversation in supported instruments
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  analyticsConversationPreviewClicked(e, t) {
    return this.track(new wr(e), t);
  }
  /**
   * Analytics Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Dashboard%20Viewed)
   *
   * When the user views a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  analyticsDashboardViewed(e, t) {
    return this.track(new Sr(e), t);
  }
  /**
   * Analytics Export Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20Clicked)
   *
   * When the user clicks the export button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsExportClicked(e, t) {
    return this.track(new br(e), t);
  }
  /**
   * Analytics Export Download Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20Download%20Clicked)
   *
   * When the user clicks the export download button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsExportDownloadClicked(e, t) {
    return this.track(new Ir(e), t);
  }
  /**
   * Analytics Export My Data Button Pressed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20My%20Data%20Button%20Pressed)
   *
   * When the user clicks Export my data button on Analytics Export Dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfDays)
   * @param options Amplitude event options.
   */
  analyticsExportMyDataButtonPressed(e, t) {
    return this.track(new Ar(e), t);
  }
  /**
   * Analytics Filter Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Cleared)
   *
   * When the user clears a filter in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterCleared(e, t) {
    return this.track(new Or(e), t);
  }
  /**
   * Analytics Filter Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Opened)
   *
   * When the user opens a filter in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterOpened(e, t) {
    return this.track(new Tr(e), t);
  }
  /**
   * Analytics Filter Operator Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Operator%20Updated)
   *
   * When the updates the operator of filter in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterOperatorUpdated(e, t) {
    return this.track(new Pr(e), t);
  }
  /**
   * Analytics Filter Value Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Value%20Added)
   *
   * When the user adds a filter value in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. all)
   * @param options Amplitude event options.
   */
  analyticsFilterValueAdded(e, t) {
    return this.track(new Er(e), t);
  }
  /**
   * Analytics Filters Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filters%20Applied)
   *
   * When the user applies some filters in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFiltersApplied(e, t) {
    return this.track(new Fr(e), t);
  }
  /**
   * Analytics Filters Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filters%20Cleared)
   *
   * When the user clears all filters in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFiltersCleared(e, t) {
    return this.track(new Mr(e), t);
  }
  /**
   * Analytics Helper Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Helper%20Clicked)
   *
   * When the user clicks a helper in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsHelperClicked(e, t) {
    return this.track(new Rr(e), t);
  }
  /**
   * Analytics In Depth Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20In%20Depth%20Clicked)
   *
   * When the user clicks an in-depth button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInDepthClicked(e, t) {
    return this.track(new Dr(e), t);
  }
  /**
   * Analytics Insights Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Clicked)
   *
   * When the user clicks the AI insights button in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsClicked(e, t) {
    return this.track(new Ur(e), t);
  }
  /**
   * Analytics Insights Copy Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Copy%20Clicked)
   *
   * When the user clicks copy to clipboard on an AI insight in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsCopyClicked(e, t) {
    return this.track(new Hr(e), t);
  }
  /**
   * Analytics Insights Feedback Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Feedback%20Clicked)
   *
   * When the user clicks a feedback button on an AI insight in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsFeedbackClicked(e, t) {
    return this.track(new Br(e), t);
  }
  /**
   * Analytics Insights Prompt Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Prompt%20Clicked)
   *
   * When the user clicks on an AI insight prompt in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsPromptClicked(e, t) {
    return this.track(new Lr(e), t);
  }
  /**
   * Analytics Insights Regenerate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Regenerate%20Clicked)
   *
   * When the user clicks regenerate on an AI insight prompt in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsRegenerateClicked(e, t) {
    return this.track(new Nr(e), t);
  }
  /**
   * Analytics Period Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Period%20Updated)
   *
   * When the user updates the period on a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPeriodUpdated(e, t) {
    return this.track(new Wr(e), t);
  }
  /**
   * Analytics Quick View Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Created)
   *
   * When the user creates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewCreated(e, t) {
    return this.track(new Vr(e), t);
  }
  /**
   * Analytics Quick View Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Deleted)
   *
   * When the user deletes a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  analyticsQuickViewDeleted(e, t) {
    return this.track(new xr(e), t);
  }
  /**
   * Analytics Quick View Duplicated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Duplicated)
   *
   * When the user duplicates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewDuplicated(e, t) {
    return this.track(new Qr(e), t);
  }
  /**
   * Analytics Quick View Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Favorite%20Toggled)
   *
   * When the user favorites or unfavorites a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. favorited)
   * @param options Amplitude event options.
   */
  analyticsQuickViewFavoriteToggled(e, t) {
    return this.track(new Kr(e), t);
  }
  /**
   * Analytics Quick View Sharing Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Sharing%20Toggled)
   *
   * When the user shares or unshares a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewSharingToggled(e, t) {
    return this.track(new qr(e), t);
  }
  /**
   * Analytics Quick View Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Updated)
   *
   * When the user updates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewUpdated(e, t) {
    return this.track(new zr(e), t);
  }
  /**
   * Analytics Quick View Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Viewed)
   *
   * When the user views a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewViewed(e, t) {
    return this.track(new Gr(e), t);
  }
  /**
   * Analytics Refresh Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Refresh%20Clicked)
   *
   * When the user clicks a refresh button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsRefreshClicked(e, t) {
    return this.track(new jr(e), t);
  }
  /**
   * Analytics Table Load All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Table%20Load%20All%20Clicked)
   *
   * When the user clicks the load all results button on a table
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsTableLoadAllClicked(e, t) {
    return this.track(new Jr(e), t);
  }
  /**
   * Analytics Table Sort Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Table%20Sort%20Updated)
   *
   * When the user updates the sorting on a table
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. column)
   * @param options Amplitude event options.
   */
  analyticsTableSortUpdated(e, t) {
    return this.track(new $r(e), t);
  }
  /**
   * Analytics Timezone Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Timezone%20Updated)
   *
   * When the user updates the timezone on a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsTimezoneUpdated(e, t) {
    return this.track(new Yr(e), t);
  }
  /**
   * Analytics View Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20View%20Conversations%20Clicked)
   *
   * When the user clicks the view conversations button in a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsViewConversationsClicked(e, t) {
    return this.track(new Zr(e), t);
  }
  /**
   * Auth Failed Init
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Auth%20Failed%20Init)
   *
   * When the application fails to initialize authentication
   *
   * @param properties The event's properties (e.g. failureReason)
   * @param options Amplitude event options.
   */
  authFailedInit(e, t) {
    return this.track(new Xr(e), t);
  }
  /**
   * Automations Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in automations settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new ei(), e);
  }
  /**
   * Automations Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Cancelled)
   *
   * When the user cancels the Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormCancelled(e, t) {
    return this.track(new ti(e), t);
  }
  /**
   * Automations Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Opened)
   *
   * When the user opens the create/update Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormOpened(e, t) {
    return this.track(new ni(e), t);
  }
  /**
   * Automations Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Submitted)
   *
   * When the user proceeds on the Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormSubmitted(e, t) {
    return this.track(new ri(e), t);
  }
  /**
   * Automations Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOpened(e) {
    return this.track(new ii(), e);
  }
  /**
   * Automations Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionDeleteClicked(e) {
    return this.track(new si(), e);
  }
  /**
   * Automations Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new oi(), e);
  }
  /**
   * Automations Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit Flow in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionFlowClicked(e) {
    return this.track(new ai(), e);
  }
  /**
   * Automations Options Menu Option Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Settings%20Clicked)
   *
   * When the user selects Settings in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionSettingsClicked(e) {
    return this.track(new ci(), e);
  }
  /**
   * Automations Pagination Next Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Pagination%20Next%20Clicked)
   *
   * When the user clicks the next page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsPaginationNextClicked(e) {
    return this.track(new ui(), e);
  }
  /**
   * Automations Pagination Previous Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Pagination%20Previous%20Clicked)
   *
   * When the user clicks the previous page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsPaginationPreviousClicked(e) {
    return this.track(new di(), e);
  }
  /**
   * Automations Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchApplied(e) {
    return this.track(new li(), e);
  }
  /**
   * Automations Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchClosed(e) {
    return this.track(new pi(), e);
  }
  /**
   * Automations Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchOpened(e) {
    return this.track(new hi(), e);
  }
  /**
   * Automations Toggled Off
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Toggled%20Off)
   *
   * When the user toggles an automation off
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsToggledOff(e) {
    return this.track(new vi(), e);
  }
  /**
   * Automations Toggled On
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Toggled%20On)
   *
   * When the user toggles an automation on
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsToggledOn(e) {
    return this.track(new gi(), e);
  }
  /**
   * Bans Ban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Ban%20User%20Clicked)
   *
   * When the user clicks the Ban User button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  bansBanUserClicked(e, t) {
    return this.track(new Ci(e), t);
  }
  /**
   * Bans Unban Ip Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Unban%20Ip%20Clicked)
   *
   * When the user clicks the Unban IP button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  bansUnbanIpClicked(e) {
    return this.track(new fi(), e);
  }
  /**
   * Bans Unban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Unban%20User%20Clicked)
   *
   * When the user clicks the Unban User button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  bansUnbanUserClicked(e, t) {
    return this.track(new ki(e), t);
  }
  /**
   * Bulk Actions Update Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bulk%20Actions%20Update%20Clicked)
   *
   * When the user clicks the Update button in the Bulk Actions
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationsCount)
   * @param options Amplitude event options.
   */
  bulkActionsUpdateClicked(e, t) {
    return this.track(new yi(e), t);
  }
  /**
   * Business Hours Add Schedule Audio Message Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Audio%20Message%20Added)
   *
   * When the user added an Audio message.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleAudioMessageAdded(e, t) {
    return this.track(new mi(e), t);
  }
  /**
   * Business Hours Add Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Button%20Clicked)
   *
   * When the user clicked the Add new schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleButtonClicked(e) {
    return this.track(new _i(), e);
  }
  /**
   * Business Hours Add Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Add new schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleFormCancelled(e, t) {
    return this.track(new wi(e), t);
  }
  /**
   * Business Hours Add Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Add new schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleFormSubmitted(e, t) {
    return this.track(new Si(e), t);
  }
  /**
   * Business Hours Conflict Notification Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Conflict%20Notification%20Button%20Clicked)
   *
   * When the user clicked the Go to Business Hours button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursConflictNotificationButtonClicked(e) {
    return this.track(new bi(), e);
  }
  /**
   * Business Hours Conflict Notification Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Conflict%20Notification%20Closed)
   *
   * When the user clicked the close button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursConflictNotificationClosed(e) {
    return this.track(new Ii(), e);
  }
  /**
   * Business Hours Delete Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Delete%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Delete schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDeleteScheduleFormCancelled(e) {
    return this.track(new Ai(), e);
  }
  /**
   * Business Hours Delete Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Delete%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Delete schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDeleteScheduleFormSubmitted(e) {
    return this.track(new Oi(), e);
  }
  /**
   * Business Hours Duplicate Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Duplicate%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Duplicate schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDuplicateScheduleFormCancelled(e) {
    return this.track(new Ti(), e);
  }
  /**
   * Business Hours Duplicate Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Duplicate%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Duplicate schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDuplicateScheduleFormSubmitted(e) {
    return this.track(new Pi(), e);
  }
  /**
   * Business Hours First Schedule Modal Question Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20First%20Schedule%20Modal%20Question%20Clicked)
   *
   * When the user clicked the one of the question toggle.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. question)
   * @param options Amplitude event options.
   */
  businessHoursFirstScheduleModalQuestionClicked(e, t) {
    return this.track(new Ei(e), t);
  }
  /**
   * Business Hours First Schedule Support Article Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20First%20Schedule%20Support%20Article%20Clicked)
   *
   * When the user clicked the Support article link.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursFirstScheduleSupportArticleClicked(e) {
    return this.track(new Fi(), e);
  }
  /**
   * Business Hours Go To Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Go%20To%20Flow%20Clicked)
   *
   * When the user clicked the Go to flow on the Schedules listing page.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursGoToFlowClicked(e) {
    return this.track(new Mi(), e);
  }
  /**
   * Business Hours Migration Wizard Audio Message Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Audio%20Message%20Added)
   *
   * When the user added an Audio message.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardAudioMessageAdded(e, t) {
    return this.track(new Ri(e), t);
  }
  /**
   * Business Hours Migration Wizard Create New Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Create%20New%20Schedule%20Button%20Clicked)
   *
   * When the clicked the Create new schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardCreateNewScheduleButtonClicked(e) {
    return this.track(new Di(), e);
  }
  /**
   * Business Hours Migration Wizard Edit Hours Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Edit%20Hours%20Button%20Clicked)
   *
   * When the user clicked the Edit hours button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardEditHoursButtonClicked(e) {
    return this.track(new Ui(), e);
  }
  /**
   * Business Hours Migration Wizard Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Form%20Cancelled)
   *
   * When the user cancelled the Migration wizard modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. step)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardFormCancelled(e, t) {
    return this.track(new Hi(e), t);
  }
  /**
   * Business Hours Migration Wizard Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Form%20Submitted)
   *
   * When the user submitted the Migration wizard modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardFormSubmitted(e, t) {
    return this.track(new Bi(e), t);
  }
  /**
   * Business Hours Migration Wizard Opening Hours Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Opening%20Hours%20Form%20Cancelled)
   *
   * When the user cancelled the Migration wizard Opening hours form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardOpeningHoursFormCancelled(e) {
    return this.track(new Li(), e);
  }
  /**
   * Business Hours Migration Wizard Opening Hours Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Opening%20Hours%20Form%20Submitted)
   *
   * When the user submitted the Migration wizard Opening hours form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardOpeningHoursFormSubmitted(e) {
    return this.track(new Ni(), e);
  }
  /**
   * Business Hours Migration Wizard Start Update Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Start%20Update%20Button%20Clicked)
   *
   * When the user clicked the Start update button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardStartUpdateButtonClicked(e) {
    return this.track(new Wi(), e);
  }
  /**
   * Business Hours Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Opened)
   *
   * When the user opened the Options Menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOpened(e) {
    return this.track(new Vi(), e);
  }
  /**
   * Business Hours Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selected Delete in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionDeleteClicked(e) {
    return this.track(new xi(), e);
  }
  /**
   * Business Hours Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selected Duplicate in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new Qi(), e);
  }
  /**
   * Business Hours Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selected Edit schedule in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionEditClicked(e) {
    return this.track(new Ki(), e);
  }
  /**
   * Business Hours Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selected Rename in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionRenameClicked(e) {
    return this.track(new qi(), e);
  }
  /**
   * Business Hours Rename Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Rename%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Rename schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursRenameScheduleFormCancelled(e) {
    return this.track(new zi(), e);
  }
  /**
   * Business Hours Rename Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Rename%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Rename schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursRenameScheduleFormSubmitted(e, t) {
    return this.track(new Gi(e), t);
  }
  /**
   * Business Hours Schedule Add Exception Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Button%20Clicked)
   *
   * When user clicked on the Add exception button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionButtonClicked(e) {
    return this.track(new ji(), e);
  }
  /**
   * Business Hours Schedule Add Exception Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Form%20Cancelled)
   *
   * When the user cancelled the Add exception form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionFormCancelled(e) {
    return this.track(new Ji(), e);
  }
  /**
   * Business Hours Schedule Add Exception Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Form%20Submitted)
   *
   * When the user submitted Add exception form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionFormSubmitted(e) {
    return this.track(new $i(), e);
  }
  /**
   * Business Hours Schedule Audio Message Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Form%20Cancelled)
   *
   * When the user cancelled the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageFormCancelled(e, t) {
    return this.track(new Yi(e), t);
  }
  /**
   * Business Hours Schedule Audio Message Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Form%20Submitted)
   *
   * When the user submitted the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageFormSubmitted(e, t) {
    return this.track(new Zi(e), t);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Opened)
   *
   * When the user opened the Audio message options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOpened(e, t) {
    return this.track(new Xi(e), t);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Clear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Clear%20Clicked)
   *
   * When the user selected Clear from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionClearClicked(e, t) {
    return this.track(new es(e), t);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Record Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Record%20Clicked)
   *
   * When the user selected Record audio message from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked(e, t) {
    return this.track(new ts(e), t);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Upload Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Upload%20Clicked)
   *
   * When the user selected Upload audio message from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked(e, t) {
    return this.track(new ns(e), t);
  }
  /**
   * Business Hours Schedule Auto Reply Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Auto%20Reply%20Form%20Cancelled)
   *
   * When the user cancelled the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAutoReplyFormCancelled(e, t) {
    return this.track(new rs(e), t);
  }
  /**
   * Business Hours Schedule Auto Reply Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Auto%20Reply%20Form%20Submitted)
   *
   * When the user submitted the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAutoReplyFormSubmitted(e, t) {
    return this.track(new is(e), t);
  }
  /**
   * Business Hours Schedule Auto Reply Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Auto%20Reply%20Options%20Menu%20Opened)
   *
   * When the user opened the Auto replies options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAutoReplyOptionsMenuOpened(e, t) {
    return this.track(new ss(e), t);
  }
  /**
   * Business Hours Schedule Auto Reply Options Menu Option Add Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Auto%20Reply%20Options%20Menu%20Option%20Add%20Clicked)
   *
   * When the user selected Add auto-reply template option.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAutoReplyOptionsMenuOptionAddClicked(e, t) {
    return this.track(new os(e), t);
  }
  /**
   * Business Hours Schedule Auto Reply Options Menu Option Clear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Auto%20Reply%20Options%20Menu%20Option%20Clear%20Clicked)
   *
   * When the user selected Clear from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAutoReplyOptionsMenuOptionClearClicked(e, t) {
    return this.track(new as(e), t);
  }
  /**
   * Business Hours Schedule Conflict Change Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Conflict%20Change%20Button%20Clicked)
   *
   * When the user clicked the Change button on the overridden item.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleConflictChangeButtonClicked(e) {
    return this.track(new cs(), e);
  }
  /**
   * Business Hours Schedule Conflict Review Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Conflict%20Review%20Button%20Clicked)
   *
   * When the user clicked the Review conflicts button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleConflictReviewButtonClicked(e) {
    return this.track(new us(), e);
  }
  /**
   * Business Hours Schedule Delete Exception Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Delete%20Exception%20Form%20Cancelled)
   *
   * When the user cancelled the Delete exception modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleDeleteExceptionFormCancelled(e) {
    return this.track(new ds(), e);
  }
  /**
   * Business Hours Schedule Delete Exception Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Delete%20Exception%20Form%20Submitted)
   *
   * When the user submitted the Delete exception modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleDeleteExceptionFormSubmitted(e) {
    return this.track(new ls(), e);
  }
  /**
   * Business Hours Schedule Exception Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Exception%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selected Delete in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleExceptionOptionsMenuOptionDeleteClicked(e, t) {
    return this.track(new ps(e), t);
  }
  /**
   * Business Hours Schedule Import Holiday Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Import%20Holiday%20Form%20Cancelled)
   *
   * When the user cancelled the Import holiday form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleImportHolidayFormCancelled(e) {
    return this.track(new hs(), e);
  }
  /**
   * Business Hours Schedule Import Holiday Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Import%20Holiday%20Form%20Submitted)
   *
   * When the user submitted the Import holiday form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursScheduleImportHolidayFormSubmitted(e, t) {
    return this.track(new vs(e), t);
  }
  /**
   * Business Hours Schedule Options Menu Import Holidays Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Import%20Holidays%20Clicked)
   *
   * When the user selected Import holidays in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuImportHolidaysClicked(e) {
    return this.track(new gs(), e);
  }
  /**
   * Business Hours Schedule Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Opened)
   *
   * When the user opened the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuOpened(e) {
    return this.track(new Cs(), e);
  }
  /**
   * Business Hours Schedule Options Menu Recover Holidays Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Recover%20Holidays%20Clicked)
   *
   * When the user selected Recover deleted holidays in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuRecoverHolidaysClicked(e) {
    return this.track(new fs(), e);
  }
  /**
   * Business Hours Schedule Options Menu Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Rename%20Clicked)
   *
   * When the user selected Rename in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuRenameClicked(e) {
    return this.track(new ks(), e);
  }
  /**
   * Business Hours Schedule Options Menu Timezone Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Timezone%20Clicked)
   *
   * When the user selected Edit timezone in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuTimezoneClicked(e) {
    return this.track(new ys(), e);
  }
  /**
   * Business Hours Schedule Preview Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Preview%20Button%20Clicked)
   *
   * When the user clicked the Preview button.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursSchedulePreviewButtonClicked(e, t) {
    return this.track(new ms(e), t);
  }
  /**
   * Business Hours Schedule Recover Holidays Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Recover%20Holidays%20Form%20Cancelled)
   *
   * When the user cancelled the Recover holidays modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleRecoverHolidaysFormCancelled(e) {
    return this.track(new _s(), e);
  }
  /**
   * Business Hours Schedule Recover Holidays Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Recover%20Holidays%20Form%20Submitted)
   *
   * When the user submitted the Recover holidays modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleRecoverHolidaysFormSubmitted(e) {
    return this.track(new ws(), e);
  }
  /**
   * Business Hours Schedule Review Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Review%20Form%20Cancelled)
   *
   * When the user cancelled the Review conflicts form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleReviewFormCancelled(e) {
    return this.track(new Ss(), e);
  }
  /**
   * Business Hours Schedule Review Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Review%20Form%20Submitted)
   *
   * When the user submitted the Review conflicts form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleReviewFormSubmitted(e) {
    return this.track(new bs(), e);
  }
  /**
   * Business Hours Schedule Save Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Save%20Schedule%20Button%20Clicked)
   *
   * When the user clicked the Save schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleSaveScheduleButtonClicked(e) {
    return this.track(new Is(), e);
  }
  /**
   * Business Hours Schedule Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Tab%20Clicked)
   *
   * When user clicked one of the view tabs.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursScheduleTabClicked(e, t) {
    return this.track(new As(e), t);
  }
  /**
   * Business Hours Schedule View Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20View%20Clicked)
   *
   * When the user clicked one of the view buttons.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  businessHoursScheduleViewClicked(e, t) {
    return this.track(new Os(e), t);
  }
  /**
   * Chat Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in chat settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new Ts(), e);
  }
  /**
   * Chat Form Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Canceled)
   *
   * When the user cancels the Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormCanceled(e, t) {
    return this.track(new Ps(e), t);
  }
  /**
   * Chat Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Opened)
   *
   * When the user opens the create/rename Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormOpened(e, t) {
    return this.track(new Es(e), t);
  }
  /**
   * Chat Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Submitted)
   *
   * When the user proceed on the Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormSubmitted(e, t) {
    return this.track(new Fs(e), t);
  }
  /**
   * Chat Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Opened)
   *
   * Whether the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOpened(e) {
    return this.track(new Ms(), e);
  }
  /**
   * Chat Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionDeleteClicked(e) {
    return this.track(new Rs(), e);
  }
  /**
   * Chat Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new Ds(), e);
  }
  /**
   * Chat Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit flow in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionFlowClicked(e) {
    return this.track(new Us(), e);
  }
  /**
   * Chat Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionRenameClicked(e) {
    return this.track(new Hs(), e);
  }
  /**
   * Chat Options Menu Option Setup Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Setup%20Clicked)
   *
   * When the user selects Setup in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionSetupClicked(e) {
    return this.track(new Bs(), e);
  }
  /**
   * Chat Pagination Next Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Pagination%20Next%20Clicked)
   *
   * When the user clicks the next page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatPaginationNextClicked(e) {
    return this.track(new Ls(), e);
  }
  /**
   * Chat Pagination Previous Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Pagination%20Previous%20Clicked)
   *
   * When the user clicks the previous page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatPaginationPreviousClicked(e) {
    return this.track(new Ns(), e);
  }
  /**
   * Chat Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchApplied(e) {
    return this.track(new Ws(), e);
  }
  /**
   * Chat Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchClosed(e) {
    return this.track(new Vs(), e);
  }
  /**
   * Chat Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchOpened(e) {
    return this.track(new xs(), e);
  }
  /**
   * Chatbot Create Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Create%20Modal%20Opened)
   *
   * When the user opens the Create new chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotCreateModalOpened(e) {
    return this.track(new Qs(), e);
  }
  /**
   * Chatbot Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Created)
   *
   * When the user creates a new chatbot
   *
   * @param properties The event's properties (e.g. chatbotType)
   * @param options Amplitude event options.
   */
  chatbotCreated(e, t) {
    return this.track(new Ks(e), t);
  }
  /**
   * Chatbot Delete Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Delete%20Modal%20Opened)
   *
   * When the user opens the Delete chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotDeleteModalOpened(e) {
    return this.track(new qs(), e);
  }
  /**
   * Chatbot Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Deleted)
   *
   * When the user deletes a chatbot
   *
   * @param properties The event's properties (e.g. chatbotType)
   * @param options Amplitude event options.
   */
  chatbotDeleted(e, t) {
    return this.track(new zs(e), t);
  }
  /**
   * Chatbot Edit Identity Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Edit%20Identity%20Modal%20Opened)
   *
   * When the user opens the Identity chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotEditIdentityModalOpened(e) {
    return this.track(new Gs(), e);
  }
  /**
   * Chatbot Identity Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Identity%20Edited)
   *
   * When the user edits the Identity chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotIdentityEdited(e) {
    return this.track(new js(), e);
  }
  /**
   * Command Executed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Command%20Executed)
   *
   * When the user executes a command.
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  commandExecuted(e, t) {
    return this.track(new Js(e), t);
  }
  /**
   * Company Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Company%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on company modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  companyModalFormSubmitted(e, t) {
    return this.track(new $s(e), t);
  }
  /**
   * Contacts Add New Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Add%20New%20Company%20Clicked)
   *
   * When the user clicks the Add New Company button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsAddNewCompanyClicked(e) {
    return this.track(new Ys(), e);
  }
  /**
   * Contacts Add New Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Add%20New%20Contact%20Clicked)
   *
   * When the user clicks the Add New Contact button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsAddNewContactClicked(e) {
    return this.track(new Zs(), e);
  }
  /**
   * Contacts Ban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Ban%20User%20Clicked)
   *
   * When the user clicks the Ban User button on the Contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  contactsBanUserClicked(e, t) {
    return this.track(new Xs(e), t);
  }
  /**
   * Contacts Card Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Actions%20Menu%20Opened)
   *
   * When the user opens the Actions Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardActionsMenuOpened(e) {
    return this.track(new eo(), e);
  }
  /**
   * Contacts Card Compose New Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Compose%20New%20Email%20Clicked)
   *
   * When the user clicks the Compose New Email button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardComposeNewEmailClicked(e) {
    return this.track(new to(), e);
  }
  /**
   * Contacts Card Edit Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Edit%20Company%20Clicked)
   *
   * When the user clicks the to edit a company
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardEditCompanyClicked(e) {
    return this.track(new no(), e);
  }
  /**
   * Contacts Card Edit Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Edit%20Contact%20Clicked)
   *
   * When the user clicks the to edit a contact
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardEditContactClicked(e) {
    return this.track(new ro(), e);
  }
  /**
   * Contacts Card Make Call Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Make%20Call%20Clicked)
   *
   * When the user clicks to make a call in the contact card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardMakeCallClicked(e) {
    return this.track(new io(), e);
  }
  /**
   * Contacts Card See All Assigned Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20See%20All%20Assigned%20Conversations%20Clicked)
   *
   * When the user clicks the button to see all assigned conversations
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardSeeAllAssignedConversationsClicked(e) {
    return this.track(new so(), e);
  }
  /**
   * Contacts Card See All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20See%20All%20Conversations%20Clicked)
   *
   * When the user clicks the button to see all conversations
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardSeeAllConversationsClicked(e) {
    return this.track(new oo(), e);
  }
  /**
   * Contacts Card View Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20View%20Company%20Clicked)
   *
   * When the user clicks to view the company in the contacts card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardViewCompanyClicked(e) {
    return this.track(new ao(), e);
  }
  /**
   * Contacts Card View User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20View%20User%20Clicked)
   *
   * When the user clicks to view the user in the contacts card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardViewUserClicked(e) {
    return this.track(new co(), e);
  }
  /**
   * Contacts Search Blurred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Search%20Blurred)
   *
   * When the search input is blurred
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsSearchBlurred(e) {
    return this.track(new uo(), e);
  }
  /**
   * Contacts Search Focused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Search%20Focused)
   *
   * When the search input is focused
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsSearchFocused(e) {
    return this.track(new lo(), e);
  }
  /**
   * Contacts Unban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Unban%20User%20Clicked)
   *
   * When the user clicks the Unban User button on the Contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  contactsUnbanUserClicked(e, t) {
    return this.track(new po(e), t);
  }
  /**
   * Contacts View Companies
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20View%20Companies)
   *
   * When the user selects Companies in the dropdown in the contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsViewCompanies(e) {
    return this.track(new ho(), e);
  }
  /**
   * Contacts View End Users
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20View%20End%20Users)
   *
   * When the user selects Contacts from the dropdown in the contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsViewEndUsers(e) {
    return this.track(new vo(), e);
  }
  /**
   * Conversation Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Actions%20Menu%20Opened)
   *
   * When the user opens the Actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActionsMenuOpened(e) {
    return this.track(new go(), e);
  }
  /**
   * Conversation Actions Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Actions%20Menu%20Option%20Clicked)
   *
   * When the user selects an option from the Actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  conversationActionsMenuOptionClicked(e, t) {
    return this.track(new Co(e), t);
  }
  /**
   * Conversation Activity Log Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Closed)
   *
   * When the user closed the Activity Log
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActivityLogClosed(e) {
    return this.track(new fo(), e);
  }
  /**
   * Conversation Activity Log Flooter Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Flooter%20Expanded)
   *
   * When the agent has expanded the Flooter.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActivityLogFlooterExpanded(e) {
    return this.track(new ko(), e);
  }
  /**
   * Conversation Activity Log Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Opened)
   *
   * When the user opens the Activity Log
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationActivityLogOpened(e, t) {
    return this.track(new yo(e), t);
  }
  /**
   * Conversation Attached Image Is Downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Attached%20Image%20Is%20Downloaded)
   *
   * When the user downloads an image attachment from the preview modal
   *
   * @param options Amplitude event options.
   */
  conversationAttachedImageIsDownloaded(e) {
    return this.track(new mo(), e);
  }
  /**
   * Conversation Attached Image Is Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Attached%20Image%20Is%20Viewed)
   *
   * When the user clicks on an image attachment that opens the preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationAttachedImageIsViewed(e) {
    return this.track(new _o(), e);
  }
  /**
   * Conversation Claimed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Claimed)
   *
   * When the user claims the conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationClaimed(e, t) {
    return this.track(new wo(e), t);
  }
  /**
   * Conversation Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Closed)
   *
   * When the user closes the conversatio
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationClosed(e, t) {
    return this.track(new So(e), t);
  }
  /**
   * Conversation Csat Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Cancelled)
   *
   * When the user cancels the CSAT
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatCancelled(e) {
    return this.track(new bo(), e);
  }
  /**
   * Conversation Csat Menu Cancel Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Cancel%20Option%20Clicked)
   *
   * When the user clicks the Cancel CSAT menu option
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatMenuCancelOptionClicked(e) {
    return this.track(new Io(), e);
  }
  /**
   * Conversation Csat Menu Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Language%20Selected)
   *
   * When the user changes the language from the CSAT menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  conversationCsatMenuLanguageSelected(e, t) {
    return this.track(new Ao(e), t);
  }
  /**
   * Conversation Csat Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Opened)
   *
   * When the user opens the CSAT menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatMenuOpened(e) {
    return this.track(new Oo(), e);
  }
  /**
   * Conversation Follow Up
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up)
   *
   * When a conversation was followed up.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationFollowUp(e, t) {
    return this.track(new To(e), t);
  }
  /**
   * Conversation Follow Up Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up%20Menu%20Opened)
   *
   * When the user opens the Follow Up menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationFollowUpMenuOpened(e) {
    return this.track(new Po(), e);
  }
  /**
   * Conversation Follow Up Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up%20Menu%20Option%20Clicked)
   *
   * When the user selects an option from the Follow Up menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  conversationFollowUpMenuOptionClicked(e, t) {
    return this.track(new Eo(e), t);
  }
  /**
   * Conversation Header Conversation Details Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Conversation%20Details%20Menu%20Opened)
   *
   * When the user opens conversation details dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderConversationDetailsMenuOpened(e) {
    return this.track(new Fo(), e);
  }
  /**
   * Conversation Header More Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20More%20Menu%20Opened)
   *
   * When the user opens the more menu in the conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderMoreMenuOpened(e) {
    return this.track(new Mo(), e);
  }
  /**
   * Conversation Header Tag Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Added)
   *
   * When the user adds a tag from tag dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationHeaderTagAdded(e, t) {
    return this.track(new Ro(e), t);
  }
  /**
   * Conversation Header Tag Include Deactivated Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Include%20Deactivated%20Toggled)
   *
   * When the user toggles Include deactivated tags in tag select dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. include)
   * @param options Amplitude event options.
   */
  conversationHeaderTagIncludeDeactivatedToggled(e, t) {
    return this.track(new Do(e), t);
  }
  /**
   * Conversation Header Tag Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Menu%20Opened)
   *
   * When the user opens tags select dropdown from conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTagMenuOpened(e) {
    return this.track(new Uo(), e);
  }
  /**
   * Conversation Header Tag Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Removed)
   *
   * When the user removes a tag from conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationHeaderTagRemoved(e, t) {
    return this.track(new Ho(e), t);
  }
  /**
   * Conversation Header Transfer To Agent Item Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Agent%20Item%20Selected)
   *
   * When the user selects an agent from transfer to agent dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToAgentItemSelected(e) {
    return this.track(new Bo(), e);
  }
  /**
   * Conversation Header Transfer To Agent Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Agent%20Menu%20Opened)
   *
   * When the user opens the transfer to agent dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToAgentMenuOpened(e) {
    return this.track(new Lo(), e);
  }
  /**
   * Conversation Header Transfer To Number Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Number%20Button%20Clicked)
   *
   * When the user clicks on transfer to number button in the conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToNumberButtonClicked(e) {
    return this.track(new No(), e);
  }
  /**
   * Conversation Header Transfer To Queue Item Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Queue%20Item%20Selected)
   *
   * When the user selects a queue from transfer to queue dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. queue)
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToQueueItemSelected(e, t) {
    return this.track(new Wo(e), t);
  }
  /**
   * Conversation Header Transfer To Queue Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Queue%20Menu%20Opened)
   *
   * When the user opens the transfer to queue dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToQueueMenuOpened(e) {
    return this.track(new Vo(), e);
  }
  /**
   * Conversation Internal Note Editor Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Internal%20Note%20Editor%20Opened)
   *
   * When the user opens the internal note tab
   *
   * @param options Amplitude event options.
   */
  conversationInternalNoteEditorOpened(e) {
    return this.track(new xo(), e);
  }
  /**
   * Conversation Offered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Offered)
   *
   * When a conversation was offered to an agent
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationOffered(e, t) {
    return this.track(new Qo(e), t);
  }
  /**
   * Conversation Replied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Replied)
   *
   * When the user replies a conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationReplied(e, t) {
    return this.track(new Ko(e), t);
  }
  /**
   * Conversation Resolved As A Knowledge Article Draft
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20As%20A%20Knowledge%20Article%20Draft)
   *
   * When a user chooses to create a draft when they resolve a conversation
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedAsAKnowledgeArticleDraft(e, t) {
    return this.track(new qo(e), t);
  }
  /**
   * Conversation Resolved As A Knowledge Gap
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20As%20A%20Knowledge%20Gap)
   *
   * When a user chooses to register a knowledge gap when they resolve a conversation
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedAsAKnowledgeGap(e, t) {
    return this.track(new zo(e), t);
  }
  /**
   * Conversation Resolved By Knowledge
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20By%20Knowledge)
   *
   * When a user resolves a conversation using the knowledge flow
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedByKnowledge(e, t) {
    return this.track(new Go(e), t);
  }
  /**
   * Conversation Resolved With No Knowledge Article
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20With%20No%20Knowledge%20Article)
   *
   * When a user chooses to resolve a conversation without marking any knowledge article as having helped
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedWithNoKnowledgeArticle(e, t) {
    return this.track(new jo(e), t);
  }
  /**
   * Conversation Sidebar Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Closed)
   *
   * When the user closes the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarClosed(e) {
    return this.track(new Jo(), e);
  }
  /**
   * Conversation Sidebar Conversation History Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Closed)
   *
   * When the user closes the accordion item conversation history
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryClosed(e) {
    return this.track(new $o(), e);
  }
  /**
   * Conversation Sidebar Conversation History Navigated To Conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Navigated%20To%20Conversation)
   *
   * When the user navigates to a conversation listed in the conversation history accordion item in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryNavigatedToConversation(e) {
    return this.track(new Yo(), e);
  }
  /**
   * Conversation Sidebar Conversation History Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Opened)
   *
   * When the user opens the accordion item conversation history
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryOpened(e) {
    return this.track(new Zo(), e);
  }
  /**
   * Conversation Sidebar Customer Info Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Customer%20Info%20Email%20Clicked)
   *
   * When the user opens compose email from clicking the customers email in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarCustomerInfoEmailClicked(e) {
    return this.track(new Xo(), e);
  }
  /**
   * Conversation Sidebar Customer Info Phone Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Customer%20Info%20Phone%20Number%20Clicked)
   *
   * When the user starts phone call from clicking the customers phone number in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarCustomerInfoPhoneNumberClicked(e) {
    return this.track(new ea(), e);
  }
  /**
   * Conversation Sidebar Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Opened)
   *
   * When the user opens the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarOpened(e) {
    return this.track(new ta(), e);
  }
  /**
   * Conversation Timeline Item Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Timeline%20Item%20Opened)
   *
   * When the user clicks an item in the conversation timeline
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationTimelineItemOpened(e) {
    return this.track(new na(), e);
  }
  /**
   * Conversation Timeline Navigated To Conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Timeline%20Navigated%20To%20Conversation)
   *
   * When the user clicks a conversation listed in a timeline item
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationTimelineNavigatedToConversation(e) {
    return this.track(new ra(), e);
  }
  /**
   * Conversation Transferred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Transferred)
   *
   * When a conversation was transferred.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationTransferred(e, t) {
    return this.track(new ia(e), t);
  }
  /**
   * Conversations Bulk Actions Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Bulk%20Actions%20Clicked)
   *
   * When the user clicks the Bulk Actions button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  conversationsBulkActionsClicked(e, t) {
    return this.track(new sa(e), t);
  }
  /**
   * Conversations Clear All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Clear%20All%20Clicked)
   *
   * When the user clicks the clear all checkbox
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsClearAllClicked(e) {
    return this.track(new oa(), e);
  }
  /**
   * Conversations Filter Agent Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Agent%20Clicked)
   *
   * When the user clicks the Filter Conversations" button for the agent"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  conversationsFilterAgentClicked(e, t) {
    return this.track(new aa(e), t);
  }
  /**
   * Conversations Filter Clear All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Clear%20All%20Clicked)
   *
   * When the user clicks the Clear all button in the Conversations filters
   *
   * @param options Amplitude event options.
   */
  conversationsFilterClearAllClicked(e) {
    return this.track(new ca(), e);
  }
  /**
   * Conversations Filter Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Cleared)
   *
   * When the user clears a conversations filter
   *
   * @param properties The event's properties (e.g. filter)
   * @param options Amplitude event options.
   */
  conversationsFilterCleared(e, t) {
    return this.track(new ua(e), t);
  }
  /**
   * Conversations Filter Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Contact%20Clicked)
   *
   * When the user clicks the Filter Conversations" button for the contact"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  conversationsFilterContactClicked(e, t) {
    return this.track(new da(e), t);
  }
  /**
   * Conversations Filter Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Toggled)
   *
   * When the user toggles a conversations filter
   *
   * @param properties The event's properties (e.g. checked)
   * @param options Amplitude event options.
   */
  conversationsFilterToggled(e, t) {
    return this.track(new la(e), t);
  }
  /**
   * Conversations Go To Conversation Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Go%20To%20Conversation%20Clicked)
   *
   * When the user clicks the Go To Conversations button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationsGoToConversationClicked(e, t) {
    return this.track(new pa(e), t);
  }
  /**
   * Conversations Item Preview Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Item%20Preview%20Clicked)
   *
   * When the user clicks the preview conversation button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsItemPreviewClicked(e) {
    return this.track(new ha(), e);
  }
  /**
   * Conversations Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Next%20Page%20Clicked)
   *
   * When the user clicks the Next Page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsNextPageClicked(e) {
    return this.track(new va(), e);
  }
  /**
   * Conversations Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Previous%20Page%20Clicked)
   *
   * When the user clicks the Previous Page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsPreviousPageClicked(e) {
    return this.track(new ga(), e);
  }
  /**
   * Conversations Select All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Select%20All%20Clicked)
   *
   * When the user clicks the select all checkbox
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsSelectAllClicked(e) {
    return this.track(new Ca(), e);
  }
  /**
   * Conversations Select Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Select%20Clicked)
   *
   * When the user clicks the select checkbox for a single conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationsSelectClicked(e, t) {
    return this.track(new fa(e), t);
  }
  /**
   * Conversations Timestamp Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Timestamp%20Clicked)
   *
   * When the user clicks a timestamp
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationsTimestampClicked(e, t) {
    return this.track(new ka(e), t);
  }
  /**
   * Conversations Transfer To Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Transfer%20To%20Queue%20Clicked)
   *
   * When the user clicks the Transfer To Queue button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsTransferToQueueClicked(e) {
    return this.track(new ya(), e);
  }
  /**
   * Conversations View Agent Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20View%20Agent%20Clicked)
   *
   * When the user clicks the View Agent button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsViewAgentClicked(e) {
    return this.track(new ma(), e);
  }
  /**
   * Conversations View Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20View%20Contact%20Clicked)
   *
   * When the user clicks the View Contact button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsViewContactClicked(e) {
    return this.track(new _a(), e);
  }
  /**
   * ConversationSummaryFeedbackNotUseful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryFeedbackNotUseful)
   *
   * When an agent doesn't find the summary of conversation useful and clicks on thumbs down button.
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryFeedbackNotUseful(e, t) {
    return this.track(new wa(e), t);
  }
  /**
   * ConversationSummaryFeedbackUseful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryFeedbackUseful)
   *
   * When an agent finds the summary of conversation useful and clicks on thumbs up button.
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryFeedbackUseful(e, t) {
    return this.track(new Sa(e), t);
  }
  /**
   * ConversationSummaryRegenerateSummary
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryRegenerateSummary)
   *
   * When an agent requests for a new conversation summary
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryRegenerateSummary(e, t) {
    return this.track(new ba(e), t);
  }
  /**
   * Copy Script
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Copy%20Script)
   *
   * When the user copy the Dixa Widget script
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  copyScript(e) {
    return this.track(new Ia(), e);
  }
  /**
   * Country Code Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Country%20Code%20Selected)
   *
   * When the user selects a country from the Country Code Dropdown in Telephony Search User field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  countryCodeSelected(e) {
    return this.track(new Aa(), e);
  }
  /**
   * Custom Attribute Value Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Custom%20Attribute%20Value%20Updated)
   *
   * Whenever the user updates value of a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  customAttributeValueUpdated(e, t) {
    return this.track(new Oa(e), t);
  }
  /**
   * Dashboard Back To Old Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Back%20To%20Old%20Clicked)
   *
   * When the user clicks the link to go back to the old dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardBackToOldClicked(e) {
    return this.track(new Ta(), e);
  }
  /**
   * Dashboard Global Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Global%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the global tv dashboard button
   *
   * @param options Amplitude event options.
   */
  dashboardGlobalTvDashboardClicked(e) {
    return this.track(new Pa(), e);
  }
  /**
   * Dashboard Layout Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Layout%20Changed)
   *
   * When the user changes the dashboard layout
   *
   * @param properties The event's properties (e.g. layout)
   * @param options Amplitude event options.
   */
  dashboardLayoutChanged(e, t) {
    return this.track(new Ea(e), t);
  }
  /**
   * Dashboard Longest Queued Time Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Longest%20Queued%20Time%20Metric%20Clicked)
   *
   * When the user clicks the pending conversations metric in the dashboard
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  dashboardLongestQueuedTimeMetricClicked(e, t) {
    return this.track(new Fa(e), t);
  }
  /**
   * Dashboard Metric Helper Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Metric%20Helper%20Clicked)
   *
   * When the user clicks on the helper button on a metric
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  dashboardMetricHelperClicked(e, t) {
    return this.track(new Ma(e), t);
  }
  /**
   * Dashboard Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Next%20Page%20Clicked)
   *
   * When the user clicks the next page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  dashboardNextPageClicked(e) {
    return this.track(new Ra(), e);
  }
  /**
   * Dashboard Organization Timezone Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Organization%20Timezone%20Settings%20Clicked)
   *
   * When the user clicks on the link to go to organization settings from the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardOrganizationTimezoneSettingsClicked(e) {
    return this.track(new Da(), e);
  }
  /**
   * Dashboard Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Previous%20Page%20Clicked)
   *
   * When the user clicks the previous page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  dashboardPreviousPageClicked(e) {
    return this.track(new Ua(), e);
  }
  /**
   * Dashboard Queue All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20All%20Conversations%20Clicked)
   *
   * When the user clicks the link to see all the queue conversations in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueAllConversationsClicked(e) {
    return this.track(new Ha(), e);
  }
  /**
   * Dashboard Queue Go To Analytics Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Go%20To%20Analytics%20Clicked)
   *
   * When the user clicks the link to go to the queue Analytics
   *
   * @param options Amplitude event options.
   */
  dashboardQueueGoToAnalyticsClicked(e) {
    return this.track(new Ba(), e);
  }
  /**
   * Dashboard Queue Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Item%20Clicked)
   *
   * When the user clicks the dashboard queue item
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  dashboardQueueItemClicked(e) {
    return this.track(new La(), e);
  }
  /**
   * Dashboard Queue Item Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Item%20Favorite%20Toggled)
   *
   * When the user toggles the favorite queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  dashboardQueueItemFavoriteToggled(e, t) {
    return this.track(new Na(e), t);
  }
  /**
   * Dashboard Queue Name Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Name%20Clicked)
   *
   * When the user clicks the queue name link in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueNameClicked(e) {
    return this.track(new Wa(), e);
  }
  /**
   * Dashboard Queue Pending Conversations Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Pending%20Conversations%20Metric%20Clicked)
   *
   * When the user clicks the longest queued time metric in the dashboard
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  dashboardQueuePendingConversationsMetricClicked(e, t) {
    return this.track(new Va(e), t);
  }
  /**
   * Dashboard Queue Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Settings%20Clicked)
   *
   * When the user clicks the link to go to the queue settings
   *
   * @param options Amplitude event options.
   */
  dashboardQueueSettingsClicked(e) {
    return this.track(new xa(), e);
  }
  /**
   * Dashboard Queue Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the link to see the queue tv dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueTvDashboardClicked(e) {
    return this.track(new Qa(), e);
  }
  /**
   * Dashboard Queues Manually Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Manually%20Selected)
   *
   * When the user manually selects which queues to show in the dashboard
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  dashboardQueuesManuallySelected(e, t) {
    return this.track(new Ka(e), t);
  }
  /**
   * Dashboard Queues Search Field Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Search%20Field%20Cleared)
   *
   * When the user clears the query in the queues search field
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesSearchFieldCleared(e, t) {
    return this.track(new qa(e), t);
  }
  /**
   * Dashboard Queues Search Field Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Search%20Field%20Submitted)
   *
   * When the user submits the query in the queues search field
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesSearchFieldSubmitted(e, t) {
    return this.track(new za(e), t);
  }
  /**
   * Dashboard Queues Sorting Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Sorting%20Updated)
   *
   * When the user updates the queues sorting on the dashboard
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  dashboardQueuesSortingUpdated(e, t) {
    return this.track(new Ga(e), t);
  }
  /**
   * Dashboard Queues Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Type%20Changed)
   *
   * When the user changes the queues type
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesTypeChanged(e, t) {
    return this.track(new ja(e), t);
  }
  /**
   * Dashboard Refresh Data Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Refresh%20Data%20Clicked)
   *
   * When the user clicks the refresh data button in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardRefreshDataClicked(e) {
    return this.track(new Ja(), e);
  }
  /**
   * Dashboard Switch To New Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Switch%20To%20New%20Clicked)
   *
   * When the user clicks the button to switch to the new dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardSwitchToNewClicked(e) {
    return this.track(new $a(), e);
  }
  /**
   * Dashboard Tv Reloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Tv%20Reloaded)
   *
   * When the TV dashboard is automatically reloaded
   *
   * @param options Amplitude event options.
   */
  dashboardTvReloaded(e) {
    return this.track(new Ya(), e);
  }
  /**
   * Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Viewed)
   *
   * When the user views the dashboard
   *
   * @param properties The event's properties (e.g. layout)
   * @param options Amplitude event options.
   */
  dashboardViewed(e, t) {
    return this.track(new Za(e), t);
  }
  /**
   * Editor QuickResponse Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Editor%20QuickResponse%20Added)
   *
   * When the user adds a quick response in the conversation input
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  editorQuickResponseAdded(e) {
    return this.track(new Xa(), e);
  }
  /**
   * Email Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in email settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new ec(), e);
  }
  /**
   * Email Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Form%20Submitted)
   *
   * When the user proceeds on the Email form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  emailFormSubmitted(e, t) {
    return this.track(new tc(e), t);
  }
  /**
   * Email Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOpened(e) {
    return this.track(new nc(), e);
  }
  /**
   * Email Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionDeleteClicked(e) {
    return this.track(new rc(), e);
  }
  /**
   * Email Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new ic(), e);
  }
  /**
   * Email Options Menu Option Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Email%20Clicked)
   *
   * When the user selects Edit Email in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionEmailClicked(e) {
    return this.track(new sc(), e);
  }
  /**
   * Email Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit Flow in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionFlowClicked(e) {
    return this.track(new oc(), e);
  }
  /**
   * Email Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionRenameClicked(e) {
    return this.track(new ac(), e);
  }
  /**
   * Email Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchApplied(e) {
    return this.track(new cc(), e);
  }
  /**
   * Email Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchClosed(e) {
    return this.track(new uc(), e);
  }
  /**
   * Email Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchOpened(e) {
    return this.track(new dc(), e);
  }
  /**
   * Flow Action Add Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Add%20Saved)
   *
   * When the user added an action and saved it.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionAddSaved(e, t) {
    return this.track(new lc(e), t);
  }
  /**
   * Flow Action Condition Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Condition%20Added)
   *
   * When the user adds a condition to a branch/condition-action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionConditionAdded(e, t) {
    return this.track(new pc(e), t);
  }
  /**
   * Flow Action Condition Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Condition%20Removed)
   *
   * When the user adds a condition to a branch/condition-action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionConditionRemoved(e, t) {
    return this.track(new hc(e), t);
  }
  /**
   * Flow Action Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Deleted)
   *
   * When the user deletes a node in a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionDeleted(e, t) {
    return this.track(new vc(e), t);
  }
  /**
   * Flow Action Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Edit%20Clicked)
   *
   * When the user clicks the edit button on an action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionEditClicked(e, t) {
    return this.track(new gc(e), t);
  }
  /**
   * Flow Action Edit Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Edit%20Saved)
   *
   * When the user saves an action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionEditSaved(e, t) {
    return this.track(new Cc(e), t);
  }
  /**
   * Flow Activate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Activate%20Clicked)
   *
   * When the user saves a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActivateClicked(e, t) {
    return this.track(new fc(e), t);
  }
  /**
   * Flow Add Action Action Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Action%20Selected)
   *
   * When the user selects a specific action to add
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionActionSelected(e, t) {
    return this.track(new kc(e), t);
  }
  /**
   * Flow Add Action Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Cancelled)
   *
   * When the user closes the add action modal without making a selection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionCancelled(e, t) {
    return this.track(new yc(e), t);
  }
  /**
   * Flow Add Action Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Opened)
   *
   * When the user opens the add action modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionOpened(e, t) {
    return this.track(new mc(e), t);
  }
  /**
   * Flow Back To Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Back%20To%20Settings%20Clicked)
   *
   * When the user clicks the go back to settings button in a Flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowBackToSettingsClicked(e, t) {
    return this.track(new _c(e), t);
  }
  /**
   * Flow Context Align Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Align%20Clicked)
   *
   * When the user clicks Align" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextAlignClicked(e, t) {
    return this.track(new wc(e), t);
  }
  /**
   * Flow Context Delete Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Cancel%20Clicked)
   *
   * When the user clicks Cancel" in the confirm modal after clicking the "Delete" option in context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteCancelClicked(e, t) {
    return this.track(new Sc(e), t);
  }
  /**
   * Flow Context Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Clicked)
   *
   * When the user clicks Delete" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteClicked(e, t) {
    return this.track(new bc(e), t);
  }
  /**
   * Flow Context Delete Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Confirm%20Clicked)
   *
   * When the user clicks Confirm" in the confirm modal after clicking the "Delete" option in context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteConfirmClicked(e, t) {
    return this.track(new Ic(e), t);
  }
  /**
   * Flow Context Node Arrange Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Node%20Arrange%20Clicked)
   *
   * When the user clicks Arrange nodes" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextNodeArrangeClicked(e, t) {
    return this.track(new Ac(e), t);
  }
  /**
   * Flow Phone Number Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Phone%20Number%20Changed)
   *
   * When the user changed the phone number in the phone flow.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  flowPhoneNumberChanged(e) {
    return this.track(new Oc(), e);
  }
  /**
   * Flow Save Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Save%20Clicked)
   *
   * When the user saves a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowSaveClicked(e, t) {
    return this.track(new Tc(e), t);
  }
  /**
   * Flow Title Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Title%20Edit%20Clicked)
   *
   * When the user clicks the Flow Title to Edit
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowTitleEditClicked(e, t) {
    return this.track(new Pc(e), t);
  }
  /**
   * Flow Zoom In Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20In%20Clicked)
   *
   * When the user uses zooms in using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomInClicked(e, t) {
    return this.track(new Ec(e), t);
  }
  /**
   * Flow Zoom Out Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20Out%20Clicked)
   *
   * When the user uses zooms out using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomOutClicked(e, t) {
    return this.track(new Fc(e), t);
  }
  /**
   * Flow Zoom Reset Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20Reset%20Clicked)
   *
   * When the user reset the zoom level using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomResetClicked(e, t) {
    return this.track(new Mc(e), t);
  }
  /**
   * Follow Up Conversation Modal Internal Note Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Follow%20Up%20Conversation%20Modal%20Internal%20Note%20Added)
   *
   * When the user selects the option to include an internal note
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  followUpConversationModalInternalNoteAdded(e) {
    return this.track(new Rc(), e);
  }
  /**
   * Follow Up Conversation Modal Offer In Queue Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Follow%20Up%20Conversation%20Modal%20Offer%20In%20Queue%20Added)
   *
   * When the user selects the option to offer the conversation in the queue
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  followUpConversationModalOfferInQueueAdded(e) {
    return this.track(new Dc(), e);
  }
  /**
   * Knowledge Article Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Archived)
   *
   * When a user archives an article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleArchived(e, t) {
    return this.track(new Uc(e), t);
  }
  /**
   * Knowledge Article Changes Discarded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Changes%20Discarded)
   *
   * When a user discards changes made to a work in progress article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleChangesDiscarded(e, t) {
    return this.track(new Hc(e), t);
  }
  /**
   * Knowledge Article Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Created)
   *
   * When an article is created in knowledge, either from content management or other sources (like conversation sidebar)
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleCreated(e, t) {
    return this.track(new Bc(e), t);
  }
  /**
   * Knowledge Article Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Destroyed)
   *
   * When the user deletes an article
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleDestroyed(e, t) {
    return this.track(new Lc(e), t);
  }
  /**
   * Knowledge Article Feedback Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Feedback%20Submitted)
   *
   * When a user submits feedback on an article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleFeedbackSubmitted(e, t) {
    return this.track(new Nc(e), t);
  }
  /**
   * Knowledge Article Marked As Helpful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Marked%20As%20Helpful)
   *
   * When a user indicates that an article was helpful
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. assistType)
   * @param options Amplitude event options.
   */
  knowledgeArticleMarkedAsHelpful(e, t) {
    return this.track(new Wc(e), t);
  }
  /**
   * Knowledge Article Moved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Moved)
   *
   * When the user moves an article to a new collection
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleMoved(e, t) {
    return this.track(new Vc(e), t);
  }
  /**
   * Knowledge Article Published
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Published)
   *
   * When a user publishes an article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticlePublished(e, t) {
    return this.track(new xc(e), t);
  }
  /**
   * Knowledge Article Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Reordered)
   *
   * When an article is re-ordered in the knowledge management screen
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleReordered(e, t) {
    return this.track(new Qc(e), t);
  }
  /**
   * Knowledge Article Tag Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Tag%20Added)
   *
   * When a user adds a tag to a knowledge article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleTagAdded(e, t) {
    return this.track(new Kc(e), t);
  }
  /**
   * Knowledge Article Tag Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Tag%20Removed)
   *
   * When a user removes a tag from a knowledge article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleTagRemoved(e, t) {
    return this.track(new qc(e), t);
  }
  /**
   * Knowledge Article Unpublished
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Unpublished)
   *
   * When a user unpublishes a knowledge article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleUnpublished(e, t) {
    return this.track(new zc(e), t);
  }
  /**
   * Knowledge Article Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Updated)
   *
   * When the user updates an article, either the content or meta
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleUpdated(e, t) {
    return this.track(new Gc(e), t);
  }
  /**
   * Knowledge Article Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Viewed)
   *
   * When a user views a knowledge article
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleViewed(e, t) {
    return this.track(new jc(e), t);
  }
  /**
   * Knowledge Articles Search By Term Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Articles%20Search%20By%20Term%20Submitted)
   *
   * When a user searches for knowledge articles
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeArticlesSearchByTermSubmitted(e, t) {
    return this.track(new Jc(e), t);
  }
  /**
   * Knowledge Category Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Created)
   *
   * When a user creates a knowledge category
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryCreated(e, t) {
    return this.track(new $c(e), t);
  }
  /**
   * Knowledge Category Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Destroyed)
   *
   * When a user deletes a knowledge category
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryDestroyed(e, t) {
    return this.track(new Yc(e), t);
  }
  /**
   * Knowledge Category Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Reordered)
   *
   * When a category is re-ordered in the knowledge management screen
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryReordered(e, t) {
    return this.track(new Zc(e), t);
  }
  /**
   * Knowledge Category Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Updated)
   *
   * When a user makes a change to a knowledge category
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryUpdated(e, t) {
    return this.track(new Xc(e), t);
  }
  /**
   * Knowledge Collection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Created)
   *
   * When a user creates a knowledge collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionCreated(e, t) {
    return this.track(new eu(e), t);
  }
  /**
   * Knowledge Collection Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Destroyed)
   *
   * When a user deletes a knowledge collection
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionDestroyed(e, t) {
    return this.track(new tu(e), t);
  }
  /**
   * Knowledge Collection Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Updated)
   *
   * When a user makes a change to a collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  knowledgeCollectionUpdated(e, t) {
    return this.track(new nu(e), t);
  }
  /**
   * Knowledge Collection Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Viewed)
   *
   * When a user views the knowledge collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionViewed(e, t) {
    return this.track(new ru(e), t);
  }
  /**
   * Knowledge Help Center Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Created)
   *
   * When the user creates a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterCreated(e, t) {
    return this.track(new iu(e), t);
  }
  /**
   * Knowledge Help Center Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Deleted)
   *
   * When the user updates a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterDeleted(e, t) {
    return this.track(new su(e), t);
  }
  /**
   * Knowledge Help Center Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Updated)
   *
   * When the user deletes a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterUpdated(e, t) {
    return this.track(new ou(e), t);
  }
  /**
   * Knowledge Internal Kb Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Internal%20Kb%20Dashboard%20Viewed)
   *
   * When a knowledge user views the dashboard in an Internal KB
   *
   * @param options Amplitude event options.
   */
  knowledgeInternalKbDashboardViewed(e) {
    return this.track(new au(), e);
  }
  /**
   * Knowledge Internal Kb Search Result Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Internal%20Kb%20Search%20Result%20Clicked)
   *
   * Knowledge Internal Kb Search Result Clicked
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeInternalKbSearchResultClicked(e, t) {
    return this.track(new cu(e), t);
  }
  /**
   * Knowledge Resolution Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Resolution%20Cancelled)
   *
   * When a knowledge resolution is cancelled
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  knowledgeResolutionCancelled(e, t) {
    return this.track(new uu(e), t);
  }
  /**
   * Knowledge Resolution Initialised
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Resolution%20Initialised)
   *
   * When a initialises a knowledge conversation resolution flow
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  knowledgeResolutionInitialised(e, t) {
    return this.track(new du(e), t);
  }
  /**
   * Merge Contacts Merge Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Cancelled)
   *
   * When a user has been selected and the modal is closed afterwards
   *
   * @param options Amplitude event options.
   */
  mergeContactsMergeCancelled(e) {
    return this.track(new lu(), e);
  }
  /**
   * Merge Contacts Merge Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Failed)
   *
   * When a merge is failing for some reason
   *
   * @param options Amplitude event options.
   */
  mergeContactsMergeFailed(e) {
    return this.track(new pu(), e);
  }
  /**
   * Merge Contacts Merge Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Succeeded)
   *
   * When a contact has successfully been merged
   *
   * @param properties The event's properties (e.g. numberOfEmails)
   * @param options Amplitude event options.
   */
  mergeContactsMergeSucceeded(e, t) {
    return this.track(new hu(e), t);
  }
  /**
   * Merge Contacts Modal Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Modal%20Closed)
   *
   * When the merge contacts modal is closed
   *
   * @param options Amplitude event options.
   */
  mergeContactsModalClosed(e) {
    return this.track(new vu(), e);
  }
  /**
   * Merge Contacts Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Modal%20Opened)
   *
   * When the merge contacts modal is opened
   *
   * @param options Amplitude event options.
   */
  mergeContactsModalOpened(e) {
    return this.track(new gu(), e);
  }
  /**
   * Merge Contacts Source Contact Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Source%20Contact%20Selected)
   *
   * When a contact is selected in the merge contacts modal
   *
   * @param options Amplitude event options.
   */
  mergeContactsSourceContactSelected(e) {
    return this.track(new Cu(), e);
  }
  /**
   * Messenger Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in messenger settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  messengerFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new fu(), e);
  }
  /**
   * Messenger Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Cancelled)
   *
   * When the user cancels the Messenger modal/form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormCancelled(e, t) {
    return this.track(new ku(e), t);
  }
  /**
   * Messenger Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Opened)
   *
   * When the user opens one of the Messenger listing modals/forms
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormOpened(e, t) {
    return this.track(new yu(e), t);
  }
  /**
   * Messenger Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Submitted)
   *
   * When the user proceeds on a messenger form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormSubmitted(e, t) {
    return this.track(new mu(e), t);
  }
  /**
   * Messenger Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  messengerOptionsMenuOpened(e) {
    return this.track(new _u(), e);
  }
  /**
   * Messenger Options Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Options%20Menu%20Option%20Clicked)
   *
   * When the user selects an option in the Messenger options menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  messengerOptionsMenuOptionClicked(e, t) {
    return this.track(new wu(e), t);
  }
  /**
   * Modal Conversation Close Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Conversation%20Close%20Cancel%20Clicked)
   *
   * When the user clicks cancel in the confirm close conversation modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  modalConversationCloseCancelClicked(e) {
    return this.track(new Su(), e);
  }
  /**
   * Modal Conversation Close Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Conversation%20Close%20Confirm%20Clicked)
   *
   * When the user clicks confirm in the confirm close conversation modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  modalConversationCloseConfirmClicked(e, t) {
    return this.track(new bu(e), t);
  }
  /**
   * Modal Transfer To Queue Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Transfer%20To%20Queue%20Cancel%20Clicked)
   *
   * When the user clicks cancel in the transfer to queue modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  modalTransferToQueueCancelClicked(e) {
    return this.track(new Iu(), e);
  }
  /**
   * Modal Transfer To Queue Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Transfer%20To%20Queue%20Confirm%20Clicked)
   *
   * When the user clicks confirm in the transfer to queue modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  modalTransferToQueueConfirmClicked(e, t) {
    return this.track(new Au(e), t);
  }
  /**
   * Network Connection Status Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Network%20Connection%20Status%20Changed)
   *
   * When the user network connection changes
   *
   * @param properties The event's properties (e.g. status)
   * @param options Amplitude event options.
   */
  networkConnectionStatusChanged(e, t) {
    return this.track(new Ou(e), t);
  }
  /**
   * Notification Offer Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Accepted)
   *
   * When the user accepts an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferAccepted(e, t) {
    return this.track(new Tu(e), t);
  }
  /**
   * Notification Offer Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Closed)
   *
   * When the user closes an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferClosed(e, t) {
    return this.track(new Pu(e), t);
  }
  /**
   * Notification Offer Rejected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Rejected)
   *
   * When the user rejects an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferRejected(e, t) {
    return this.track(new Eu(e), t);
  }
  /**
   * Notification Offer Timeout
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Timeout)
   *
   * When the offer notification times out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  notificationOfferTimeout(e) {
    return this.track(new Fu(), e);
  }
  /**
   * Notification Transfer Offer Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Accepted)
   *
   * When the user accepts a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferAccepted(e, t) {
    return this.track(new Mu(e), t);
  }
  /**
   * Notification Transfer Offer Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Closed)
   *
   * When the user closes a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferClosed(e, t) {
    return this.track(new Ru(e), t);
  }
  /**
   * Notification Transfer Offer Rejected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Rejected)
   *
   * When the user rejects a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferRejected(e, t) {
    return this.track(new Du(e), t);
  }
  /**
   * Notification Transfer Offer Timeout
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Timeout)
   *
   * When the transfer offer notification times out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  notificationTransferOfferTimeout(e) {
    return this.track(new Uu(), e);
  }
  /**
   * Organizations Navigation Organization Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Organizations%20Navigation%20Organization%20Clicked)
   *
   * When the user clicks an organization in the organizations navigation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  organizationsNavigationOrganizationClicked(e, t) {
    return this.track(new Hu(e), t);
  }
  /**
   * Partner Integrations Github Create New Issue Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Canceled)
   *
   * When the user closes the create new modal without confirming/saving.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueCanceled(e, t) {
    return this.track(new Bu(e), t);
  }
  /**
   * Partner Integrations Github Create New Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Clicked)
   *
   * When the user clicked on the create new button.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueClicked(e, t) {
    return this.track(new Lu(e), t);
  }
  /**
   * Partner Integrations Github Create New Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Confirmed)
   *
   * When the user confirmed to create a new issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueConfirmed(e, t) {
    return this.track(new Nu(e), t);
  }
  /**
   * Partner Integrations Github Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Link%20Issue%20Clicked)
   *
   * When the user clicked on an issue in the search results to link it to the conversation.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubLinkIssueClicked(e, t) {
    return this.track(new Wu(e), t);
  }
  /**
   * Partner Integrations Github Unlink All Issues Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Canceled)
   *
   * when the user canceled to unlink all issues.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesCanceled(e, t) {
    return this.track(new Vu(e), t);
  }
  /**
   * Partner Integrations Github Unlink All Issues Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Clicked)
   *
   * When the user clicked on the unlink all button.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesClicked(e, t) {
    return this.track(new xu(e), t);
  }
  /**
   * Partner Integrations Github Unlink All Issues Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Confirmed)
   *
   * When the user confirmed to unlink all issues.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesConfirmed(e, t) {
    return this.track(new Qu(e), t);
  }
  /**
   * Partner Integrations Github Unlink Issue Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Canceled)
   *
   * When the user canceled to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueCanceled(e, t) {
    return this.track(new Ku(e), t);
  }
  /**
   * Partner Integrations Github Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Clicked)
   *
   * When the user clicked on the button to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueClicked(e, t) {
    return this.track(new qu(e), t);
  }
  /**
   * Partner Integrations Github Unlink Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Confirmed)
   *
   * When the user confirmed to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueConfirmed(e, t) {
    return this.track(new zu(e), t);
  }
  /**
   * Partner Integrations Github View Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20View%20Link%20Clicked)
   *
   * When the user clicked on a linked issue to open it in Github.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubViewLinkClicked(e, t) {
    return this.track(new Gu(e), t);
  }
  /**
   * Partner Integrations Jira Comments Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Comments%20Collapsed)
   *
   * When the user collapses an issue's comments
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCommentsCollapsed(e, t) {
    return this.track(new ju(e), t);
  }
  /**
   * Partner Integrations Jira Comments Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Comments%20Expanded)
   *
   * When the user expands an issue's comments
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCommentsExpanded(e, t) {
    return this.track(new Ju(e), t);
  }
  /**
   * Partner Integrations Jira Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Link%20Issue%20Clicked)
   *
   * When the user creates a link to a Jira issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraLinkIssueClicked(e, t) {
    return this.track(new $u(e), t);
  }
  /**
   * Partner Integrations Jira Open Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Open%20Issue%20Clicked)
   *
   * When the user opens a Jira issue's details
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraOpenIssueClicked(e, t) {
    return this.track(new Yu(e), t);
  }
  /**
   * Partner Integrations Jira Open Jira Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Open%20Jira%20Clicked)
   *
   * When the user opens Jira from the widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraOpenJiraClicked(e, t) {
    return this.track(new Zu(e), t);
  }
  /**
   * Partner Integrations Jira Remove All Dangling Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Remove%20All%20Dangling%20Clicked)
   *
   * When the user clicks remove all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraRemoveAllDanglingClicked(e, t) {
    return this.track(new Xu(e), t);
  }
  /**
   * Partner Integrations Jira Remove Dangling Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Remove%20Dangling%20Issue%20Clicked)
   *
   * When the user clicks remove on a dangling link
   *
   * @param properties The event's properties (e.g. jiraDanglingIssueKey)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraRemoveDanglingIssueClicked(e, t) {
    return this.track(new ed(e), t);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Cancelled)
   *
   * When the user cancels removing all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesCancelled(e, t) {
    return this.track(new td(e), t);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Clicked)
   *
   * When the user clicks unlink all links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesClicked(e, t) {
    return this.track(new nd(e), t);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Confirmed)
   *
   * When the user confirms removing all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesConfirmed(e, t) {
    return this.track(new rd(e), t);
  }
  /**
   * Partner Integrations Jira Unlink Issue Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Cancelled)
   *
   * When the user cancels unlinking an issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueCancelled(e, t) {
    return this.track(new id(e), t);
  }
  /**
   * Partner Integrations Jira Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Clicked)
   *
   * When the user clicks unlink issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueClicked(e, t) {
    return this.track(new sd(e), t);
  }
  /**
   * Partner Integrations Jira Unlink Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Confirmed)
   *
   * When the user confirms unlinking an issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueConfirmed(e, t) {
    return this.track(new od(e), t);
  }
  /**
   * Partner Integrations Klaviyo Messages Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Messages%20Received)
   *
   * When the widget received messages
   *
   * @param properties The event's properties (e.g. emailsBounced)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoMessagesReceived(e, t) {
    return this.track(new ad(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Failed)
   *
   * When the widget failed to receive profile information
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileFailed(e, t) {
    return this.track(new cd(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Received)
   *
   * When the widget received profile information
   *
   * @param properties The event's properties (e.g. hasProfile)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileReceived(e, t) {
    return this.track(new ud(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Clicked)
   *
   * When the user clicked to subscribe to a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked(e, t) {
    return this.track(new dd(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Failed)
   *
   * When the subscription to a channel failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed(e, t) {
    return this.track(new ld(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Succeeded)
   *
   * When the user successfully subscribed to a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded(e, t) {
    return this.track(new pd(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Clicked)
   *
   * When the user unsubscribed a given channel
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeClicked(e, t) {
    return this.track(new hd(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Failed)
   *
   * When the user unsubscription attempt failed
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeFailed(e, t) {
    return this.track(new vd(e), t);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Succeeded)
   *
   * When the user successfully unsubscribed from a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeSucceeded(e, t) {
    return this.track(new gd(e), t);
  }
  /**
   * Partner Integrations Linear Create New Issue Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Cancelled)
   *
   * When the user cancels to create a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueCancelled(e, t) {
    return this.track(new Cd(e), t);
  }
  /**
   * Partner Integrations Linear Create New Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Clicked)
   *
   * When the user clicks to open a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueClicked(e, t) {
    return this.track(new fd(e), t);
  }
  /**
   * Partner Integrations Linear Create New Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Confirmed)
   *
   * When the user confirms to create a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueConfirmed(e, t) {
    return this.track(new kd(e), t);
  }
  /**
   * Partner Integrations Linear Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Link%20Issue%20Clicked)
   *
   * When the user creates a link to a Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearLinkIssueClicked(e, t) {
    return this.track(new yd(e), t);
  }
  /**
   * Partner Integrations Linear Open Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Open%20Issue%20Clicked)
   *
   * When the user opens the details of a Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearOpenIssueClicked(e, t) {
    return this.track(new md(e), t);
  }
  /**
   * Partner Integrations Linear Open Linear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Open%20Linear%20Clicked)
   *
   * When the user opens Linear from the widget
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearOpenLinearClicked(e, t) {
    return this.track(new _d(e), t);
  }
  /**
   * Partner Integrations Linear Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Unlink%20Issue%20Clicked)
   *
   * When the user clicks unlink issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearUnlinkIssueClicked(e, t) {
    return this.track(new wd(e), t);
  }
  /**
   * Partner Integrations Settings Create Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Create%20Submitted)
   *
   * When the user submitted the creation of a partner integration configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsCreateSubmitted(e, t) {
    return this.track(new Sd(e), t);
  }
  /**
   * Partner Integrations Settings Overview Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Overview%20Created)
   *
   * When the user created a partner integration settings page from the integration settings overview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsOverviewCreated(e, t) {
    return this.track(new bd(e), t);
  }
  /**
   * Partner Integrations Settings Overview Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Overview%20Viewed)
   *
   * When the user viewed a partner integration settings page from the integration settings overview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsOverviewViewed(e, t) {
    return this.track(new Id(e), t);
  }
  /**
   * Partner Integrations Settings View Delete Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Canceled)
   *
   * When the user canceled the deletion request
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteCanceled(e, t) {
    return this.track(new Ad(e), t);
  }
  /**
   * Partner Integrations Settings View Delete Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Confirmed)
   *
   * When the user confirmed the deletion of a partner integrations configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteConfirmed(e, t) {
    return this.track(new Od(e), t);
  }
  /**
   * Partner Integrations Settings View Delete Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Requested)
   *
   * Then the user requested the deletion of a partner integrations configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteRequested(e, t) {
    return this.track(new Td(e), t);
  }
  /**
   * Partner Integrations Settings View OAuth Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20OAuth%20Started)
   *
   * When the user clicked the OAuth button in the widget settings view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewOAuthStarted(e, t) {
    return this.track(new Pd(e), t);
  }
  /**
   * Partner Integrations Settings View OAuth Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20OAuth%20Succeeded)
   *
   * When the user clicked the OAuth button in the widget settings view and the connection was successful
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewOAuthSucceeded(e, t) {
    return this.track(new Ed(e), t);
  }
  /**
   * Partner Integrations Settings View Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Submitted)
   *
   * When the user submitted changes to a partner integration configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewSubmitted(e, t) {
    return this.track(new Fd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Collapse Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Collapse%20Closed)
   *
   * When the user closed an order collapse inside the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCollapseClosed(e, t) {
    return this.track(new Md(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Collapse Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Collapse%20Opened)
   *
   * When the user opened an order collapse inside the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCollapseOpened(e, t) {
    return this.track(new Rd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Modal%20Canceled)
   *
   * When the user canceled the change of the shipping address of an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled(e, t) {
    return this.track(new Dd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Modal%20Opened)
   *
   * When the user opened the change shipping address modal for an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened(e, t) {
    return this.track(new Ud(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Submitted)
   *
   * When the user submitted a change of the shipping address for an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted(e, t) {
    return this.track(new Hd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Canceled)
   *
   * When the user canceled the refund order option request
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundCanceled(e, t) {
    return this.track(new Bd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Confirmed)
   *
   * When the user confirmed the refund order option
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundConfirmed(e, t) {
    return this.track(new Ld(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Requested)
   *
   * When the user requested the refund order option
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundRequested(e, t) {
    return this.track(new Nd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20View%20All%20Orders%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view all orders in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked(e, t) {
    return this.track(new Wd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Order View Order In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20View%20Order%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view order in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked(e, t) {
    return this.track(new Vd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget Refreshed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Refreshed)
   *
   * When the user refreshed the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetRefreshed(e, t) {
    return this.track(new xd(e), t);
  }
  /**
   * Partner Integrations Shopify Widget View Customer In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20View%20Customer%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view customer in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked(e, t) {
    return this.track(new Qd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Clicked)
   *
   * If the icon to subscribe to a channel got clicked.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionClicked(e, t) {
    return this.track(new Kd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Failed)
   *
   * If a channel subscription failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionFailed(e, t) {
    return this.track(new qd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Succeeded)
   *
   * If a channel subscription succeeded.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded(e, t) {
    return this.track(new zd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Clicked)
   *
   * If the icon to unsubscribe to a channel got clicked.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked(e, t) {
    return this.track(new Gd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Failed)
   *
   * If a channel unsubscription failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed(e, t) {
    return this.track(new jd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Succeeded)
   *
   * If a channel unsubscription succeeded.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded(e, t) {
    return this.track(new Jd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Message External Link Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Message%20External%20Link%20Opened)
   *
   * A link to an external message got opened.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetMessageExternalLinkOpened(e, t) {
    return this.track(new $d(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Messages Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Messages%20Received)
   *
   * Describes if the widget received messages.
   *
   * @param properties The event's properties (e.g. emailsReceived)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetMessagesReceived(e, t) {
    return this.track(new Yd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Profile%20Received)
   *
   * Describes if the widget received profile informations.
   *
   * @param properties The event's properties (e.g. hasProfile)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetProfileReceived(e, t) {
    return this.track(new Zd(e), t);
  }
  /**
   * Partner Integrations Voyado Widget Transactions Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Transactions%20Received)
   *
   * Describes if the widget received transactions.
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetTransactionsReceived(e, t) {
    return this.track(new Xd(e), t);
  }
  /**
   * Partner Integrations Widget Collapse Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Collapse%20Closed)
   *
   * When the user closed the partner integration widget in the conversation sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetCollapseClosed(e, t) {
    return this.track(new el(e), t);
  }
  /**
   * Partner Integrations Widget Collapse Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Collapse%20Opened)
   *
   * When the user opened the partner integration widget in the conversation sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetCollapseOpened(e, t) {
    return this.track(new tl(e), t);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Add Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Add%20Points%20Failed)
   *
   * When adding points to the customers points balance failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionAddPointsFailed(e) {
    return this.track(new nl(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Add Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Add%20Points%20Succeeded)
   *
   * When the agent successfuly added points to the customers point balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded(e) {
    return this.track(new rl(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Customer Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Customer%20Received)
   *
   * When the user received customer data to be displayed in the integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionCustomerReceived(e) {
    return this.track(new il(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Remove Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Remove%20Points%20Failed)
   *
   * When removing points from the customers point balance failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionRemovePointsFailed(e) {
    return this.track(new sl(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Remove Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Remove%20Points%20Succeeded)
   *
   * When the agent successfuly removed points from the customers points balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded(e) {
    return this.track(new ol(), e);
  }
  /**
   * Phone Actions Menu Action Add Outbound Caller ID Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Action%20Add%20Outbound%20Caller%20ID%20Clicked)
   *
   * When the user selects Add outbound caller ID from the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuActionAddOutboundCallerIdClicked(e) {
    return this.track(new al(), e);
  }
  /**
   * Phone Actions Menu Action Change Hold Music Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Action%20Change%20Hold%20Music%20Clicked)
   *
   * When the user selects Change hold music from the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuActionChangeHoldMusicClicked(e) {
    return this.track(new cl(), e);
  }
  /**
   * Phone Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Opened)
   *
   * When the users opens the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuOpened(e) {
    return this.track(new ul(), e);
  }
  /**
   * Phone Add Outbound Caller ID Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Add%20Outbound%20Caller%20ID%20Form%20Cancelled)
   *
   * When the user cancels to verify a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneAddOutboundCallerIdFormCancelled(e) {
    return this.track(new dl(), e);
  }
  /**
   * Phone Add Outbound Caller ID Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Add%20Outbound%20Caller%20ID%20Form%20Submitted)
   *
   * When the user verifies a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneAddOutboundCallerIdFormSubmitted(e) {
    return this.track(new ll(), e);
  }
  /**
   * Phone Change Hold Music Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Change%20Hold%20Music%20Form%20Cancelled)
   *
   * When the user cancels the change the hold music form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneChangeHoldMusicFormCancelled(e) {
    return this.track(new pl(), e);
  }
  /**
   * Phone Change Hold Music Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Change%20Hold%20Music%20Form%20Submitted)
   *
   * When the user changes the hold music
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneChangeHoldMusicFormSubmitted(e) {
    return this.track(new hl(), e);
  }
  /**
   * Phone Create Flow Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Create%20Flow%20Form%20Cancelled)
   *
   * When the user cancels the Create flow form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneCreateFlowFormCancelled(e) {
    return this.track(new vl(), e);
  }
  /**
   * Phone Create Flow Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Create%20Flow%20Form%20Submitted)
   *
   * When the user submit the Create flow form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneCreateFlowFormSubmitted(e) {
    return this.track(new gl(), e);
  }
  /**
   * Phone Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in phone settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new Cl(), e);
  }
  /**
   * Phone Flow Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionDeleteClicked(e) {
    return this.track(new fl(), e);
  }
  /**
   * Phone Flow Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new kl(), e);
  }
  /**
   * Phone Flow Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selects Edit from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionEditClicked(e) {
    return this.track(new yl(), e);
  }
  /**
   * Phone Flow Options Menu Option Move To Another Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Move%20To%20Another%20Number%20Clicked)
   *
   * When the user selects Move to another number from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionMoveToAnotherNumberClicked(e) {
    return this.track(new ml(), e);
  }
  /**
   * Phone Flow Options Menu Option Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Opened)
   *
   * When the user opens the flow ellipsis menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionOpened(e) {
    return this.track(new _l(), e);
  }
  /**
   * Phone Flow Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionRenameClicked(e) {
    return this.track(new wl(), e);
  }
  /**
   * Phone Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Cancelled)
   *
   * When the user cancels the buy number form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormCancelled(e) {
    return this.track(new Sl(), e);
  }
  /**
   * Phone Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Opened)
   *
   * When the user opens the buy number form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormOpened(e) {
    return this.track(new bl(), e);
  }
  /**
   * Phone Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Submitted)
   *
   * When the user buys a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormSubmitted(e) {
    return this.track(new Il(), e);
  }
  /**
   * Phone Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Opened)
   *
   * When the user opens the ellipsis menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOpened(e) {
    return this.track(new Al(), e);
  }
  /**
   * Phone Options Menu Option Create Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Create%20Flow%20Clicked)
   *
   * When the user selects Create flow from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionCreateFlowClicked(e) {
    return this.track(new Ol(), e);
  }
  /**
   * Phone Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selects Edit from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionEditClicked(e) {
    return this.track(new Tl(), e);
  }
  /**
   * Phone Options Menu Option Remove Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Remove%20Number%20Clicked)
   *
   * When the user selects Remove number from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionRemoveNumberClicked(e) {
    return this.track(new Pl(), e);
  }
  /**
   * Phone Options Menu Option Set Default Caller ID Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Set%20Default%20Caller%20ID%20Clicked)
   *
   * When the user selects Set default caller ID from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionSetDefaultCallerIdClicked(e) {
    return this.track(new El(), e);
  }
  /**
   * Phone Options Menu Option Setup Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Setup%20Clicked)
   *
   * When the user selects Setup from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionSetupClicked(e) {
    return this.track(new Fl(), e);
  }
  /**
   * Phone Recording Downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Downloaded)
   *
   * When a user downloads the voice conversation recording
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingDownloaded(e, t) {
    return this.track(new Ml(e), t);
  }
  /**
   * Phone Recording Pause Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Pause%20Clicked)
   *
   * When a user clicks pause" on the voice conversation recording"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPauseClicked(e, t) {
    return this.track(new Rl(e), t);
  }
  /**
   * Phone Recording Play Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Play%20Clicked)
   *
   * When a user clicks play" on the voice conversation recording"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlayClicked(e, t) {
    return this.track(new Dl(e), t);
  }
  /**
   * Phone Recording Playback Abandoned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Playback%20Abandoned)
   *
   * When a user navigates away from a conversation while the voice conversation recording is playing
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlaybackAbandoned(e, t) {
    return this.track(new Ul(e), t);
  }
  /**
   * Phone Recording Playback Ended
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Playback%20Ended)
   *
   * When the voice conversation recording plays through to the end
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlaybackEnded(e, t) {
    return this.track(new Hl(e), t);
  }
  /**
   * Phone Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Search%20Applied)
   *
   * When the user searches for a flow
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneSearchApplied(e) {
    return this.track(new Bl(), e);
  }
  /**
   * Presence Media Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Media%20Updated)
   *
   * When the user updates their availability for a channel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  presenceMediaUpdated(e, t) {
    return this.track(new Ll(e), t);
  }
  /**
   * Presence Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Updated)
   *
   * When the user updates their status to Away or Working
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  presenceUpdated(e, t) {
    return this.track(new Nl(e), t);
  }
  /**
   * Push Notification Platform Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Cancelled)
   *
   * When the user cancels the push notification platform modal/form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormCancelled(e, t) {
    return this.track(new Wl(e), t);
  }
  /**
   * Push Notification Platform Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Opened)
   *
   * When the user opens one of the push notification platform listing modals/forms
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormOpened(e, t) {
    return this.track(new Vl(e), t);
  }
  /**
   * Push Notification Platform Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Submitted)
   *
   * When the user submits push notification platform form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormSubmitted(e, t) {
    return this.track(new xl(e), t);
  }
  /**
   * Saved Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Applied)
   *
   * When the user applies a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchApplied(e) {
    return this.track(new Ql(), e);
  }
  /**
   * Saved Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Closed)
   *
   * When the user closes a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchClosed(e) {
    return this.track(new Kl(), e);
  }
  /**
   * Saved Search Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Created)
   *
   * When the user creates a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. saveAsNew)
   * @param options Amplitude event options.
   */
  savedSearchCreated(e, t) {
    return this.track(new ql(e), t);
  }
  /**
   * Saved Search Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Deleted)
   *
   * When the user deletes a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchDeleted(e) {
    return this.track(new zl(), e);
  }
  /**
   * Saved Search Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Updated)
   *
   * When the user updates a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchUpdated(e) {
    return this.track(new Gl(), e);
  }
  /**
   * Scheduled Conversations Csv Import Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Scheduled%20Conversations%20Csv%20Import%20Clicked)
   *
   * When the user clicks the import csv button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  scheduledConversationsCsvImportClicked(e) {
    return this.track(new jl(), e);
  }
  /**
   * Scheduled Conversations Csv Imported
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Scheduled%20Conversations%20Csv%20Imported)
   *
   * When the user submits a csv file
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  scheduledConversationsCsvImported(e) {
    return this.track(new Jl(), e);
  }
  /**
   * Search Contact Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Closed)
   *
   * When the users closes the contact preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewClosed(e, t) {
    return this.track(new $l(e), t);
  }
  /**
   * Search Contact Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full contact view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewGoToClicked(e, t) {
    return this.track(new Yl(e), t);
  }
  /**
   * Search Contact Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Opened)
   *
   * When the users clicks on a contact in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewOpened(e, t) {
    return this.track(new Zl(e), t);
  }
  /**
   * Search Contact Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Type%20Changed)
   *
   * When the users changes the contact type in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactTypeChanged(e, t) {
    return this.track(new Xl(e), t);
  }
  /**
   * Search Conversation Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Closed)
   *
   * When the user closes the conversation preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchConversationPreviewClosed(e) {
    return this.track(new ep(), e);
  }
  /**
   * Search Conversation Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full conversation view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  searchConversationPreviewGoToClicked(e, t) {
    return this.track(new tp(e), t);
  }
  /**
   * Search Conversation Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Opened)
   *
   * When the user clicks on a conversation in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  searchConversationPreviewOpened(e, t) {
    return this.track(new np(e), t);
  }
  /**
   * Search Field Blurred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Blurred)
   *
   * When the user clicks outside of the search field and it loses focus
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldBlurred(e, t) {
    return this.track(new rp(e), t);
  }
  /**
   * Search Field Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Cleared)
   *
   * When the user clicks the button to clear the search field
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldCleared(e, t) {
    return this.track(new ip(e), t);
  }
  /**
   * Search Field Focused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Focused)
   *
   * When the user clicks on the search field and it becomes focused
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldFocused(e, t) {
    return this.track(new sp(e), t);
  }
  /**
   * Search Field Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Submitted)
   *
   * When the user submits the value in the search field
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isEmpty)
   * @param options Amplitude event options.
   */
  searchFieldSubmitted(e, t) {
    return this.track(new op(e), t);
  }
  /**
   * Search Filter Condition Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Condition%20Added)
   *
   * When the user clears the value of a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFilterConditionAdded(e, t) {
    return this.track(new ap(e), t);
  }
  /**
   * Search Filter Condition Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Condition%20Removed)
   *
   * When the user removes a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchFilterConditionRemoved(e, t) {
    return this.track(new cp(e), t);
  }
  /**
   * Search Filter Operator Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Operator%20Updated)
   *
   * When the user updates the operator of a search filter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. operator)
   * @param options Amplitude event options.
   */
  searchFilterOperatorUpdated(e, t) {
    return this.track(new up(e), t);
  }
  /**
   * Search Filter Strategy Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Strategy%20Updated)
   *
   * When the user updates the search filtering strategy
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. strategy)
   * @param options Amplitude event options.
   */
  searchFilterStrategyUpdated(e, t) {
    return this.track(new dp(e), t);
  }
  /**
   * Search Filter Value Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Value%20Added)
   *
   * When the user adds a value to a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. operator)
   * @param options Amplitude event options.
   */
  searchFilterValueAdded(e, t) {
    return this.track(new lp(e), t);
  }
  /**
   * Search Filter Value Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Value%20Cleared)
   *
   * When the user adds a value to a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFilterValueCleared(e, t) {
    return this.track(new pp(e), t);
  }
  /**
   * Search Filters Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Applied)
   *
   * When the user applies the search filters
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersApplied(e, t) {
    return this.track(new hp(e), t);
  }
  /**
   * Search Filters Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Cleared)
   *
   * When the user clears the search filters
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersCleared(e, t) {
    return this.track(new vp(e), t);
  }
  /**
   * Search Filters Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Closed)
   *
   * When the user closes the search filters sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersClosed(e, t) {
    return this.track(new gp(e), t);
  }
  /**
   * Search Filters Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Opened)
   *
   * When the user opens the search filters sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersOpened(e, t) {
    return this.track(new Cp(e), t);
  }
  /**
   * Search Filters Validation Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Validation%20Failed)
   *
   * When the validation of the search filters fails
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. errors)
   * @param options Amplitude event options.
   */
  searchFiltersValidationFailed(e, t) {
    return this.track(new fp(e), t);
  }
  /**
   * Search Note Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Note%20Preview%20Closed)
   *
   * When the user closes the note preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchNotePreviewClosed(e) {
    return this.track(new kp(), e);
  }
  /**
   * Search Note Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Note%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full conversation view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchNotePreviewGoToClicked(e) {
    return this.track(new yp(), e);
  }
  /**
   * Search Note Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Note%20Preview%20Opened)
   *
   * When the user clicks on a note in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchNotePreviewOpened(e) {
    return this.track(new mp(), e);
  }
  /**
   * Search Sorting Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Sorting%20Updated)
   *
   * When the user changes the search results sorting
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  searchSortingUpdated(e, t) {
    return this.track(new _p(e), t);
  }
  /**
   * Search Strict Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Strict%20Toggled)
   *
   * When the user toggles strict search
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  searchStrictToggled(e, t) {
    return this.track(new wp(e), t);
  }
  /**
   * Search Tab Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Tab%20Opened)
   *
   * When the user opens a different search tab
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  searchTabOpened(e, t) {
    return this.track(new Sp(e), t);
  }
  /**
   * Settings Agents Add Agent Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Add%20Agent%20Button%20Clicked)
   *
   * When the user clicks on Add agent" button on agents settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsAgentsAddAgentButtonClicked(e) {
    return this.track(new bp(), e);
  }
  /**
   * Settings Agents Edit Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Edit%20Button%20Clicked)
   *
   * When the user clicks on the edit icon in the agents table on settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsAgentsEditButtonClicked(e) {
    return this.track(new Ip(), e);
  }
  /**
   * Settings Agents Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Tab%20Clicked)
   *
   * When the user switches between tabs on agents settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsAgentsTabClicked(e, t) {
    return this.track(new Ap(e), t);
  }
  /**
   * Settings Agents Workloads Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Workloads%20Form%20Submitted)
   *
   * When the user submits the form on workloads tab on agents settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. payload)
   * @param options Amplitude event options.
   */
  settingsAgentsWorkloadsFormSubmitted(e, t) {
    return this.track(new Op(e), t);
  }
  /**
   * Settings Audio Delete Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Cancel%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteCancelClicked(e, t) {
    return this.track(new Tp(e), t);
  }
  /**
   * Settings Audio Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteClicked(e, t) {
    return this.track(new Pp(e), t);
  }
  /**
   * Settings Audio Delete Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Confirm%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteConfirmClicked(e, t) {
    return this.track(new Ep(e), t);
  }
  /**
   * Settings Audio Upload Wait Music
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Upload%20Wait%20Music)
   *
   * When the user uploads a wait music file
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioUploadWaitMusic(e, t) {
    return this.track(new Fp(e), t);
  }
  /**
   * Settings Audio Usage Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Usage%20Flow%20Clicked)
   *
   * When the user interacts with audio usage
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioUsageFlowClicked(e, t) {
    return this.track(new Mp(e), t);
  }
  /**
   * Settings Audio Usage Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Usage%20Link%20Clicked)
   *
   * When the user interacts with audio usage
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioUsageLinkClicked(e, t) {
    return this.track(new Rp(e), t);
  }
  /**
   * Settings Commands Assign Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Assign%20Keybindings)
   *
   * When the user assigns keybindings to a command
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsAssignKeybindings(e, t) {
    return this.track(new Dp(e), t);
  }
  /**
   * Settings Commands Reset All Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Reset%20All%20Keybindings)
   *
   * When the user resets all commands to their default keybindings
   *
   * @param options Amplitude event options.
   */
  settingsCommandsResetAllKeybindings(e) {
    return this.track(new Up(), e);
  }
  /**
   * Settings Commands Reset Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Reset%20Keybindings)
   *
   * When the user resets a command's keybindings
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsResetKeybindings(e, t) {
    return this.track(new Hp(e), t);
  }
  /**
   * Settings Commands Unassign All Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Unassign%20All%20Keybindings)
   *
   * When the user unassigns all commands' keybindings
   *
   * @param options Amplitude event options.
   */
  settingsCommandsUnassignAllKeybindings(e) {
    return this.track(new Bp(), e);
  }
  /**
   * Settings Commands Unassign Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Unassign%20Keybindings)
   *
   * When the user unassigns a command's keybindings
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsUnassignKeybindings(e, t) {
    return this.track(new Lp(e), t);
  }
  /**
   * Settings Custom Attribute Activated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Activated)
   *
   * When the user activated a custom attribute
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeActivated(e, t) {
    return this.track(new Np(e), t);
  }
  /**
   * Settings Custom Attribute Add New Attribute Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Add%20New%20Attribute%20Clicked)
   *
   * When the user clicks the Add new attribute button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. entityId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeAddNewAttributeClicked(e, t) {
    return this.track(new Wp(e), t);
  }
  /**
   * Settings Custom Attribute Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Archived)
   *
   * When the user archives a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeArchived(e, t) {
    return this.track(new Vp(e), t);
  }
  /**
   * Settings Custom Attribute Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Created)
   *
   * When the user create a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. entityId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeCreated(e, t) {
    return this.track(new xp(e), t);
  }
  /**
   * Settings Custom Attribute Deactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Deactivated)
   *
   * When the user deactivates a custom attribute
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeDeactivated(e, t) {
    return this.track(new Qp(e), t);
  }
  /**
   * Settings Custom Attribute Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Reordered)
   *
   * When the user reorders a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeReordered(e, t) {
    return this.track(new Kp(e), t);
  }
  /**
   * Settings Custom Attribute Unarchived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Unarchived)
   *
   * When the user unarchives a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeUnarchived(e, t) {
    return this.track(new qp(e), t);
  }
  /**
   * Settings Custom Attribute Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Updated)
   *
   * When the user updates a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeUpdated(e, t) {
    return this.track(new zp(e), t);
  }
  /**
   * Settings Integrations Api Tokens Add Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Add%20Confirm)
   *
   * When the user creates a new API token
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. apiTokenVersion)
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensAddConfirm(e, t) {
    return this.track(new Gp(e), t);
  }
  /**
   * Settings Integrations Api Tokens Copy
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Copy)
   *
   * When the user clicks on the button to copy an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensCopy(e) {
    return this.track(new jp(), e);
  }
  /**
   * Settings Integrations Api Tokens Documentation Link Integrations Api
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Documentation%20Link%20Integrations%20Api)
   *
   * When the user clicks on the link to open the documentation for the Integrations API
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensDocumentationLinkIntegrationsApi(e) {
    return this.track(new Jp(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove)
   *
   * When the user clicks on the button to remove an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemove(e) {
    return this.track(new $p(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove%20Cancel)
   *
   * When the user cancels removing an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemoveCancel(e) {
    return this.track(new Yp(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove%20Confirm)
   *
   * When the user confirms removing an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemoveConfirm(e) {
    return this.track(new Zp(), e);
  }
  /**
   * Settings Integrations Api Tokens View
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20View)
   *
   * When the user clicks on the button to view an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensView(e) {
    return this.track(new Xp(), e);
  }
  /**
   * Settings Integrations Card Edit Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Edit%20Save)
   *
   * When the user is on the card edit page and saves changes to an existing card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardEditSave(e, t) {
    return this.track(new eh(e), t);
  }
  /**
   * Settings Integrations Card Edit Test
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Edit%20Test)
   *
   * When the user is on the card edit page and clicks on Test
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardEditTest(e, t) {
    return this.track(new th(e), t);
  }
  /**
   * Settings Integrations Card Listing Add Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Add%20Card)
   *
   * When the user clicks on Add card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingAddCard(e, t) {
    return this.track(new nh(e), t);
  }
  /**
   * Settings Integrations Card Listing Edit Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Edit%20Card)
   *
   * When the user clicks on Edit card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingEditCard(e, t) {
    return this.track(new rh(e), t);
  }
  /**
   * Settings Integrations Card Listing Remove Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Remove%20Card)
   *
   * When the user clicks on Remove Card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingRemoveCard(e, t) {
    return this.track(new ih(e), t);
  }
  /**
   * Settings Integrations Card Listing Remove Card Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Remove%20Card%20Cancel)
   *
   * When the user clicks on Remove Card but cancels the dialog
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingRemoveCardCancel(e, t) {
    return this.track(new sh(e), t);
  }
  /**
   * Settings Integrations Card Listing Remove Card Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Remove%20Card%20Confirm)
   *
   * When the user clicks on Remove Card and confirms the dialog
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingRemoveCardConfirm(e, t) {
    return this.track(new oh(e), t);
  }
  /**
   * Settings Integrations Card Listing Test Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Test%20Card)
   *
   * When the user clicks on Test card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingTestCard(e, t) {
    return this.track(new ah(e), t);
  }
  /**
   * Settings Integrations Card Read Documentation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Read%20Documentation)
   *
   * When the user clicks on the documentation link in the header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardRoute)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardReadDocumentation(e, t) {
    return this.track(new ch(e), t);
  }
  /**
   * Settings Integrations Card Test
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test)
   *
   * When the user is on the test card page and clicks on Test
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTest(e, t) {
    return this.track(new uh(e), t);
  }
  /**
   * Settings Integrations Card Test Add Parameter
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test%20Add%20Parameter)
   *
   * When the user is on the test card page and adds a parameter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTestAddParameter(e, t) {
    return this.track(new dh(e), t);
  }
  /**
   * Settings Integrations Card Test Remove Parameter
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test%20Remove%20Parameter)
   *
   * When the user is on the test card page and removes a parameter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTestRemoveParameter(e, t) {
    return this.track(new lh(e), t);
  }
  /**
   * Settings Integrations Custom Card Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Created)
   *
   * When the user created a custom card.
   *
   * @param properties The event's properties (e.g. authorizationHeader)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardCreated(e, t) {
    return this.track(new ph(e), t);
  }
  /**
   * Settings Integrations Custom Card Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Edited)
   *
   * When the user edited a custom card.
   *
   * @param properties The event's properties (e.g. authorizationHeader)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardEdited(e, t) {
    return this.track(new hh(e), t);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Failed)
   *
   * When the authentication of the OAuth provider failed.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationFailed(e, t) {
    return this.track(new vh(e), t);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Succeeded)
   *
   * When the authentication of the OAuth provider succeeded.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded(e, t) {
    return this.track(new gh(e), t);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Timed Out
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Timed%20Out)
   *
   * When the authentication of the OAuth provider timed out.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut(e, t) {
    return this.track(new Ch(e), t);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Created)
   *
   * When the user created a new OAuth provider.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderCreated(e, t) {
    return this.track(new fh(e), t);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Updated)
   *
   * When the user updated an existing OAuth provider.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderUpdated(e, t) {
    return this.track(new kh(e), t);
  }
  /**
   * Settings Integrations Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Item%20Clicked)
   *
   * When the user clicks on one of the integrations
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. integrationsId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsItemClicked(e, t) {
    return this.track(new yh(e), t);
  }
  /**
   * Settings Integrations Webform Endpoints Add Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Add%20Save)
   *
   * When the user adds a new webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. hasRedirectUrl)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsAddSave(e, t) {
    return this.track(new mh(e), t);
  }
  /**
   * Settings Integrations Webform Endpoints Copy
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Copy)
   *
   * When the user copies a webform endpoint
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsCopy(e) {
    return this.track(new _h(), e);
  }
  /**
   * Settings Integrations Webform Endpoints Read Documentation Link
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Read%20Documentation%20Link)
   *
   * When the user clicks on the documentation link in the header of the webforms endpoint page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsReadDocumentationLink(e) {
    return this.track(new wh(), e);
  }
  /**
   * Settings Integrations Webform Endpoints Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove)
   *
   * When the user clicks the delete button on a webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemove(e, t) {
    return this.track(new Sh(e), t);
  }
  /**
   * Settings Integrations Webform Endpoints Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove%20Cancel)
   *
   * When the user cancels deleting a webform endpoint
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemoveCancel(e, t) {
    return this.track(new bh(e), t);
  }
  /**
   * Settings Integrations Webform Endpoints Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove%20Confirm)
   *
   * When the user confirms deleting a webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemoveConfirm(e, t) {
    return this.track(new Ih(e), t);
  }
  /**
   * Settings Integrations Webhooks Add
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Add)
   *
   * When the user confirms adding a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksAdd(e) {
    return this.track(new Ah(), e);
  }
  /**
   * Settings Integrations Webhooks Add Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Add%20Confirm)
   *
   * When the user adds a new webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksAddConfirm(e) {
    return this.track(new Oh(), e);
  }
  /**
   * Settings Integrations Webhooks Documentation Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Documentation%20Link%20Clicked)
   *
   * When the user clicks on the webhooks documentation link
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksDocumentationLinkClicked(e) {
    return this.track(new Th(), e);
  }
  /**
   * Settings Integrations Webhooks Edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Edit)
   *
   * When the user clicks on the button to edit a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEdit(e) {
    return this.track(new Ph(), e);
  }
  /**
   * Settings Integrations Webhooks Edit Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Edit%20Save)
   *
   * When the user clicks on the button to save changes to a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEditSave(e) {
    return this.track(new Eh(), e);
  }
  /**
   * Settings Integrations Webhooks Enabled Off
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Enabled%20Off)
   *
   * When the user disables a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEnabledOff(e) {
    return this.track(new Fh(), e);
  }
  /**
   * Settings Integrations Webhooks Enabled On
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Enabled%20On)
   *
   * When the user enables a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEnabledOn(e) {
    return this.track(new Mh(), e);
  }
  /**
   * Settings Integrations Webhooks Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove)
   *
   * When the user clicks on the button to remove a webhook
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemove(e) {
    return this.track(new Rh(), e);
  }
  /**
   * Settings Integrations Webhooks Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove%20Cancel)
   *
   * When the user cancels removing a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemoveCancel(e) {
    return this.track(new Dh(), e);
  }
  /**
   * Settings Integrations Webhooks Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove%20Confirm)
   *
   * When the user confirms removing a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemoveConfirm(e) {
    return this.track(new Uh(), e);
  }
  /**
   * Settings Integrations Webhooks View
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View)
   *
   * When the user clicks on the button to view a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksView(e) {
    return this.track(new Hh(), e);
  }
  /**
   * Settings Integrations Webhooks View Copy Secret
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Copy%20Secret)
   *
   * When the user clicks on the copy webhook URL button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewCopySecret(e) {
    return this.track(new Bh(), e);
  }
  /**
   * Settings Integrations Webhooks View Copy Url
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Copy%20Url)
   *
   * When the user is on the Settings/Webhooks page and views a webhook and clicks on the copy URL button
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewCopyUrl(e) {
    return this.track(new Lh(), e);
  }
  /**
   * Settings Integrations Webhooks View Edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Edit)
   *
   * When the user clicks on the button to edit a webhook from the webhook view
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewEdit(e) {
    return this.track(new Nh(), e);
  }
  /**
   * Settings Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Menu%20Item%20Clicked)
   *
   * When the user clicks the settings menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  settingsMenuItemClicked(e, t) {
    return this.track(new Wh(e), t);
  }
  /**
   * Settings Organization Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Organization%20Form%20Submitted)
   *
   * When the user submits the form on organization settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsOrganizationFormSubmitted(e) {
    return this.track(new Vh(), e);
  }
  /**
   * Settings Organization Logo Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Organization%20Logo%20Changed)
   *
   * When the user changes organization logo
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsOrganizationLogoChanged(e) {
    return this.track(new xh(), e);
  }
  /**
   * Settings Profile Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Profile%20Form%20Submitted)
   *
   * When the user submits the form on profile settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. payload)
   * @param options Amplitude event options.
   */
  settingsProfileFormSubmitted(e, t) {
    return this.track(new Qh(e), t);
  }
  /**
   * Settings Queue Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Added)
   *
   * When the user added a queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isDefault)
   * @param options Amplitude event options.
   */
  settingsQueueAdded(e, t) {
    return this.track(new Kh(e), t);
  }
  /**
   * Settings Queue Agent Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Deleted)
   *
   * When the user performed a search.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueAgentDeleted(e) {
    return this.track(new qh(), e);
  }
  /**
   * Settings Queue Agent Search Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Search%20Submitted)
   *
   * When an agent was deleted.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueAgentSearchSubmitted(e) {
    return this.track(new zh(), e);
  }
  /**
   * Settings Queue Agent Sorted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Sorted)
   *
   * When sorting was applied.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  settingsQueueAgentSorted(e, t) {
    return this.track(new Gh(e), t);
  }
  /**
   * Settings Queue Alerts Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Alerts%20Saved)
   *
   * When the queue settings alerts form was saved.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. availableAgentsEnabled)
   * @param options Amplitude event options.
   */
  settingsQueueAlertsSaved(e, t) {
    return this.track(new jh(e), t);
  }
  /**
   * Settings Queue Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Saved)
   *
   * When the user saved a queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isDefault)
   * @param options Amplitude event options.
   */
  settingsQueueSaved(e, t) {
    return this.track(new Jh(e), t);
  }
  /**
   * Settings Queue Teams Add Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Add%20Team%20Button%20Clicked)
   *
   * When the Add team button was clicked.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsAddTeamButtonClicked(e) {
    return this.track(new $h(), e);
  }
  /**
   * Settings Queue Teams Add Team Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Add%20Team%20Form%20Submitted)
   *
   * When the Add team form was submitted.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsAddTeamFormSubmitted(e) {
    return this.track(new Yh(), e);
  }
  /**
   * Settings Queue Teams Delete Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Delete%20Team%20Button%20Clicked)
   *
   * When the Delete team button was clicked.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsDeleteTeamButtonClicked(e) {
    return this.track(new Zh(), e);
  }
  /**
   * Settings Queues Add Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Add%20Queue%20Clicked)
   *
   * When the user clicks the Add Queue button in the queue settings
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueuesAddQueueClicked(e) {
    return this.track(new Xh(), e);
  }
  /**
   * Settings Queues Archive Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Archive%20Queue%20Clicked)
   *
   * When the users clicks the archive queue button in the queue settings
   *
   * @param properties The event's properties (e.g. openConversationsCount)
   * @param options Amplitude event options.
   */
  settingsQueuesArchiveQueueClicked(e, t) {
    return this.track(new ev(e), t);
  }
  /**
   * Settings Queues Edit Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Edit%20Queue%20Clicked)
   *
   * When the user clicks the edit button in the queue settings
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueuesEditQueueClicked(e) {
    return this.track(new tv(), e);
  }
  /**
   * Settings Queues Unarchive Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Unarchive%20Queue%20Clicked)
   *
   * When the users clicks the unarchive queue button in the queue settings
   *
   * @param options Amplitude event options.
   */
  settingsQueuesUnarchiveQueueClicked(e) {
    return this.track(new nv(), e);
  }
  /**
   * Settings Roles Custom Role Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Created)
   *
   * When a user creates a custom role
   *
   * @param properties The event's properties (e.g. hasDescription)
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleCreated(e, t) {
    return this.track(new rv(e), t);
  }
  /**
   * Settings Roles Custom Role Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Deleted)
   *
   * When a user deletes a custom role
   *
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleDeleted(e) {
    return this.track(new iv(), e);
  }
  /**
   * Settings Roles Custom Role Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Edited)
   *
   * When a user edits a custom role
   *
   * @param properties The event's properties (e.g. hasDescription)
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleEdited(e, t) {
    return this.track(new sv(e), t);
  }
  /**
   * Settings Roles User Unassigned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20User%20Unassigned)
   *
   * When a user unassigns a single user from a role
   *
   * @param properties The event's properties (e.g. roleType)
   * @param options Amplitude event options.
   */
  settingsRolesUserUnassigned(e, t) {
    return this.track(new ov(e), t);
  }
  /**
   * Settings Roles Users Assigned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Users%20Assigned)
   *
   * When a user assigns users to a role
   *
   * @param properties The event's properties (e.g. numberOfUsers)
   * @param options Amplitude event options.
   */
  settingsRolesUsersAssigned(e, t) {
    return this.track(new av(e), t);
  }
  /**
   * Settings Summarization Save Changes Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Save%20Changes%20Clicked)
   *
   * The Settings Summarization Save Changes Clicked" is triggered when user have saved changes to their summarization settings. In this instance
   *
   * @param options Amplitude event options.
   */
  settingsSummarizationSaveChangesClicked(e) {
    return this.track(new cv(), e);
  }
  /**
   * Settings Summarization Show Automatically Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Show%20Automatically%20Clicked)
   *
   * The Settings summarization show automatically clicked" is triggered when user chooses to show automatic summaries for said channel"
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSummarizationShowAutomaticallyClicked(e, t) {
    return this.track(new uv(e), t);
  }
  /**
   * Settings Summarization Show On Demand Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Show%20On%20Demand%20Clicked)
   *
   * The Settings summarization show on demand clicked" is triggered when user chooses to show summaries on demand for said channel"
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSummarizationShowOnDemandClicked(e, t) {
    return this.track(new dv(e), t);
  }
  /**
   * Settings Tags Add Tag Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Add%20Tag%20Button%20Clicked)
   *
   * When the user clicks on Add Tag button on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTagsAddTagButtonClicked(e) {
    return this.track(new lv(), e);
  }
  /**
   * Settings Tags Tag Activated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Tag%20Activated)
   *
   * When the user activates a tag on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tagName)
   * @param options Amplitude event options.
   */
  settingsTagsTagActivated(e, t) {
    return this.track(new pv(e), t);
  }
  /**
   * Settings Tags Tag Deactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Tag%20Deactivated)
   *
   * When the user deactivates a tag on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tagName)
   * @param options Amplitude event options.
   */
  settingsTagsTagDeactivated(e, t) {
    return this.track(new hv(e), t);
  }
  /**
   * Settings Team Add Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Add%20Team%20Button%20Clicked)
   *
   * When the user clicks on Add team" button on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamAddTeamButtonClicked(e) {
    return this.track(new vv(), e);
  }
  /**
   * Settings Team Details Add Agents Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Details%20Add%20Agents%20Button%20Clicked)
   *
   * When the user clicks on Add agents" button on team details settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamDetailsAddAgentsButtonClicked(e) {
    return this.track(new gv(), e);
  }
  /**
   * Settings Team Edit Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Edit%20Team%20Button%20Clicked)
   *
   * When the user clicks on Edit" icon in the table on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamEditTeamButtonClicked(e) {
    return this.track(new Cv(), e);
  }
  /**
   * Settings Team Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on team modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. teamName)
   * @param options Amplitude event options.
   */
  settingsTeamModalFormSubmitted(e, t) {
    return this.track(new fv(e), t);
  }
  /**
   * Settings Team Remove Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Remove%20Team%20Button%20Clicked)
   *
   * When the user clicks on Remove" icon in the table on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamRemoveTeamButtonClicked(e) {
    return this.track(new kv(), e);
  }
  /**
   * Settings Team Remove Team Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Remove%20Team%20Confirmed)
   *
   * When the user presses confirm button on delete team modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamRemoveTeamConfirmed(e) {
    return this.track(new yv(), e);
  }
  /**
   * Settings Templates Add Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Add%20Template%20Button%20Clicked)
   *
   * When the user clicks on the add button in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateType)
   * @param options Amplitude event options.
   */
  settingsTemplatesAddTemplateButtonClicked(e, t) {
    return this.track(new mv(e), t);
  }
  /**
   * Settings Templates Edit Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Edit%20Template%20Button%20Clicked)
   *
   * When the user clicks on the edit icon in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesEditTemplateButtonClicked(e, t) {
    return this.track(new _v(e), t);
  }
  /**
   * Settings Templates Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on template modal on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  settingsTemplatesModalFormSubmitted(e, t) {
    return this.track(new wv(e), t);
  }
  /**
   * Settings Templates Remove Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Remove%20Template%20Button%20Clicked)
   *
   * When the user clicks on the delete icon in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesRemoveTemplateButtonClicked(e, t) {
    return this.track(new Sv(e), t);
  }
  /**
   * Settings Templates Remove Template Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Remove%20Template%20Confirmed)
   *
   * When the user clicks on confirm button on remove template confirm modal on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesRemoveTemplateConfirmed(e, t) {
    return this.track(new bv(e), t);
  }
  /**
   * Settings Templates Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Tab%20Clicked)
   *
   * When the user switches between tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsTemplatesTabClicked(e, t) {
    return this.track(new Iv(e), t);
  }
  /**
   * Shared Worker Tab Or Window Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Changed)
   *
   * When the user opens and closes a tab or window if there are any instances left and when the focus changes between different instances
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowChanged(e) {
    return this.track(new Av(), e);
  }
  /**
   * Shared Worker Tab Or Window Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Closed)
   *
   * When the user closes the agent interface. Including every tab and window.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfInstances)
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowClosed(e, t) {
    return this.track(new Ov(e), t);
  }
  /**
   * Shared Worker Tab Or Window Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Opened)
   *
   * When the user opens the agent interface. Including every tab and window.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfInstances)
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowOpened(e, t) {
    return this.track(new Tv(e), t);
  }
  /**
   * Sidebar Add Agent Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Add%20Agent%20Button%20Clicked)
   *
   * When the user clicks on add agent icon on sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarAddAgentButtonClicked(e) {
    return this.track(new Pv(), e);
  }
  /**
   * Sidebar Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Collapsed)
   *
   * When the sidebar is collapsed
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarCollapsed(e) {
    return this.track(new Ev(), e);
  }
  /**
   * Sidebar Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Expanded)
   *
   * When the sidebar is expanded
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarExpanded(e) {
    return this.track(new Fv(), e);
  }
  /**
   * Sidebar Nav Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Nav%20Clicked)
   *
   * When the user clicks on a navigation link in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. item)
   * @param options Amplitude event options.
   */
  sidebarNavClicked(e, t) {
    return this.track(new Mv(e), t);
  }
  /**
   * Sign Out Aborted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sign%20Out%20Aborted)
   *
   * When the user aborts signing out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  signOutAborted(e) {
    return this.track(new Rv(), e);
  }
  /**
   * Sign Out Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sign%20Out%20Confirmed)
   *
   * When the user confirms signing out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  signOutConfirmed(e) {
    return this.track(new Dv(), e);
  }
  /**
   * Simultaneous Ring Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Simultaneous%20Ring%20Updated)
   *
   * When the user updates their simultaneous ring status
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  simultaneousRingUpdated(e, t) {
    return this.track(new Uv(e), t);
  }
  /**
   * Smart Conversation Reply Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Smart%20Conversation%20Reply%20Button%20Clicked)
   *
   * When the user clicks the Smart Conversation Reply" button from the Elevio or Dixa knowledge sidebar card"
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  smartConversationReplyButtonClicked(e, t) {
    return this.track(new Hv(e), t);
  }
  /**
   * Tag Select Create New Tag Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tag%20Select%20Create%20New%20Tag%20Clicked)
   *
   * When the user clicks on the inline tag creation item on the list to create a tag with the searched value
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. component)
   * @param options Amplitude event options.
   */
  tagSelectCreateNewTagClicked(e, t) {
    return this.track(new Bv(e), t);
  }
  /**
   * Tags Create Modal Color Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Color%20Changed)
   *
   * When the user changes the tag color on Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. color)
   * @param options Amplitude event options.
   */
  tagsCreateModalColorChanged(e, t) {
    return this.track(new Lv(e), t);
  }
  /**
   * Tags Create Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. path)
   * @param options Amplitude event options.
   */
  tagsCreateModalFormSubmitted(e, t) {
    return this.track(new Nv(e), t);
  }
  /**
   * Tags Create Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Opened)
   *
   * When the user opens the Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. path)
   * @param options Amplitude event options.
   */
  tagsCreateModalOpened(e, t) {
    return this.track(new Wv(e), t);
  }
  /**
   * Team Agent Actions Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Actions%20Menu%20Item%20Clicked)
   *
   * When the user clicks the agent actions menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  teamAgentActionsMenuItemClicked(e, t) {
    return this.track(new Vv(e), t);
  }
  /**
   * Team Agent Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Actions%20Menu%20Opened)
   *
   * When the user opens the agent actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamAgentActionsMenuOpened(e) {
    return this.track(new xv(), e);
  }
  /**
   * Team Agent Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Collapsed)
   *
   * When the user collapsed the agent item
   *
   * @param options Amplitude event options.
   */
  teamAgentCollapsed(e) {
    return this.track(new Qv(), e);
  }
  /**
   * Team Agent Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Expanded)
   *
   * When the user expands the agent item
   *
   * @param options Amplitude event options.
   */
  teamAgentExpanded(e) {
    return this.track(new Kv(), e);
  }
  /**
   * Team Assigned Agents Only Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Assigned%20Agents%20Only%20Clicked)
   *
   * When the user clicks the Assigned Agents Only button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamAssignedAgentsOnlyClicked(e) {
    return this.track(new qv(), e);
  }
  /**
   * Team Conversation Actions Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Actions%20Menu%20Item%20Clicked)
   *
   * When the user clicks the conversation actions menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  teamConversationActionsMenuItemClicked(e, t) {
    return this.track(new zv(e), t);
  }
  /**
   * Team Conversation Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Actions%20Menu%20Opened)
   *
   * When the user opens the conversation actions menu
   *
   * @param options Amplitude event options.
   */
  teamConversationActionsMenuOpened(e) {
    return this.track(new Gv(), e);
  }
  /**
   * Team Conversation Status Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Status%20Link%20Clicked)
   *
   * When the user clicks the status link in the conversation
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamConversationStatusLinkClicked(e) {
    return this.track(new jv(), e);
  }
  /**
   * Team Conversation Title Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Title%20Link%20Clicked)
   *
   * When the user clicks the title link in the conversation
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamConversationTitleLinkClicked(e) {
    return this.track(new Jv(), e);
  }
  /**
   * Team Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Favorite%20Toggled)
   *
   * When the user toggles the favorite agent
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  teamFavoriteToggled(e, t) {
    return this.track(new $v(e), t);
  }
  /**
   * Team Filter Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Filter%20Menu%20Item%20Clicked)
   *
   * When the user clicks the filter menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  teamFilterMenuItemClicked(e, t) {
    return this.track(new Yv(e), t);
  }
  /**
   * Team Filter Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Filter%20Menu%20Opened)
   *
   * When the user opens the filter agents menu
   *
   * @param options Amplitude event options.
   */
  teamFilterMenuOpened(e) {
    return this.track(new Zv(), e);
  }
  /**
   * Team Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Next%20Page%20Clicked)
   *
   * When the user clicks the next page on the Team page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamNextPageClicked(e) {
    return this.track(new Xv(), e);
  }
  /**
   * Team Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Previous%20Page%20Clicked)
   *
   * When the user clicks the previous page on the Team page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamPreviousPageClicked(e) {
    return this.track(new eg(), e);
  }
  /**
   * Topbar Beamer Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Beamer%20Opened)
   *
   * When Beamer is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarBeamerOpened(e) {
    return this.track(new tg(), e);
  }
  /**
   * Topbar Email Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Email%20Opened)
   *
   * When the email dropdown in the topbar is opened
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarEmailOpened(e) {
    return this.track(new ng(), e);
  }
  /**
   * Topbar Notifications Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Notifications%20Opened)
   *
   * When the notifications dropdown is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarNotificationsOpened(e) {
    return this.track(new rg(), e);
  }
  /**
   * Topbar Phones Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Phones%20Opened)
   *
   * When the phones dropdown in the topbar is opened
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarPhonesOpened(e) {
    return this.track(new ig(), e);
  }
  /**
   * Topbar Support Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Support%20Opened)
   *
   * When the support menu is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarSupportOpened(e) {
    return this.track(new sg(), e);
  }
  /**
   * User Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/User%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on user modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. company)
   * @param options Amplitude event options.
   */
  userModalFormSubmitted(e, t) {
    return this.track(new og(e), t);
  }
  /**
   * Websocket Active Connection Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Active%20Connection%20Changed)
   *
   * When the active websocket connection changes
   *
   * @param properties The event's properties (e.g. newConnectionId)
   * @param options Amplitude event options.
   */
  websocketActiveConnectionChanged(e, t) {
    return this.track(new ag(e), t);
  }
  /**
   * Websocket Close Event Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Close%20Event%20Received)
   *
   * When the websocket receives a close event
   *
   * @param properties The event's properties (e.g. code)
   * @param options Amplitude event options.
   */
  websocketCloseEventReceived(e, t) {
    return this.track(new cg(e), t);
  }
  /**
   * Websocket Connection Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Connection%20Closed)
   *
   * When the websocket connection is created
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  websocketConnectionClosed(e, t) {
    return this.track(new ug(e), t);
  }
  /**
   * Websocket Connection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Connection%20Created)
   *
   * When the websocket connection is closed
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  websocketConnectionCreated(e, t) {
    return this.track(new dg(e), t);
  }
  /**
   * Websocket Reconnect Attempt Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Reconnect%20Attempt%20Started)
   *
   * When the websocket reconnect attempt starts
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  websocketReconnectAttemptStarted(e, t) {
    return this.track(new lg(e), t);
  }
}
const nt = new pg();
function gg(n, e, t) {
  if (!nt.isLoaded)
    return { promise: Promise.resolve() };
  const i = new te();
  if (t)
    for (const [s, o] of Object.entries(t))
      o != null && i.set(s, o);
  return nt.client.groupIdentify(n, e, i);
}
export {
  sr as AddAgentsModalFormSubmitted,
  or as AgentCopilotBackButtonClicked,
  ar as AgentCopilotDropdownItemClicked,
  cr as AgentCopilotImproveWritingImprovementClicked,
  ur as AgentCopilotTextInsertBelowClicked,
  dr as AgentCopilotTextReplaceClicked,
  lr as AgentCopilotTranslateMessageLanguageSelected,
  pr as AgentCopilotUndoClicked,
  pg as Ampli,
  hr as AnalyticsBusinessHoursScheduleRemoved,
  vr as AnalyticsBusinessHoursScheduleUpdated,
  gr as AnalyticsChartGranularityChanged,
  Cr as AnalyticsChartVisualizationChanged,
  fr as AnalyticsCompareClicked,
  kr as AnalyticsCompareContextUpdated,
  yr as AnalyticsComparePeriodUpdated,
  mr as AnalyticsContextUpdated,
  _r as AnalyticsConversationLinkClicked,
  wr as AnalyticsConversationPreviewClicked,
  Sr as AnalyticsDashboardViewed,
  br as AnalyticsExportClicked,
  Ir as AnalyticsExportDownloadClicked,
  Ar as AnalyticsExportMyDataButtonPressed,
  Or as AnalyticsFilterCleared,
  Tr as AnalyticsFilterOpened,
  Pr as AnalyticsFilterOperatorUpdated,
  Er as AnalyticsFilterValueAdded,
  Fr as AnalyticsFiltersApplied,
  Mr as AnalyticsFiltersCleared,
  Rr as AnalyticsHelperClicked,
  Dr as AnalyticsInDepthClicked,
  Ur as AnalyticsInsightsClicked,
  Hr as AnalyticsInsightsCopyClicked,
  Br as AnalyticsInsightsFeedbackClicked,
  Lr as AnalyticsInsightsPromptClicked,
  Nr as AnalyticsInsightsRegenerateClicked,
  Wr as AnalyticsPeriodUpdated,
  Vr as AnalyticsQuickViewCreated,
  xr as AnalyticsQuickViewDeleted,
  Qr as AnalyticsQuickViewDuplicated,
  Kr as AnalyticsQuickViewFavoriteToggled,
  qr as AnalyticsQuickViewSharingToggled,
  zr as AnalyticsQuickViewUpdated,
  Gr as AnalyticsQuickViewViewed,
  jr as AnalyticsRefreshClicked,
  Jr as AnalyticsTableLoadAllClicked,
  $r as AnalyticsTableSortUpdated,
  Yr as AnalyticsTimezoneUpdated,
  Zr as AnalyticsViewConversationsClicked,
  rr as ApiKey,
  Xr as AuthFailedInit,
  ei as AutomationsFlowOptionsMenuOptionAuditLogClicked,
  ti as AutomationsFormCancelled,
  ni as AutomationsFormOpened,
  ri as AutomationsFormSubmitted,
  ii as AutomationsOptionsMenuOpened,
  si as AutomationsOptionsMenuOptionDeleteClicked,
  oi as AutomationsOptionsMenuOptionDuplicateClicked,
  ai as AutomationsOptionsMenuOptionFlowClicked,
  ci as AutomationsOptionsMenuOptionSettingsClicked,
  ui as AutomationsPaginationNextClicked,
  di as AutomationsPaginationPreviousClicked,
  li as AutomationsSearchApplied,
  pi as AutomationsSearchClosed,
  hi as AutomationsSearchOpened,
  vi as AutomationsToggledOff,
  gi as AutomationsToggledOn,
  Ci as BansBanUserClicked,
  fi as BansUnbanIpClicked,
  ki as BansUnbanUserClicked,
  yi as BulkActionsUpdateClicked,
  mi as BusinessHoursAddScheduleAudioMessageAdded,
  _i as BusinessHoursAddScheduleButtonClicked,
  wi as BusinessHoursAddScheduleFormCancelled,
  Si as BusinessHoursAddScheduleFormSubmitted,
  bi as BusinessHoursConflictNotificationButtonClicked,
  Ii as BusinessHoursConflictNotificationClosed,
  Ai as BusinessHoursDeleteScheduleFormCancelled,
  Oi as BusinessHoursDeleteScheduleFormSubmitted,
  Ti as BusinessHoursDuplicateScheduleFormCancelled,
  Pi as BusinessHoursDuplicateScheduleFormSubmitted,
  Ei as BusinessHoursFirstScheduleModalQuestionClicked,
  Fi as BusinessHoursFirstScheduleSupportArticleClicked,
  Mi as BusinessHoursGoToFlowClicked,
  Ri as BusinessHoursMigrationWizardAudioMessageAdded,
  Di as BusinessHoursMigrationWizardCreateNewScheduleButtonClicked,
  Ui as BusinessHoursMigrationWizardEditHoursButtonClicked,
  Hi as BusinessHoursMigrationWizardFormCancelled,
  Bi as BusinessHoursMigrationWizardFormSubmitted,
  Li as BusinessHoursMigrationWizardOpeningHoursFormCancelled,
  Ni as BusinessHoursMigrationWizardOpeningHoursFormSubmitted,
  Wi as BusinessHoursMigrationWizardStartUpdateButtonClicked,
  Vi as BusinessHoursOptionsMenuOpened,
  xi as BusinessHoursOptionsMenuOptionDeleteClicked,
  Qi as BusinessHoursOptionsMenuOptionDuplicateClicked,
  Ki as BusinessHoursOptionsMenuOptionEditClicked,
  qi as BusinessHoursOptionsMenuOptionRenameClicked,
  zi as BusinessHoursRenameScheduleFormCancelled,
  Gi as BusinessHoursRenameScheduleFormSubmitted,
  ji as BusinessHoursScheduleAddExceptionButtonClicked,
  Ji as BusinessHoursScheduleAddExceptionFormCancelled,
  $i as BusinessHoursScheduleAddExceptionFormSubmitted,
  Yi as BusinessHoursScheduleAudioMessageFormCancelled,
  Zi as BusinessHoursScheduleAudioMessageFormSubmitted,
  Xi as BusinessHoursScheduleAudioMessageOptionsMenuOpened,
  es as BusinessHoursScheduleAudioMessageOptionsMenuOptionClearClicked,
  ts as BusinessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked,
  ns as BusinessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked,
  rs as BusinessHoursScheduleAutoReplyFormCancelled,
  is as BusinessHoursScheduleAutoReplyFormSubmitted,
  ss as BusinessHoursScheduleAutoReplyOptionsMenuOpened,
  os as BusinessHoursScheduleAutoReplyOptionsMenuOptionAddClicked,
  as as BusinessHoursScheduleAutoReplyOptionsMenuOptionClearClicked,
  cs as BusinessHoursScheduleConflictChangeButtonClicked,
  us as BusinessHoursScheduleConflictReviewButtonClicked,
  ds as BusinessHoursScheduleDeleteExceptionFormCancelled,
  ls as BusinessHoursScheduleDeleteExceptionFormSubmitted,
  ps as BusinessHoursScheduleExceptionOptionsMenuOptionDeleteClicked,
  hs as BusinessHoursScheduleImportHolidayFormCancelled,
  vs as BusinessHoursScheduleImportHolidayFormSubmitted,
  gs as BusinessHoursScheduleOptionsMenuImportHolidaysClicked,
  Cs as BusinessHoursScheduleOptionsMenuOpened,
  fs as BusinessHoursScheduleOptionsMenuRecoverHolidaysClicked,
  ks as BusinessHoursScheduleOptionsMenuRenameClicked,
  ys as BusinessHoursScheduleOptionsMenuTimezoneClicked,
  ms as BusinessHoursSchedulePreviewButtonClicked,
  _s as BusinessHoursScheduleRecoverHolidaysFormCancelled,
  ws as BusinessHoursScheduleRecoverHolidaysFormSubmitted,
  Ss as BusinessHoursScheduleReviewFormCancelled,
  bs as BusinessHoursScheduleReviewFormSubmitted,
  Is as BusinessHoursScheduleSaveScheduleButtonClicked,
  As as BusinessHoursScheduleTabClicked,
  Os as BusinessHoursScheduleViewClicked,
  Ts as ChatFlowOptionsMenuOptionAuditLogClicked,
  Ps as ChatFormCanceled,
  Es as ChatFormOpened,
  Fs as ChatFormSubmitted,
  Ms as ChatOptionsMenuOpened,
  Rs as ChatOptionsMenuOptionDeleteClicked,
  Ds as ChatOptionsMenuOptionDuplicateClicked,
  Us as ChatOptionsMenuOptionFlowClicked,
  Hs as ChatOptionsMenuOptionRenameClicked,
  Bs as ChatOptionsMenuOptionSetupClicked,
  Ls as ChatPaginationNextClicked,
  Ns as ChatPaginationPreviousClicked,
  Ws as ChatSearchApplied,
  Vs as ChatSearchClosed,
  xs as ChatSearchOpened,
  Qs as ChatbotCreateModalOpened,
  Ks as ChatbotCreated,
  qs as ChatbotDeleteModalOpened,
  zs as ChatbotDeleted,
  Gs as ChatbotEditIdentityModalOpened,
  js as ChatbotIdentityEdited,
  Js as CommandExecuted,
  $s as CompanyModalFormSubmitted,
  Ys as ContactsAddNewCompanyClicked,
  Zs as ContactsAddNewContactClicked,
  Xs as ContactsBanUserClicked,
  eo as ContactsCardActionsMenuOpened,
  to as ContactsCardComposeNewEmailClicked,
  no as ContactsCardEditCompanyClicked,
  ro as ContactsCardEditContactClicked,
  io as ContactsCardMakeCallClicked,
  so as ContactsCardSeeAllAssignedConversationsClicked,
  oo as ContactsCardSeeAllConversationsClicked,
  ao as ContactsCardViewCompanyClicked,
  co as ContactsCardViewUserClicked,
  uo as ContactsSearchBlurred,
  lo as ContactsSearchFocused,
  po as ContactsUnbanUserClicked,
  ho as ContactsViewCompanies,
  vo as ContactsViewEndUsers,
  go as ConversationActionsMenuOpened,
  Co as ConversationActionsMenuOptionClicked,
  fo as ConversationActivityLogClosed,
  ko as ConversationActivityLogFlooterExpanded,
  yo as ConversationActivityLogOpened,
  mo as ConversationAttachedImageIsDownloaded,
  _o as ConversationAttachedImageIsViewed,
  wo as ConversationClaimed,
  So as ConversationClosed,
  bo as ConversationCsatCancelled,
  Io as ConversationCsatMenuCancelOptionClicked,
  Ao as ConversationCsatMenuLanguageSelected,
  Oo as ConversationCsatMenuOpened,
  To as ConversationFollowUp,
  Po as ConversationFollowUpMenuOpened,
  Eo as ConversationFollowUpMenuOptionClicked,
  Fo as ConversationHeaderConversationDetailsMenuOpened,
  Mo as ConversationHeaderMoreMenuOpened,
  Ro as ConversationHeaderTagAdded,
  Do as ConversationHeaderTagIncludeDeactivatedToggled,
  Uo as ConversationHeaderTagMenuOpened,
  Ho as ConversationHeaderTagRemoved,
  Bo as ConversationHeaderTransferToAgentItemSelected,
  Lo as ConversationHeaderTransferToAgentMenuOpened,
  No as ConversationHeaderTransferToNumberButtonClicked,
  Wo as ConversationHeaderTransferToQueueItemSelected,
  Vo as ConversationHeaderTransferToQueueMenuOpened,
  xo as ConversationInternalNoteEditorOpened,
  Qo as ConversationOffered,
  Ko as ConversationReplied,
  qo as ConversationResolvedAsAKnowledgeArticleDraft,
  zo as ConversationResolvedAsAKnowledgeGap,
  Go as ConversationResolvedByKnowledge,
  jo as ConversationResolvedWithNoKnowledgeArticle,
  Jo as ConversationSidebarClosed,
  $o as ConversationSidebarConversationHistoryClosed,
  Yo as ConversationSidebarConversationHistoryNavigatedToConversation,
  Zo as ConversationSidebarConversationHistoryOpened,
  Xo as ConversationSidebarCustomerInfoEmailClicked,
  ea as ConversationSidebarCustomerInfoPhoneNumberClicked,
  ta as ConversationSidebarOpened,
  wa as ConversationSummaryFeedbackNotUseful,
  Sa as ConversationSummaryFeedbackUseful,
  ba as ConversationSummaryRegenerateSummary,
  na as ConversationTimelineItemOpened,
  ra as ConversationTimelineNavigatedToConversation,
  ia as ConversationTransferred,
  sa as ConversationsBulkActionsClicked,
  oa as ConversationsClearAllClicked,
  aa as ConversationsFilterAgentClicked,
  ca as ConversationsFilterClearAllClicked,
  ua as ConversationsFilterCleared,
  da as ConversationsFilterContactClicked,
  la as ConversationsFilterToggled,
  pa as ConversationsGoToConversationClicked,
  ha as ConversationsItemPreviewClicked,
  va as ConversationsNextPageClicked,
  ga as ConversationsPreviousPageClicked,
  Ca as ConversationsSelectAllClicked,
  fa as ConversationsSelectClicked,
  ka as ConversationsTimestampClicked,
  ya as ConversationsTransferToQueueClicked,
  ma as ConversationsViewAgentClicked,
  _a as ConversationsViewContactClicked,
  Ia as CopyScript,
  Aa as CountryCodeSelected,
  Oa as CustomAttributeValueUpdated,
  Ta as DashboardBackToOldClicked,
  Pa as DashboardGlobalTvDashboardClicked,
  Ea as DashboardLayoutChanged,
  Fa as DashboardLongestQueuedTimeMetricClicked,
  Ma as DashboardMetricHelperClicked,
  Ra as DashboardNextPageClicked,
  Da as DashboardOrganizationTimezoneSettingsClicked,
  Ua as DashboardPreviousPageClicked,
  Ha as DashboardQueueAllConversationsClicked,
  Ba as DashboardQueueGoToAnalyticsClicked,
  La as DashboardQueueItemClicked,
  Na as DashboardQueueItemFavoriteToggled,
  Wa as DashboardQueueNameClicked,
  Va as DashboardQueuePendingConversationsMetricClicked,
  xa as DashboardQueueSettingsClicked,
  Qa as DashboardQueueTvDashboardClicked,
  Ka as DashboardQueuesManuallySelected,
  qa as DashboardQueuesSearchFieldCleared,
  za as DashboardQueuesSearchFieldSubmitted,
  Ga as DashboardQueuesSortingUpdated,
  ja as DashboardQueuesTypeChanged,
  Ja as DashboardRefreshDataClicked,
  $a as DashboardSwitchToNewClicked,
  Ya as DashboardTvReloaded,
  Za as DashboardViewed,
  ir as DefaultConfiguration,
  Xa as EditorQuickResponseAdded,
  ec as EmailFlowOptionsMenuOptionAuditLogClicked,
  tc as EmailFormSubmitted,
  nc as EmailOptionsMenuOpened,
  rc as EmailOptionsMenuOptionDeleteClicked,
  ic as EmailOptionsMenuOptionDuplicateClicked,
  sc as EmailOptionsMenuOptionEmailClicked,
  oc as EmailOptionsMenuOptionFlowClicked,
  ac as EmailOptionsMenuOptionRenameClicked,
  cc as EmailSearchApplied,
  uc as EmailSearchClosed,
  dc as EmailSearchOpened,
  lc as FlowActionAddSaved,
  pc as FlowActionConditionAdded,
  hc as FlowActionConditionRemoved,
  vc as FlowActionDeleted,
  gc as FlowActionEditClicked,
  Cc as FlowActionEditSaved,
  fc as FlowActivateClicked,
  kc as FlowAddActionActionSelected,
  yc as FlowAddActionCancelled,
  mc as FlowAddActionOpened,
  _c as FlowBackToSettingsClicked,
  wc as FlowContextAlignClicked,
  Sc as FlowContextDeleteCancelClicked,
  bc as FlowContextDeleteClicked,
  Ic as FlowContextDeleteConfirmClicked,
  Ac as FlowContextNodeArrangeClicked,
  Oc as FlowPhoneNumberChanged,
  Tc as FlowSaveClicked,
  Pc as FlowTitleEditClicked,
  Ec as FlowZoomInClicked,
  Fc as FlowZoomOutClicked,
  Mc as FlowZoomResetClicked,
  Rc as FollowUpConversationModalInternalNoteAdded,
  Dc as FollowUpConversationModalOfferInQueueAdded,
  vg as Identify,
  Uc as KnowledgeArticleArchived,
  Hc as KnowledgeArticleChangesDiscarded,
  Bc as KnowledgeArticleCreated,
  Lc as KnowledgeArticleDestroyed,
  Nc as KnowledgeArticleFeedbackSubmitted,
  Wc as KnowledgeArticleMarkedAsHelpful,
  Vc as KnowledgeArticleMoved,
  xc as KnowledgeArticlePublished,
  Qc as KnowledgeArticleReordered,
  Kc as KnowledgeArticleTagAdded,
  qc as KnowledgeArticleTagRemoved,
  zc as KnowledgeArticleUnpublished,
  Gc as KnowledgeArticleUpdated,
  jc as KnowledgeArticleViewed,
  Jc as KnowledgeArticlesSearchByTermSubmitted,
  $c as KnowledgeCategoryCreated,
  Yc as KnowledgeCategoryDestroyed,
  Zc as KnowledgeCategoryReordered,
  Xc as KnowledgeCategoryUpdated,
  eu as KnowledgeCollectionCreated,
  tu as KnowledgeCollectionDestroyed,
  nu as KnowledgeCollectionUpdated,
  ru as KnowledgeCollectionViewed,
  iu as KnowledgeHelpCenterCreated,
  su as KnowledgeHelpCenterDeleted,
  ou as KnowledgeHelpCenterUpdated,
  au as KnowledgeInternalKbDashboardViewed,
  cu as KnowledgeInternalKbSearchResultClicked,
  uu as KnowledgeResolutionCancelled,
  du as KnowledgeResolutionInitialised,
  lu as MergeContactsMergeCancelled,
  pu as MergeContactsMergeFailed,
  hu as MergeContactsMergeSucceeded,
  vu as MergeContactsModalClosed,
  gu as MergeContactsModalOpened,
  Cu as MergeContactsSourceContactSelected,
  fu as MessengerFlowOptionsMenuOptionAuditLogClicked,
  ku as MessengerFormCancelled,
  yu as MessengerFormOpened,
  mu as MessengerFormSubmitted,
  _u as MessengerOptionsMenuOpened,
  wu as MessengerOptionsMenuOptionClicked,
  Su as ModalConversationCloseCancelClicked,
  bu as ModalConversationCloseConfirmClicked,
  Iu as ModalTransferToQueueCancelClicked,
  Au as ModalTransferToQueueConfirmClicked,
  Ou as NetworkConnectionStatusChanged,
  Tu as NotificationOfferAccepted,
  Pu as NotificationOfferClosed,
  Eu as NotificationOfferRejected,
  Fu as NotificationOfferTimeout,
  Mu as NotificationTransferOfferAccepted,
  Ru as NotificationTransferOfferClosed,
  Du as NotificationTransferOfferRejected,
  Uu as NotificationTransferOfferTimeout,
  Hu as OrganizationsNavigationOrganizationClicked,
  Bu as PartnerIntegrationsGithubCreateNewIssueCanceled,
  Lu as PartnerIntegrationsGithubCreateNewIssueClicked,
  Nu as PartnerIntegrationsGithubCreateNewIssueConfirmed,
  Wu as PartnerIntegrationsGithubLinkIssueClicked,
  Vu as PartnerIntegrationsGithubUnlinkAllIssuesCanceled,
  xu as PartnerIntegrationsGithubUnlinkAllIssuesClicked,
  Qu as PartnerIntegrationsGithubUnlinkAllIssuesConfirmed,
  Ku as PartnerIntegrationsGithubUnlinkIssueCanceled,
  qu as PartnerIntegrationsGithubUnlinkIssueClicked,
  zu as PartnerIntegrationsGithubUnlinkIssueConfirmed,
  Gu as PartnerIntegrationsGithubViewLinkClicked,
  ju as PartnerIntegrationsJiraCommentsCollapsed,
  Ju as PartnerIntegrationsJiraCommentsExpanded,
  $u as PartnerIntegrationsJiraLinkIssueClicked,
  Yu as PartnerIntegrationsJiraOpenIssueClicked,
  Zu as PartnerIntegrationsJiraOpenJiraClicked,
  Xu as PartnerIntegrationsJiraRemoveAllDanglingClicked,
  ed as PartnerIntegrationsJiraRemoveDanglingIssueClicked,
  td as PartnerIntegrationsJiraUnlinkAllIssuesCancelled,
  nd as PartnerIntegrationsJiraUnlinkAllIssuesClicked,
  rd as PartnerIntegrationsJiraUnlinkAllIssuesConfirmed,
  id as PartnerIntegrationsJiraUnlinkIssueCancelled,
  sd as PartnerIntegrationsJiraUnlinkIssueClicked,
  od as PartnerIntegrationsJiraUnlinkIssueConfirmed,
  ad as PartnerIntegrationsKlaviyoMessagesReceived,
  cd as PartnerIntegrationsKlaviyoProfileFailed,
  ud as PartnerIntegrationsKlaviyoProfileReceived,
  dd as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked,
  ld as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed,
  pd as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded,
  hd as PartnerIntegrationsKlaviyoProfileUnsubscribeClicked,
  vd as PartnerIntegrationsKlaviyoProfileUnsubscribeFailed,
  gd as PartnerIntegrationsKlaviyoProfileUnsubscribeSucceeded,
  Cd as PartnerIntegrationsLinearCreateNewIssueCancelled,
  fd as PartnerIntegrationsLinearCreateNewIssueClicked,
  kd as PartnerIntegrationsLinearCreateNewIssueConfirmed,
  yd as PartnerIntegrationsLinearLinkIssueClicked,
  md as PartnerIntegrationsLinearOpenIssueClicked,
  _d as PartnerIntegrationsLinearOpenLinearClicked,
  wd as PartnerIntegrationsLinearUnlinkIssueClicked,
  Sd as PartnerIntegrationsSettingsCreateSubmitted,
  bd as PartnerIntegrationsSettingsOverviewCreated,
  Id as PartnerIntegrationsSettingsOverviewViewed,
  Ad as PartnerIntegrationsSettingsViewDeleteCanceled,
  Od as PartnerIntegrationsSettingsViewDeleteConfirmed,
  Td as PartnerIntegrationsSettingsViewDeleteRequested,
  Pd as PartnerIntegrationsSettingsViewOAuthStarted,
  Ed as PartnerIntegrationsSettingsViewOAuthSucceeded,
  Fd as PartnerIntegrationsSettingsViewSubmitted,
  Md as PartnerIntegrationsShopifyWidgetOrderCollapseClosed,
  Rd as PartnerIntegrationsShopifyWidgetOrderCollapseOpened,
  Dd as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled,
  Ud as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened,
  Hd as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted,
  Bd as PartnerIntegrationsShopifyWidgetOrderRefundCanceled,
  Ld as PartnerIntegrationsShopifyWidgetOrderRefundConfirmed,
  Nd as PartnerIntegrationsShopifyWidgetOrderRefundRequested,
  Wd as PartnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked,
  Vd as PartnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked,
  xd as PartnerIntegrationsShopifyWidgetRefreshed,
  Qd as PartnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked,
  Kd as PartnerIntegrationsVoyadoWidgetChannelSubscriptionClicked,
  qd as PartnerIntegrationsVoyadoWidgetChannelSubscriptionFailed,
  zd as PartnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded,
  Gd as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked,
  jd as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed,
  Jd as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded,
  $d as PartnerIntegrationsVoyadoWidgetMessageExternalLinkOpened,
  Yd as PartnerIntegrationsVoyadoWidgetMessagesReceived,
  Zd as PartnerIntegrationsVoyadoWidgetProfileReceived,
  Xd as PartnerIntegrationsVoyadoWidgetTransactionsReceived,
  el as PartnerIntegrationsWidgetCollapseClosed,
  tl as PartnerIntegrationsWidgetCollapseOpened,
  nl as PartnerIntegrationsWidgetLoyaltyLionAddPointsFailed,
  rl as PartnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded,
  il as PartnerIntegrationsWidgetLoyaltyLionCustomerReceived,
  sl as PartnerIntegrationsWidgetLoyaltyLionRemovePointsFailed,
  ol as PartnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded,
  al as PhoneActionsMenuActionAddOutboundCallerIdClicked,
  cl as PhoneActionsMenuActionChangeHoldMusicClicked,
  ul as PhoneActionsMenuOpened,
  dl as PhoneAddOutboundCallerIdFormCancelled,
  ll as PhoneAddOutboundCallerIdFormSubmitted,
  pl as PhoneChangeHoldMusicFormCancelled,
  hl as PhoneChangeHoldMusicFormSubmitted,
  vl as PhoneCreateFlowFormCancelled,
  gl as PhoneCreateFlowFormSubmitted,
  Cl as PhoneFlowOptionsMenuOptionAuditLogClicked,
  fl as PhoneFlowOptionsMenuOptionDeleteClicked,
  kl as PhoneFlowOptionsMenuOptionDuplicateClicked,
  yl as PhoneFlowOptionsMenuOptionEditClicked,
  ml as PhoneFlowOptionsMenuOptionMoveToAnotherNumberClicked,
  _l as PhoneFlowOptionsMenuOptionOpened,
  wl as PhoneFlowOptionsMenuOptionRenameClicked,
  Sl as PhoneFormCancelled,
  bl as PhoneFormOpened,
  Il as PhoneFormSubmitted,
  Al as PhoneOptionsMenuOpened,
  Ol as PhoneOptionsMenuOptionCreateFlowClicked,
  Tl as PhoneOptionsMenuOptionEditClicked,
  Pl as PhoneOptionsMenuOptionRemoveNumberClicked,
  El as PhoneOptionsMenuOptionSetDefaultCallerIdClicked,
  Fl as PhoneOptionsMenuOptionSetupClicked,
  Ml as PhoneRecordingDownloaded,
  Rl as PhoneRecordingPauseClicked,
  Dl as PhoneRecordingPlayClicked,
  Ul as PhoneRecordingPlaybackAbandoned,
  Hl as PhoneRecordingPlaybackEnded,
  Bl as PhoneSearchApplied,
  Ll as PresenceMediaUpdated,
  Nl as PresenceUpdated,
  Wl as PushNotificationPlatformFormCancelled,
  Vl as PushNotificationPlatformFormOpened,
  xl as PushNotificationPlatformFormSubmitted,
  Ql as SavedSearchApplied,
  Kl as SavedSearchClosed,
  ql as SavedSearchCreated,
  zl as SavedSearchDeleted,
  Gl as SavedSearchUpdated,
  jl as ScheduledConversationsCsvImportClicked,
  Jl as ScheduledConversationsCsvImported,
  $l as SearchContactPreviewClosed,
  Yl as SearchContactPreviewGoToClicked,
  Zl as SearchContactPreviewOpened,
  Xl as SearchContactTypeChanged,
  ep as SearchConversationPreviewClosed,
  tp as SearchConversationPreviewGoToClicked,
  np as SearchConversationPreviewOpened,
  rp as SearchFieldBlurred,
  ip as SearchFieldCleared,
  sp as SearchFieldFocused,
  op as SearchFieldSubmitted,
  ap as SearchFilterConditionAdded,
  cp as SearchFilterConditionRemoved,
  up as SearchFilterOperatorUpdated,
  dp as SearchFilterStrategyUpdated,
  lp as SearchFilterValueAdded,
  pp as SearchFilterValueCleared,
  hp as SearchFiltersApplied,
  vp as SearchFiltersCleared,
  gp as SearchFiltersClosed,
  Cp as SearchFiltersOpened,
  fp as SearchFiltersValidationFailed,
  kp as SearchNotePreviewClosed,
  yp as SearchNotePreviewGoToClicked,
  mp as SearchNotePreviewOpened,
  _p as SearchSortingUpdated,
  wp as SearchStrictToggled,
  Sp as SearchTabOpened,
  bp as SettingsAgentsAddAgentButtonClicked,
  Ip as SettingsAgentsEditButtonClicked,
  Ap as SettingsAgentsTabClicked,
  Op as SettingsAgentsWorkloadsFormSubmitted,
  Tp as SettingsAudioDeleteCancelClicked,
  Pp as SettingsAudioDeleteClicked,
  Ep as SettingsAudioDeleteConfirmClicked,
  Fp as SettingsAudioUploadWaitMusic,
  Mp as SettingsAudioUsageFlowClicked,
  Rp as SettingsAudioUsageLinkClicked,
  Dp as SettingsCommandsAssignKeybindings,
  Up as SettingsCommandsResetAllKeybindings,
  Hp as SettingsCommandsResetKeybindings,
  Bp as SettingsCommandsUnassignAllKeybindings,
  Lp as SettingsCommandsUnassignKeybindings,
  Np as SettingsCustomAttributeActivated,
  Wp as SettingsCustomAttributeAddNewAttributeClicked,
  Vp as SettingsCustomAttributeArchived,
  xp as SettingsCustomAttributeCreated,
  Qp as SettingsCustomAttributeDeactivated,
  Kp as SettingsCustomAttributeReordered,
  qp as SettingsCustomAttributeUnarchived,
  zp as SettingsCustomAttributeUpdated,
  Gp as SettingsIntegrationsApiTokensAddConfirm,
  jp as SettingsIntegrationsApiTokensCopy,
  Jp as SettingsIntegrationsApiTokensDocumentationLinkIntegrationsApi,
  $p as SettingsIntegrationsApiTokensRemove,
  Yp as SettingsIntegrationsApiTokensRemoveCancel,
  Zp as SettingsIntegrationsApiTokensRemoveConfirm,
  Xp as SettingsIntegrationsApiTokensView,
  eh as SettingsIntegrationsCardEditSave,
  th as SettingsIntegrationsCardEditTest,
  nh as SettingsIntegrationsCardListingAddCard,
  rh as SettingsIntegrationsCardListingEditCard,
  ih as SettingsIntegrationsCardListingRemoveCard,
  sh as SettingsIntegrationsCardListingRemoveCardCancel,
  oh as SettingsIntegrationsCardListingRemoveCardConfirm,
  ah as SettingsIntegrationsCardListingTestCard,
  ch as SettingsIntegrationsCardReadDocumentation,
  uh as SettingsIntegrationsCardTest,
  dh as SettingsIntegrationsCardTestAddParameter,
  lh as SettingsIntegrationsCardTestRemoveParameter,
  ph as SettingsIntegrationsCustomCardCreated,
  hh as SettingsIntegrationsCustomCardEdited,
  vh as SettingsIntegrationsCustomCardOauthProviderAuthenticationFailed,
  gh as SettingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded,
  Ch as SettingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut,
  fh as SettingsIntegrationsCustomCardOauthProviderCreated,
  kh as SettingsIntegrationsCustomCardOauthProviderUpdated,
  yh as SettingsIntegrationsItemClicked,
  mh as SettingsIntegrationsWebformEndpointsAddSave,
  _h as SettingsIntegrationsWebformEndpointsCopy,
  wh as SettingsIntegrationsWebformEndpointsReadDocumentationLink,
  Sh as SettingsIntegrationsWebformEndpointsRemove,
  bh as SettingsIntegrationsWebformEndpointsRemoveCancel,
  Ih as SettingsIntegrationsWebformEndpointsRemoveConfirm,
  Ah as SettingsIntegrationsWebhooksAdd,
  Oh as SettingsIntegrationsWebhooksAddConfirm,
  Th as SettingsIntegrationsWebhooksDocumentationLinkClicked,
  Ph as SettingsIntegrationsWebhooksEdit,
  Eh as SettingsIntegrationsWebhooksEditSave,
  Fh as SettingsIntegrationsWebhooksEnabledOff,
  Mh as SettingsIntegrationsWebhooksEnabledOn,
  Rh as SettingsIntegrationsWebhooksRemove,
  Dh as SettingsIntegrationsWebhooksRemoveCancel,
  Uh as SettingsIntegrationsWebhooksRemoveConfirm,
  Hh as SettingsIntegrationsWebhooksView,
  Bh as SettingsIntegrationsWebhooksViewCopySecret,
  Lh as SettingsIntegrationsWebhooksViewCopyUrl,
  Nh as SettingsIntegrationsWebhooksViewEdit,
  Wh as SettingsMenuItemClicked,
  Vh as SettingsOrganizationFormSubmitted,
  xh as SettingsOrganizationLogoChanged,
  Qh as SettingsProfileFormSubmitted,
  Kh as SettingsQueueAdded,
  qh as SettingsQueueAgentDeleted,
  zh as SettingsQueueAgentSearchSubmitted,
  Gh as SettingsQueueAgentSorted,
  jh as SettingsQueueAlertsSaved,
  Jh as SettingsQueueSaved,
  $h as SettingsQueueTeamsAddTeamButtonClicked,
  Yh as SettingsQueueTeamsAddTeamFormSubmitted,
  Zh as SettingsQueueTeamsDeleteTeamButtonClicked,
  Xh as SettingsQueuesAddQueueClicked,
  ev as SettingsQueuesArchiveQueueClicked,
  tv as SettingsQueuesEditQueueClicked,
  nv as SettingsQueuesUnarchiveQueueClicked,
  rv as SettingsRolesCustomRoleCreated,
  iv as SettingsRolesCustomRoleDeleted,
  sv as SettingsRolesCustomRoleEdited,
  ov as SettingsRolesUserUnassigned,
  av as SettingsRolesUsersAssigned,
  cv as SettingsSummarizationSaveChangesClicked,
  uv as SettingsSummarizationShowAutomaticallyClicked,
  dv as SettingsSummarizationShowOnDemandClicked,
  lv as SettingsTagsAddTagButtonClicked,
  pv as SettingsTagsTagActivated,
  hv as SettingsTagsTagDeactivated,
  vv as SettingsTeamAddTeamButtonClicked,
  gv as SettingsTeamDetailsAddAgentsButtonClicked,
  Cv as SettingsTeamEditTeamButtonClicked,
  fv as SettingsTeamModalFormSubmitted,
  kv as SettingsTeamRemoveTeamButtonClicked,
  yv as SettingsTeamRemoveTeamConfirmed,
  mv as SettingsTemplatesAddTemplateButtonClicked,
  _v as SettingsTemplatesEditTemplateButtonClicked,
  wv as SettingsTemplatesModalFormSubmitted,
  Sv as SettingsTemplatesRemoveTemplateButtonClicked,
  bv as SettingsTemplatesRemoveTemplateConfirmed,
  Iv as SettingsTemplatesTabClicked,
  Av as SharedWorkerTabOrWindowChanged,
  Ov as SharedWorkerTabOrWindowClosed,
  Tv as SharedWorkerTabOrWindowOpened,
  Pv as SidebarAddAgentButtonClicked,
  Ev as SidebarCollapsed,
  Fv as SidebarExpanded,
  Mv as SidebarNavClicked,
  Rv as SignOutAborted,
  Dv as SignOutConfirmed,
  Uv as SimultaneousRingUpdated,
  Hv as SmartConversationReplyButtonClicked,
  Bv as TagSelectCreateNewTagClicked,
  Lv as TagsCreateModalColorChanged,
  Nv as TagsCreateModalFormSubmitted,
  Wv as TagsCreateModalOpened,
  Vv as TeamAgentActionsMenuItemClicked,
  xv as TeamAgentActionsMenuOpened,
  Qv as TeamAgentCollapsed,
  Kv as TeamAgentExpanded,
  qv as TeamAssignedAgentsOnlyClicked,
  zv as TeamConversationActionsMenuItemClicked,
  Gv as TeamConversationActionsMenuOpened,
  jv as TeamConversationStatusLinkClicked,
  Jv as TeamConversationTitleLinkClicked,
  $v as TeamFavoriteToggled,
  Yv as TeamFilterMenuItemClicked,
  Zv as TeamFilterMenuOpened,
  Xv as TeamNextPageClicked,
  eg as TeamPreviousPageClicked,
  tg as TopbarBeamerOpened,
  ng as TopbarEmailOpened,
  rg as TopbarNotificationsOpened,
  ig as TopbarPhonesOpened,
  sg as TopbarSupportOpened,
  og as UserModalFormSubmitted,
  ag as WebsocketActiveConnectionChanged,
  cg as WebsocketCloseEventReceived,
  ug as WebsocketConnectionClosed,
  dg as WebsocketConnectionCreated,
  lg as WebsocketReconnectAttemptStarted,
  nt as ampli,
  gg as groupIdentify
};
//# sourceMappingURL=index.js.map
